import React from 'react';
import socialNavIcons from './socialNavIcons';

const facebookIcons = {
  ...socialNavIcons,
  browse: {
    element: [
      <path
        d="M9,5v4H5V5H9 M10,3H4C3.448,3,3,3.448,3,4v6c0,0.552,0.448,1,1,1h6c0.552,0,1-0.448,1-1V4C11,3.448,10.552,3,10,3L10,3z
   M19,5v4h-4V5H19 M20,3h-6c-0.552,0-1,0.448-1,1v6c0,0.552,0.448,1,1,1h6c0.552,0,1-0.448,1-1V4C21,3.448,20.552,3,20,3L20,3z M9,15
  v4H5v-4H9 M10,13H4c-0.552,0-1,0.448-1,1v6c0,0.552,0.448,1,1,1h6c0.552,0,1-0.448,1-1v-6C11,13.448,10.552,13,10,13L10,13z M19,15
  v4h-4v-4H19 M20,13h-6c-0.552,0-1,0.448-1,1v6c0,0.552,0.448,1,1,1h6c0.552,0,1-0.448,1-1v-6C21,13.448,20.552,13,20,13L20,13z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  category: {
    element: [
      <path
        d="M19,5v14H5V5H19 M19,3H5C3.895,3,3,3.895,3,5v14c0,1.105,0.895,2,2,2h14c1.105,0,2-0.895,2-2V5C21,3.895,20.105,3,19,3L19,3
      z M17,7H7v2h10V7L17,7z M17,11H7v2h10V11L17,11z M17,15H7v2h10V15L17,15z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  discover: {
    element: [
      <path
        d="M12,2C6.48,2,2,6.48,2,12s4.48,10,10,10s10-4.48,10-10S17.52,2,12,2z M12,20c-4.41,0-8-3.59-8-8s3.59-8,8-8s8,3.59,8,8
  S16.41,20,12,20z M7.741,16.923l6.104-2.836c0.107-0.05,0.193-0.136,0.243-0.243l2.836-6.104c0.196-0.423-0.241-0.861-0.664-0.664
  l-6.104,2.836c-0.107,0.05-0.193,0.136-0.243,0.243l-2.836,6.104C6.88,16.682,7.318,17.12,7.741,16.923z M12,10.9
  c0.61,0,1.1,0.49,1.1,1.1s-0.49,1.1-1.1,1.1s-1.1-0.49-1.1-1.1S11.39,10.9,12,10.9z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  events: {
    element: [
      <path
        d="M20,4h-1V3c0-0.552-0.448-1-1-1l0,0c-0.552,0-1,0.448-1,1v1H7V3c0-0.552-0.448-1-1-1l0,0C5.448,2,5,2.448,5,3v1H4
      C2.9,4,2,4.9,2,6v14c0,1.1,0.9,2,2,2h16c1.1,0,2-0.9,2-2V6C22,4.9,21.1,4,20,4z M20,20H4v-9h16V20z M20,9H4V6h16V9z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  help: {
    element: [
      <path
        d="M11,18h2v-2h-2V18z M12,2C6.48,2,2,6.48,2,12s4.48,10,10,10s10-4.48,10-10S17.52,2,12,2z M12,20c-4.41,0-8-3.59-8-8
      s3.59-8,8-8s8,3.59,8,8S16.41,20,12,20z M12,6c-2.21,0-4,1.79-4,4h2c0-1.1,0.9-2,2-2s2,0.9,2,2c0,2-3,1.75-3,5h2c0-2.25,3-2.5,3-5
      C16,7.79,14.21,6,12,6z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  home: {
    element: [
      <path
        d="M12,5.69l5,4.5V18h-2v-5c0-0.552-0.448-1-1-1h-4c-0.552,0-1,0.448-1,1v5H7v-7.81L12,5.69 M11.666,3.301l-8.697,7.827
      C2.628,11.435,2.845,12,3.303,12H5v7c0,0.552,0.448,1,1,1h4c0.552,0,1-0.448,1-1v-5h2v5c0,0.552,0.448,1,1,1h4c0.552,0,1-0.448,1-1
      v-7h1.697c0.458,0,0.675-0.565,0.334-0.872l-8.697-7.827C12.144,3.13,11.856,3.13,11.666,3.301z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  live_events: {
    element: [
      <path d="M6.75 6.5V12.5L12 9.5L6.75 6.5ZM15.75 3.5H10.065L12.5325 1.0325L12 0.5L9 3.5H8.9775L5.9775 0.5L5.46 1.0325L7.92 3.5H2.25C1.425 3.5 0.75 4.175 0.75 5V14C0.75 14.825 1.425 15.5 2.25 15.5H15.75C16.575 15.5 17.25 14.825 17.25 14V5C17.25 4.175 16.575 3.5 15.75 3.5ZM15.75 14H2.25V5H15.75V14Z" />,
    ],
    viewBox: '0 0 18 16',
  },
  my_learning: {
    element: [
      <path d="M3 17.15V10C3 9.46667 3.19583 9.01667 3.5875 8.65C3.97917 8.28333 4.44167 8.11667 4.975 8.15C6.29167 8.35 7.54583 8.7375 8.7375 9.3125C9.92917 9.8875 11.0167 10.6333 12 11.55C12.9833 10.6333 14.0708 9.8875 15.2625 9.3125C16.4542 8.7375 17.7083 8.35 19.025 8.15C19.5583 8.11667 20.0208 8.28333 20.4125 8.65C20.8042 9.01667 21 9.46667 21 10V17.15C21 17.6833 20.825 18.1375 20.475 18.5125C20.125 18.8875 19.6833 19.0917 19.15 19.125C18.0833 19.2917 17.05 19.5667 16.05 19.95C15.05 20.3333 14.1167 20.8417 13.25 21.475C13.0667 21.625 12.8708 21.7375 12.6625 21.8125C12.4542 21.8875 12.2333 21.925 12 21.925C11.7667 21.925 11.5458 21.8875 11.3375 21.8125C11.1292 21.7375 10.9333 21.625 10.75 21.475C9.88333 20.8417 8.95 20.3333 7.95 19.95C6.95 19.5667 5.91667 19.2917 4.85 19.125C4.31667 19.0917 3.875 18.8875 3.525 18.5125C3.175 18.1375 3 17.6833 3 17.15ZM12 19.9C13.05 19.1167 14.1667 18.4917 15.35 18.025C16.5333 17.5583 17.75 17.25 19 17.1V10.2C17.7833 10.4167 16.5875 10.8542 15.4125 11.5125C14.2375 12.1708 13.1 13.05 12 14.15C10.9 13.05 9.7625 12.1708 8.5875 11.5125C7.4125 10.8542 6.21667 10.4167 5 10.2V17.1C6.25 17.25 7.46667 17.5583 8.65 18.025C9.83333 18.4917 10.95 19.1167 12 19.9ZM12 9C10.9 9 9.95833 8.60833 9.175 7.825C8.39167 7.04167 8 6.1 8 5C8 3.9 8.39167 2.95833 9.175 2.175C9.95833 1.39167 10.9 1 12 1C13.1 1 14.0417 1.39167 14.825 2.175C15.6083 2.95833 16 3.9 16 5C16 6.1 15.6083 7.04167 14.825 7.825C14.0417 8.60833 13.1 9 12 9ZM12 7C12.55 7 13.0208 6.80417 13.4125 6.4125C13.8042 6.02083 14 5.55 14 5C14 4.45 13.8042 3.97917 13.4125 3.5875C13.0208 3.19583 12.55 3 12 3C11.45 3 10.9792 3.19583 10.5875 3.5875C10.1958 3.97917 10 4.45 10 5C10 5.55 10.1958 6.02083 10.5875 6.4125C10.9792 6.80417 11.45 7 12 7Z" />,
    ],
    viewBox: '0 0 24 24',
  },
  oculus: {
    element: [
      <path d="M44.222 3.766a15.113 15.113 0 00-5.94-2.93C37.034.523 35.785.41 34.503.36c-.958-.033-1.915-.033-2.857-.033H18.16c-.958 0-1.9 0-2.857.033-1.265.049-2.531.163-3.78.474a15.113 15.113 0 00-5.94 2.93 15.096 15.096 0 000 23.441 15.113 15.113 0 005.94 2.93c1.249.312 2.498.426 3.78.475.958.033 1.9.033 2.857.033h13.485c.958 0 1.899 0 2.857-.033 1.282-.049 2.531-.18 3.78-.474a15.113 15.113 0 005.94-2.93c3.538-2.849 5.583-7.17 5.583-11.721 0-4.567-2.045-8.872-5.583-11.72zM37.65 19.562a5.145 5.145 0 01-2.207.851c-.812.115-1.574.098-2.386.098H16.715c-.795 0-1.574.033-2.385-.098a5.696 5.696 0 01-2.207-.851 4.984 4.984 0 01-2.126-4.076 4.94 4.94 0 012.126-4.076 5.145 5.145 0 012.207-.851c.795-.131 1.574-.098 2.385-.098h16.342c.795 0 1.574-.033 2.386.098.795.13 1.525.41 2.207.851a4.984 4.984 0 012.126 4.076 4.878 4.878 0 01-2.126 4.076z" />,
    ],
    viewBox: '1 0 52 31',
  },
  portal: {
    element: [
      <path d="M25.7 15.426c-3.526 0-5.582 2.498-5.582 6.024s2.203 6.023 5.73 6.023c3.525 0 5.582-2.497 5.582-6.023-.147-3.38-2.35-6.024-5.73-6.024z" />,
      <path d="M23.79 0C10.863 0 .285 10.578.285 23.507c0 12.928 10.578 23.506 23.507 23.506 12.928 0 23.506-10.578 23.506-23.506C47.297 10.578 36.72 0 23.791 0zm2.204 32.028c-2.791 0-4.848-1.176-5.73-1.91v7.786h-5.288V11.166h4.995v2.056c.734-.734 2.497-2.35 6.17-2.35 6.17 0 10.284 4.407 10.284 10.578 0 5.876-3.966 10.578-10.43 10.578z" />,
    ],
    viewBox: '1 -1 50 49',
  },
  videos: {
    element: [
      <path d="M10 16.5l6-4.5-6-4.5v9zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z" />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-01': {
    element: [
      <path
        d="M7,15h7v2H7V15z M7,11h10v2H7V11z M7,7h10v2H7V7z M19,3h-4.18C14.4,1.84,13.3,1,12,1S9.6,1.84,9.18,3H5
  C4.86,3,4.73,3.01,4.6,3.04C4.21,3.12,3.86,3.32,3.59,3.59c-0.18,0.18-0.33,0.4-0.43,0.64C3.06,4.46,3,4.72,3,5v14
  c0,0.27,0.06,0.54,0.16,0.78s0.25,0.45,0.43,0.64c0.27,0.27,0.62,0.47,1.01,0.55C4.73,20.99,4.86,21,5,21h14c1.1,0,2-0.9,2-2V5
  C21,3.9,20.1,3,19,3z M12,2.75c0.41,0,0.75,0.34,0.75,0.75S12.41,4.25,12,4.25s-0.75-0.34-0.75-0.75S11.59,2.75,12,2.75z M19,19H5V5
  h14V19z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-02': {
    element: [
      <path
        d="M12,3c-0.46,0-0.93,0.04-1.4,0.14C7.84,3.67,5.64,5.9,5.12,8.66c-0.48,2.61,0.48,5.01,2.22,6.56C7.77,15.6,8,16.13,8,16.69
      V19c0,1.1,0.9,2,2,2h0.28c0.35,0.6,0.98,1,1.72,1s1.38-0.4,1.72-1H14c1.1,0,2-0.9,2-2v-2.31c0-0.55,0.22-1.09,0.64-1.46
      C18.09,13.95,19,12.08,19,10C19,6.13,15.87,3,12,3z M14,17h-4v-1h4V17z M10,19v-1h4v1H10z M15.31,13.74
      c-0.09,0.08-0.16,0.18-0.24,0.26H8.92c-0.08-0.09-0.15-0.19-0.24-0.27c-1.32-1.18-1.91-2.94-1.59-4.7c0.36-1.94,1.96-3.55,3.89-3.93
      C11.32,5.03,11.66,5,12,5c2.76,0,5,2.24,5,5C17,11.43,16.39,12.79,15.31,13.74z M9,10.5c-0.276,0-0.5-0.224-0.5-0.5
      c0-1.93,1.57-3.5,3.5-3.5c0.276,0,0.5,0.224,0.5,0.5S12.276,7.5,12,7.5c-1.378,0-2.5,1.122-2.5,2.5C9.5,10.276,9.276,10.5,9,10.5z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-03': {
    element: [
      <path
        d="M11.594,2.681l-8,3.556C3.233,6.397,3,6.755,3,7.15V8c0,0.552,0.448,1,1,1h1v7c0,0.552,0.448,1,1,1l0,0c0.552,0,1-0.448,1-1
  V9h2v7c0,0.552,0.448,1,1,1l0,0c0.552,0,1-0.448,1-1V9h2v7c0,0.552,0.448,1,1,1l0,0c0.552,0,1-0.448,1-1V9h2v7c0,0.552,0.448,1,1,1
  l0,0c0.552,0,1-0.448,1-1V9h1c0.552,0,1-0.448,1-1V7.15c0-0.395-0.233-0.753-0.594-0.914l-8-3.556
  C12.148,2.566,11.852,2.566,11.594,2.681z M12,4.689L17.201,7H6.799L12,4.689z M3,20L3,20c0,0.552,0.448,1,1,1h16
  c0.552,0,1-0.448,1-1l0,0c0-0.552-0.448-1-1-1H4C3.448,19,3,19.448,3,20z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-04': {
    element: [
      <path
        d="M6,2C4.906,2,4,2.906,4,4v16c0,1.094,0.906,2,2,2h12c1.094,0,2-0.906,2-2V8l-6-6H6z M6,4h7v5h5v11H6V4z M8,12v2h8v-2H8z
   M8,16v2h8v-2H8z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-05': {
    element: [
      <path
        d="M9.015,12.554l1.76-2.765C11.163,9.914,11.57,10,12,10c2.209,0,4-1.791,4-4s-1.791-4-4-4S8,3.791,8,6
    c0,1.055,0.416,2.006,1.083,2.721l-1.751,2.751C7.955,11.736,8.52,12.107,9.015,12.554z M12,4c1.103,0,2,0.897,2,2s-0.897,2-2,2
    s-2-0.897-2-2S10.897,4,12,4z"
      />,
      <path
        d="M19,13c-0.43,0-0.837,0.086-1.225,0.211l-1.76-2.765c-0.495,0.447-1.06,0.818-1.682,1.082l1.751,2.751
    c-0.532,0.571-0.894,1.294-1.021,2.101C15.026,16.582,15,16.787,15,17s0.026,0.418,0.063,0.621C15.363,19.533,17.003,21,19,21
    c2.209,0,4-1.791,4-4S21.209,13,19,13z M19,19c-1.103,0-2-0.897-2-2s0.897-2,2-2s2,0.897,2,2S20.103,19,19,19z"
      />,
      <path
        d="M8.859,16C8.413,14.278,6.862,13,5,13c-2.209,0-4,1.791-4,4s1.791,4,4,4c1.862,0,3.413-1.278,3.859-3h4.232
    C13.035,17.674,13,17.341,13,17s0.035-0.674,0.09-1H8.859z M5,19c-1.103,0-2-0.897-2-2s0.897-2,2-2s2,0.897,2,2S6.103,19,5,19z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-06': {
    element: [
      <path
        d="M11,2v1H2v2h1v10c0,1.105,0.895,2,2,2h4.6L8,21h2l1.6-4h0.8l1.6,4h2l-1.6-4H19c1.105,0,2-0.895,2-2V5h1V3h-9V2H11z M5,5h14
    v10H5V5z"
      />,
      <path d="M9,7c-1.657,0-3,1.343-3,3s1.343,3,3,3s2.969-1.359,3-3H9V7z M14,7v2h4V7H14z M14,11v2h4v-2H14z" />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-07': {
    element: [
      <path
        d="M2,4v14c0,1.105,0.895,2,2,2h6.277c0.346,0.596,0.984,1,1.723,1s1.376-0.404,1.723-1H20c1.105,0,2-0.895,2-2V4h-8
      c-0.772,0-1.468,0.3-2,0.779C11.468,4.3,10.772,4,10,4H2z M4,6h6c0.551,0,1,0.449,1,1v11H4V6z M14,6h6v12h-7V7
      C13,6.449,13.449,6,14,6z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-08': {
    element: [
      <path
        d="M20.995,6.016c-0.553,0-1,0.448-1,1v10.988H12.41l0.297-0.297C15.369,15.045,17.955,15,18.002,15L19,14.996V4h-1
  c-0.206,0-2.747,0.032-6,2.658C8.747,4.032,6.206,4,6,4H5l0.002,10.996L5.998,15c0.045,0,2.633,0.045,5.295,2.707l0.297,0.297H3.953
  V7.016c0-0.552-0.448-1-1-1s-1,0.448-1,1v10.988c0,1.103,0.897,2,2,2h16.042c1.103,0,2-0.898,2-2V7.016
  C21.995,6.464,21.548,6.016,20.995,6.016z M13,8.455c1.894-1.688,2.563-2.223,4-2.383v6.984c-1.348,0.13-1.819,0.55-4,1.9V8.455z
   M11,14.957c-2.181-1.351-2.652-1.772-4-1.9V6.07c1.436,0.161,2.106,0.696,4,2.383V14.957z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-09': {
    element: [
      <path
        d="M7,2C5.355,2,4,3.355,4,5v14c0,1.645,1.355,3,3,3h13V2H7z M18,20H7c-0.565,0-1-0.435-1-1s0.435-1,1-1h11V20z M18,16H9.998
      V6h-2v10H7c-0.352,0-0.685,0.074-1,0.188V5c0-0.565,0.435-1,1-1h11V16z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-10': {
    element: [
      <path
        d="M16,2h-6H7C5.355,2,4,3.355,4,5v14c0,1.645,1.355,3,3,3h13v-0.535V20v-2v-2v-2.809V2H16z M12,4h2v4.277l-1-0.701l-1,0.701V4
      z M18,20H7c-0.565,0-1-0.435-1-1s0.435-1,1-1h11V20z M18,16H7c-0.352,0-0.685,0.074-1,0.188V5c0-0.565,0.435-1,1-1h3v8.123
      l1.574-1.104L13,10.018l3,2.105V4h2v9.191V16z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-11': {
    element: [
      <path
        d="M18,4H9H8.5C6.579,4,5,5.579,5,7.5C5,8.038,5.135,8.543,5.355,9H5H4.5C2.579,9,1,10.579,1,12.5
      c0,1.874,1.506,3.412,3.363,3.486C4.138,16.447,4,16.956,4,17.5C4,19.421,5.579,21,7.5,21H8h10h2v-2v-3v-2v-3V9V6V4H18z M4.5,14
      C3.659,14,3,13.341,3,12.5S3.659,11,4.5,11H5h5v3H4.5z M18,19H8H7.5C6.659,19,6,18.341,6,17.5S6.659,16,7.5,16H10v2l3-1.5l3,1.5v-2
      h2V19z M12,14.764V11h2v3.764l-0.105-0.053L13,14.264l-0.895,0.447L12,14.764z M18,14h-2v-3h2V14z M18,9h-2h-6H8.5
      C7.659,9,7,8.341,7,7.5S7.659,6,8.5,6H9h9V9z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-12': {
    element: [
      <path
        d="M12,2c-0.552,0-1,0.448-1,1v2H4C3.448,5,3,5.448,3,6v14c0,0.552,0.448,1,1,1h8h8c0.552,0,1-0.448,1-1V3c0-0.552-0.448-1-1-1
  H12z M13,4h6v2h-4v2h4v7h-4v2h4v2h-6V6V4z M5,7h6v2H7v2h4v4H7v2h4v2H5V7z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-13': {
    element: [
      <path
        d="M5,2C3.346,2,2,3.346,2,5v3h2v12h5v-2H6V8h11V5c0-0.551,0.448-1,1-1c0.565,0,1,0.435,1,1v15h2V5c0-1.645-1.355-3-3-3H5z
   M5,4h10.172C15.061,4.313,15,4.65,15,5v1H4V5C4,4.449,4.449,4,5,4z M8,10v2h9v-2H8z M8,14v2h2v-2H8z M14,14c-1.645,0-3,1.355-3,3
  c0,0.876,0.392,1.662,1,2.213v3.592l2-1.25l2,1.25v-3.592c0.608-0.551,1-1.336,1-2.213C17,15.355,15.645,14,14,14z M14,16
  c0.564,0,1,0.436,1,1s-0.436,1-1,1s-1-0.436-1-1S13.436,16,14,16z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-14': {
    element: [
      <path
        d="M4,4C2.895,4,2,4.895,2,6v12c0,1.105,0.895,2,2,2h2v-2H4V6h16v12h-2v2h2c1.105,0,2-0.895,2-2V6c0-1.105-0.895-2-2-2H4z
      M12,10c-2.209,0-4,1.791-4,4v10l4-2l4,2V14C16,11.791,14.209,10,12,10z M12,12c1.105,0,2,0.895,2,2s-0.895,2-2,2s-2-0.895-2-2
     S10.895,12,12,12z M10,17.445C10.59,17.789,11.268,18,12,18s1.41-0.211,2-0.555v3.318l-2-1l-2,1V17.445z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-15': {
    element: [
      <path
        d="M10,2C9.448,2,9,2.448,9,3v2H4C2.907,5,2,5.907,2,7v11c0,1.093,0.907,2,2,2h16c1.093,0,2-0.907,2-2V7c0-1.093-0.907-2-2-2
  h-5V3c0-0.552-0.448-1-1-1H10z M11,4h2v1h-2V4z M4,7h2v2h2V7h8v2h2V7h2v11H4V7z M14.5,10c-0.828,0-1.5,0.672-1.5,1.5
  s0.672,1.5,1.5,1.5s1.5-0.672,1.5-1.5S15.328,10,14.5,10z M18,12.684L13.342,15l1,2L19,14.684L18,12.684z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-16': {
    element: [
      <path
        d="M3.99,2.99c-0.552,0-1,0.448-1,1c0,0.046,0.003,0.093,0.01,0.138V16c0,0.265,0.105,0.52,0.293,0.707l3.912,3.912
      c0.223,0.293,0.59,0.439,0.953,0.381H20c0.552,0,1-0.448,1-1V8.168c0.062-0.365-0.083-0.735-0.377-0.961
      c-0.002-0.001-0.004-0.003-0.006-0.004l-3.91-3.91C16.52,3.105,16.265,3,16,3H4.117C4.075,2.994,4.033,2.991,3.99,2.99z M6.414,5
      h9.172l2,2H8.414L6.414,5z M5,6.414l2,2v9.172l-2-2V6.414z M9,9h10v10H9V9z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-17': {
    element: [
      <path
        d="M19,5v14H5V5H19 M19,3H5C3.9,3,3,3.9,3,5v14c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2V5C21,3.9,20.1,3,19,3z M14.14,11.86
      l-3,3.87L9,13.14L6,17h12C18,17,14.14,11.86,14.14,11.86z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-18': {
    element: [
      <path
        d="M4,6h16v2H4V6z M6,2h12v2H6V2z M20,10H4c-1.1,0-2,0.9-2,2v8c0,1.1,0.9,2,2,2h16c1.1,0,2-0.9,2-2v-8C22,10.9,21.1,10,20,10z
      M20,20H4v-8h16V20z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-19': {
    element: [
      <path
        d="M16,7c0.551,0,1,0.449,1,1c0,0.551-0.449,1-1,1c-0.551,0-1-0.449-1-1C15,7.449,15.449,7,16,7 M16,5c-1.657,0-3,1.343-3,3
      s1.343,3,3,3s3-1.343,3-3S17.657,5,16,5L16,5z"
      />,
      <path
        d="M16,15c0.551,0,1,0.449,1,1c0,0.551-0.449,1-1,1c-0.551,0-1-0.449-1-1C15,15.449,15.449,15,16,15 M16,13
        c-1.657,0-3,1.343-3,3s1.343,3,3,3s3-1.343,3-3S17.657,13,16,13L16,13z"
      />,
      <path
        d="M8,7c0.551,0,1,0.449,1,1c0,0.551-0.449,1-1,1S7,8.551,7,8C7,7.449,7.449,7,8,7 M8,5C6.343,5,5,6.343,5,8s1.343,3,3,3
        s3-1.343,3-3S9.657,5,8,5L8,5z"
      />,
      <path
        d="M8,15c0.551,0,1,0.449,1,1c0,0.551-0.449,1-1,1s-1-0.449-1-1C7,15.449,7.449,15,8,15 M8,13c-1.657,0-3,1.343-3,3
        s1.343,3,3,3s3-1.343,3-3S9.657,13,8,13L8,13z"
      />,
      <path d="M16.5,1C15.672,1,15,1.672,15,2.5S15.672,4,16.5,4S18,3.328,18,2.5S17.328,1,16.5,1L16.5,1z" />,
      <path d="M7.5,1C6.672,1,6,1.672,6,2.5S6.672,4,7.5,4S9,3.328,9,2.5S8.328,1,7.5,1L7.5,1z" />,
      <path d="M2.5,6C1.672,6,1,6.672,1,7.5S1.672,9,2.5,9S4,8.328,4,7.5S3.328,6,2.5,6L2.5,6z" />,
      <path d="M2.5,15C1.672,15,1,15.672,1,16.5S1.672,18,2.5,18S4,17.328,4,16.5S3.328,15,2.5,15L2.5,15z" />,
      <path d="M7.5,20C6.672,20,6,20.672,6,21.5S6.672,23,7.5,23S9,22.328,9,21.5S8.328,20,7.5,20L7.5,20z" />,
      <path d="M16.5,20c-0.828,0-1.5,0.672-1.5,1.5s0.672,1.5,1.5,1.5s1.5-0.672,1.5-1.5S17.328,20,16.5,20L16.5,20z" />,
      <path d="M21.5,15c-0.828,0-1.5,0.672-1.5,1.5s0.672,1.5,1.5,1.5s1.5-0.672,1.5-1.5S22.328,15,21.5,15L21.5,15z" />,
      <path d="M21.5,6C20.672,6,20,6.672,20,7.5S20.672,9,21.5,9S23,8.328,23,7.5S22.328,6,21.5,6L21.5,6z" />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-20': {
    element: [
      <path
        d="M5,3C3.907,3,3,3.907,3,5v14c0,1.093,0.907,2,2,2h14c1.093,0,2-0.907,2-2V5c0-1.093-0.907-2-2-2H5z M5,5h14v14H5V5z M7,7v2
      h2V7H7z M11,7v2h2V7H11z M15,7v2h2V7H15z M7,11v2h2v-2H7z M11,11v2h2v-2H11z M15,11v2h2v-2H15z M7,15v2h2v-2H7z M11,15v2h2v-2H11z
       M15,15v2h2v-2H15z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-21': {
    element: [
      <path
        d="M21,4H3C1.9,4,1,4.9,1,6v13c0,1.1,0.9,2,2,2h18c1.1,0,2-0.9,2-2V6C23,4.9,22.1,4,21,4z M3,19V6h8v13H3z M21,19h-8V6h8V19z
      M14,9.5h6V11h-6V9.5z M14,12h6v1.5h-6V12z M14,14.5h6V16h-6V14.5z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-22': {
    element: [
      <path
        d="M11,2v1H2v2h1v10c0,1.105,0.895,2,2,2h4.6L8,21h2l1.6-4h0.8l1.6,4h2l-1.6-4H19c1.105,0,2-0.895,2-2V5h1V3h-9V2H11z M5,5
      h14v10H5V5z"
      />,
      <path d="M14.14,8.86l-3,3.87L9,10.14L6,14h12L14.14,8.86z" />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-23': {
    element: [
      <path
        d="M13.001,3v2.121h4.463l-7.71,7.71C8.964,12.308,8.019,12,7,12c-2.761,0-5,2.239-5,5s2.239,5,5,5s5-2.239,5-5
  c0-1.019-0.308-1.964-0.832-2.754l7.71-7.71v4.463H21V3H13.001z M7,20c-1.654,0-3-1.346-3-3s1.346-3,3-3s3,1.346,3,3S8.654,20,7,20z
   M18.879,18.464L21,20.586L19.586,22l-2.121-2.121L15.343,22l-1.414-1.414l2.121-2.121l-2.121-2.121l1.414-1.414l2.121,2.121
  l2.121-2.121L21,16.343L18.879,18.464z M6.95,6.536l2.121,2.121l-1.414,1.414L5.536,7.95l-2.121,2.121L2,8.657l2.121-2.121L2,4.414
  L3.414,3l2.121,2.121L7.657,3l1.414,1.414L6.95,6.536z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-24': {
    element: [
      <path
        d="M8,8h8c0.552,0,1-0.448,1-1V3c0-0.551-0.449-1-1-1s-1,0.449-1,1v2c0,0.551-0.449,1-1,1s-1-0.449-1-1V3c0-0.551-0.449-1-1-1
    s-1,0.449-1,1v2c0,0.551-0.449,1-1,1S9,5.551,9,5V3c0-0.551-0.449-1-1-1S7,2.449,7,3v4C7,7.552,7.448,8,8,8z"
      />,
      <path
        d="M18.512,20.658L15.364,12H17c0.552,0,1-0.448,1-1s-0.448-1-1-1H7c-0.552,0-1,0.448-1,1s0.448,1,1,1h1.636l-3.148,8.658
    C5.251,21.31,5.734,22,6.428,22h11.145C18.266,22,18.749,21.31,18.512,20.658z M7.855,20l2.545-7h3.198l2.545,7H7.855z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-25': {
    element: [
      <path
        d="M20,6h2V4h-8.271C13.372,3.382,12.713,3.001,12,3c-0.714,0.001-1.373,0.382-1.73,1H2v2h2l-4,8c0,2.761,2.239,5,5,5
      s5-2.239,5-5L6,6h4.271C10.449,6.308,10.703,6.557,11,6.73V20H9v2h6v-2h-2V6.731C13.298,6.558,13.552,6.309,13.73,6H18l-4,8
      c0,2.761,2.239,5,5,5s5-2.239,5-5L20,6z M5,17c-1.305,0-2.403-0.837-2.816-2h5.633C7.403,16.163,6.305,17,5,17z M7.488,13H2.512
      L5,8.021L7.488,13z M19,8.021L21.488,13h-4.977L19,8.021z M19,17c-1.305,0-2.403-0.837-2.816-2h5.633C21.403,16.163,20.305,17,19,17
      z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-26': {
    element: [
      <path
        d="M14,3L14,3c-0.39,0.39-0.39,1.024,0,1.414l0.389,0.389L8.189,9.775L7.414,9C7.024,8.61,6.39,8.61,6,9l0,0
      c-0.39,0.39-0.39,1.024,0,1.414l3.094,3.094L3,19.6V21h1.4l6.092-6.094L13.586,18c0.39,0.39,1.024,0.39,1.414,0h0
      c0.39-0.39,0.39-1.024,0-1.414l-0.689-0.689l4.904-6.268L19.586,10c0.39,0.39,1.024,0.39,1.414,0v0c0.39-0.39,0.39-1.024,0-1.414
      L15.414,3C15.024,2.61,14.39,2.61,14,3z M15.799,6.236l1.98,1.98l-4.803,6.143l-3.252-3.252L15.799,6.236z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-27': {
    element: [
      <path
        d="M19.887,3H8.004c-0.265,0-0.52,0.105-0.707,0.293l-3.91,3.91C3.385,7.204,3.383,7.206,3.381,7.207
      C3.087,7.433,2.942,7.803,3.004,8.168V20c0,0.552,0.448,1,1,1h11.842c0.363,0.058,0.73-0.088,0.953-0.381l3.912-3.912
      c0.188-0.187,0.293-0.442,0.293-0.707V4.128c0.007-0.045,0.01-0.092,0.01-0.138c0-0.552-0.448-1-1-1
      C19.971,2.991,19.929,2.994,19.887,3z M15.59,7H6.418l2-2h9.172L15.59,7z M19.004,15.586l-2,2V8.414l2-2V15.586z M15.004,19h-10V9
      h10V19z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-28': {
    element: [
      <path
        d="M12,3c-0.46,0-0.93,0.04-1.4,0.14C7.84,3.67,5.64,5.9,5.12,8.66c-0.48,2.61,0.48,5.01,2.22,6.56C7.77,15.6,8,16.13,8,16.69
      V19c0,1.1,0.9,2,2,2h0.28c0.35,0.6,0.98,1,1.72,1s1.38-0.4,1.72-1H14c1.1,0,2-0.9,2-2v-2.31c0-0.55,0.22-1.09,0.64-1.46
      C18.09,13.95,19,12.08,19,10C19,6.13,15.87,3,12,3z M14,19h-4v-1h4V19z M14,17h-4v-1h4V17z M15.31,13.74
      c-0.09,0.08-0.16,0.18-0.24,0.26H12.5v-2.58l1.829-1.829l-0.707-0.707L12.006,10.5L10.38,8.874L9.672,9.581l1.828,1.828V14H8.92
      c-0.08-0.09-0.15-0.19-0.24-0.27c-1.32-1.18-1.91-2.94-1.59-4.7c0.36-1.94,1.96-3.55,3.89-3.93C11.32,5.03,11.66,5,12,5
      c2.76,0,5,2.24,5,5C17,11.43,16.39,12.79,15.31,13.74z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-29': {
    element: [
      <path
        d="M4,6h16v2H4V6z M6,2h12v2H6V2z M20,10H4c-1.1,0-2,0.9-2,2v8c0,1.1,0.9,2,2,2h16c1.1,0,2-0.9,2-2v-8C22,10.9,21.1,10,20,10z
      M20,20H4v-8h16V20z M17,14h-2v2H9v-2.008H7V18h10V14z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-30': {
    element: [
      <path
        d="M22,12c0-2.243-0.753-4.31-2.007-5.981c0.33-0.573,0.275-1.307-0.215-1.797c-0.49-0.49-1.224-0.545-1.797-0.215
      C16.31,2.753,14.243,2,12,2S7.69,2.753,6.019,4.007c-0.573-0.33-1.307-0.275-1.797,0.215c-0.49,0.49-0.545,1.224-0.215,1.797
      C2.753,7.69,2,9.757,2,12s0.753,4.31,2.007,5.981c-0.33,0.573-0.275,1.307,0.215,1.797c0.49,0.49,1.224,0.545,1.797,0.215
      C7.69,21.247,9.757,22,12,22s4.31-0.753,5.981-2.007c0.573,0.33,1.307,0.275,1.797-0.215c0.49-0.49,0.545-1.224,0.215-1.797
      C21.247,16.31,22,14.243,22,12z M18.621,16.5l-1.461-1.461C17.689,14.146,18,13.109,18,12s-0.311-2.146-0.84-3.039L18.621,7.5
      C19.491,8.781,20,10.329,20,12S19.491,15.219,18.621,16.5z M14.121,14.121c-0.396,0.396-0.502,0.955-0.362,1.459
      C13.227,15.841,12.636,16,12,16s-1.227-0.159-1.76-0.419c0.14-0.504,0.035-1.063-0.362-1.459c-0.396-0.396-0.955-0.502-1.459-0.362
      C8.159,13.227,8,12.636,8,12s0.159-1.227,0.419-1.76c0.504,0.14,1.063,0.035,1.459-0.362c0.396-0.396,0.502-0.955,0.362-1.459
      C10.773,8.159,11.364,8,12,8s1.227,0.159,1.76,0.419c-0.14,0.504-0.034,1.063,0.362,1.459s0.955,0.502,1.459,0.362
      C15.841,10.773,16,11.364,16,12s-0.159,1.227-0.419,1.76C15.076,13.62,14.518,13.725,14.121,14.121z M16.5,5.379L15.039,6.84
      C14.146,6.311,13.109,6,12,6S9.854,6.311,8.961,6.84L7.5,5.379C8.781,4.509,10.329,4,12,4S15.219,4.509,16.5,5.379z M5.379,7.5
      L6.84,8.961C6.311,9.854,6,10.891,6,12s0.311,2.146,0.84,3.039L5.379,16.5C4.509,15.219,4,13.671,4,12S4.509,8.781,5.379,7.5z
       M7.5,18.621l1.461-1.461C9.854,17.689,10.891,18,12,18s2.146-0.311,3.039-0.84l1.461,1.461C15.219,19.491,13.671,20,12,20
      S8.781,19.491,7.5,18.621z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-31': {
    element: [
      <path
        d="M17,2H4v20h13c1.645,0,3-1.355,3-3V5C20,3.355,18.645,2,17,2z M9,4h2v4.277l-1-0.701L9,8.277V4z M6,4h1v8.123l3-2.105
      l1.426,1.002L13,12.123V4h2v16H6V4z M18,19c0,0.565-0.435,1-1,1V4c0.565,0,1,0.435,1,1V19z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-32': {
    element: [
      <path
        d="M20,7h-4V5l-2-2h-4L8,5v2H4C2.9,7,2,7.9,2,9v5c0,0.75,0.4,1.38,1,1.73V19c0,1.11,0.89,2,2,2h14c1.11,0,2-0.89,2-2v-3.28
      c0.59-0.35,1-0.99,1-1.72V9C22,7.9,21.1,7,20,7z M10,5h4v2h-4V5z M4,9h16v5h-5v-3H9v3H4V9z M13,15h-2v-2h2V15z M19,19H5v-3h4v1h6v-1
      h4V19z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-33': {
    element: [
      <path
        d="M6,2C4.907,2,4,2.907,4,4v1H3C2.448,5,2,5.448,2,6s0.448,1,1,1h1v2H3c-0.552,0-1,0.448-1,1s0.448,1,1,1h1v2H3
      c-0.552,0-1,0.448-1,1s0.448,1,1,1h1v2H3c-0.552,0-1,0.448-1,1s0.448,1,1,1h1v1c0,1.093,0.907,2,2,2h12c1.093,0,2-0.907,2-2V4
      c0-1.093-0.907-2-2-2H6z M6,4h12v16H6V4z M8,7v3h8V7H8z M8,12v2h8v-2H8z M8,15v2h8v-2H8z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-34': {
    element: [
      <path
        d="M20.66,7c-0.521-0.902-1.682-1.34-3.208-1.34c-0.586,0-1.229,0.071-1.906,0.198C14.723,3.514,13.442,2,12,2
      S9.277,3.514,8.454,5.859C7.776,5.731,7.133,5.66,6.547,5.66C5.022,5.66,3.861,6.098,3.34,7c-0.721,1.249-0.051,3.115,1.568,5
      c-1.619,1.885-2.289,3.751-1.568,5c0.521,0.902,1.682,1.34,3.208,1.34c0.586,0,1.229-0.071,1.906-0.198
      C9.277,20.486,10.558,22,12,22s2.723-1.514,3.546-3.859c0.677,0.127,1.321,0.198,1.906,0.198c1.525,0,2.687-0.437,3.208-1.34
      c0.721-1.249,0.051-3.115-1.568-5C20.711,10.115,21.381,8.249,20.66,7z M17.453,7.66c1.052,0,1.437,0.272,1.476,0.34
      c0.076,0.132,0.02,0.863-0.836,2.051c-0.125,0.174-0.262,0.348-0.407,0.523c-0.412-0.369-0.858-0.732-1.334-1.086
      c-0.069-0.588-0.16-1.155-0.273-1.696C16.564,7.708,17.028,7.66,17.453,7.66z M13.25,14.165c-0.414,0.239-0.832,0.454-1.25,0.658
      c-0.418-0.204-0.836-0.419-1.25-0.658c-0.413-0.238-0.81-0.492-1.197-0.754C9.522,12.96,9.5,12.494,9.5,12s0.022-0.96,0.053-1.411
      c0.386-0.261,0.784-0.515,1.197-0.754c0.414-0.239,0.832-0.454,1.25-0.658c0.418,0.204,0.836,0.419,1.25,0.658
      c0.413,0.238,0.81,0.492,1.197,0.754C14.478,11.04,14.5,11.506,14.5,12s-0.022,0.96-0.053,1.411
      C14.06,13.673,13.663,13.927,13.25,14.165z M12,4c0.333,0,1.025,0.82,1.597,2.368C13.074,6.54,12.541,6.741,12,6.974
      c-0.541-0.234-1.074-0.435-1.597-0.606C10.975,4.82,11.667,4,12,4z M5.072,8c0.039-0.067,0.424-0.34,1.476-0.34
      c0.425,0,0.888,0.048,1.374,0.132C7.809,8.333,7.718,8.9,7.649,9.488c-0.476,0.354-0.921,0.717-1.334,1.086
      c-0.146-0.175-0.282-0.349-0.407-0.523C5.052,8.863,4.996,8.132,5.072,8z M6.547,16.34c-1.052,0-1.437-0.272-1.476-0.34
      c-0.076-0.132-0.02-0.863,0.836-2.051c0.125-0.174,0.262-0.348,0.407-0.523c0.412,0.369,0.858,0.732,1.334,1.086
      c0.069,0.588,0.16,1.155,0.273,1.696C7.436,16.292,6.972,16.34,6.547,16.34z M12,20c-0.333,0-1.025-0.82-1.597-2.368
      c0.523-0.172,1.056-0.373,1.597-0.606c0.541,0.234,1.074,0.435,1.597,0.606C13.025,19.18,12.333,20,12,20z M18.928,16
      c-0.039,0.067-0.424,0.34-1.476,0.34c-0.425,0-0.888-0.048-1.375-0.132c0.113-0.541,0.205-1.108,0.273-1.696
      c0.476-0.354,0.921-0.717,1.334-1.086c0.146,0.175,0.282,0.349,0.407,0.523C18.948,15.137,19.004,15.868,18.928,16z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-35': {
    element: [
      <path
        d="M11,2v1H2v2h1v10c0,1.105,0.895,2,2,2h4.6L8,21h2l1.6-4h0.8l1.6,4h2l-1.6-4H19c1.105,0,2-0.895,2-2V5h1V3h-9V2H11z M5,5h14
      v10H5V5z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-36': {
    element: [
      <path
        d="M20,9c-1.396,0-2.559,0.958-2.894,2.25h-3.212C13.559,9.958,12.396,9,11,9c-0.473,0-0.915,0.12-1.313,0.315L7.457,6.714
      C7.797,6.228,8,5.638,8,5c0-1.657-1.343-3-3-3S2,3.343,2,5s1.343,3,3,3c0.474,0,0.915-0.12,1.314-0.315l2.229,2.601
      C8.203,10.772,8,11.361,8,12c0,0.639,0.203,1.228,0.543,1.714l-2.229,2.601C5.915,16.12,5.474,16,5,16c-1.657,0-3,1.343-3,3
      s1.343,3,3,3s3-1.343,3-3c0-0.639-0.203-1.228-0.543-1.714l2.229-2.601C10.085,14.88,10.526,15,11,15
      c1.396,0,2.559-0.958,2.894-2.25h3.212C17.441,14.042,18.604,15,20,15c1.657,0,3-1.343,3-3S21.657,9,20,9z M3.5,5
      c0-0.827,0.673-1.5,1.5-1.5S6.5,4.173,6.5,5S5.827,6.5,5,6.5S3.5,5.827,3.5,5z M5,20.5c-0.827,0-1.5-0.673-1.5-1.5
      s0.673-1.5,1.5-1.5s1.5,0.673,1.5,1.5S5.827,20.5,5,20.5z M11,13.5c-0.827,0-1.5-0.673-1.5-1.5s0.673-1.5,1.5-1.5s1.5,0.673,1.5,1.5
      S11.827,13.5,11,13.5z M20,13.5c-0.827,0-1.5-0.673-1.5-1.5s0.673-1.5,1.5-1.5s1.5,0.673,1.5,1.5S20.827,13.5,20,13.5z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-37': {
    element: [
      <path
        d="M6,2C4.897,2,4,2.897,4,4v16c0,1.103,0.897,2,2,2h6.26c-0.422-0.604-0.75-1.277-0.965-2H6V4h7v5h5v2
      c0.695,0,1.366,0.106,2,0.295V8l-6-6H6z M18,13c-2.8,0-5,2.2-5,5s2.2,5,5,5c1,0,2.001-0.301,2.801-0.801L22.6,24l1.4-1.4
      l-1.801-1.799C22.699,20.001,23,19,23,18C23,15.2,20.8,13,18,13z M18,15c1.7,0,3,1.3,3,3s-1.3,3-3,3s-3-1.3-3-3S16.3,15,18,15z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-38': {
    element: [
      <path
        d="M20,15h-7c-0.552,0-1,0.448-1,1s0.448,1,1,1h3v2h-5.104C10.592,17.438,9.54,15.495,7,15.086v-6.09
      c0-0.009,0.023-0.911,0.566-1.48L12.5,12.45c0.39,0.39,0.902,0.584,1.414,0.584s1.024-0.194,1.414-0.584l2.121-2.121
      c0.378-0.377,0.586-0.88,0.586-1.415c0-0.534-0.208-1.036-0.586-1.414L12.5,2.55c-0.756-0.756-2.075-0.756-2.828,0L7.551,4.671
      C7.33,4.892,7.175,5.157,7.078,5.444C6.746,5.612,6.435,5.813,6.169,6.081C5.025,7.229,4.999,8.826,5,9v10H4c-0.552,0-1,0.448-1,1
      s0.448,1,1,1h14c0.552,0,1-0.448,1-1s-0.448-1-1-1v-2h2c0.552,0,1-0.448,1-1S20.552,15,20,15z M11.086,3.964l4.949,4.95l-2.12,2.123
      L8.994,6.115V6.057L11.086,3.964z M7,17.128C8.144,17.444,8.635,18.29,8.844,19H7V17.128z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-39': {
    element: [
      <path
        d="M22.293,19.293L4.707,1.707c-0.204-0.204-0.454-0.295-0.7-0.295C3.493,1.412,3,1.811,3,2.414V21h18.586
      C22.477,21,22.923,19.923,22.293,19.293z M5,19v-1h1c0.552,0,1-0.448,1-1s-0.448-1-1-1H5v-2h1c0.552,0,1-0.448,1-1s-0.448-1-1-1H5
      v-2h1c0.552,0,1-0.448,1-1S6.552,8,6,8H5V4.828L19.172,19H5z"
      />,
      <path d="M9,17h3.586c0.891,0,1.337-1.077,0.707-1.707l-3.586-3.586C9.077,11.077,8,11.523,8,12.414V16C8,16.552,8.448,17,9,17z" />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-40': {
    element: [
      <path
        d="M12,15.5c3.038,0,5.5-2.462,5.5-5.5c0-3.038-2.462-5.5-5.5-5.5S6.5,6.962,6.5,10C6.5,13.038,8.962,15.5,12,15.5z M12,6.5
      c1.93,0,3.5,1.57,3.5,3.5c0,1.93-1.57,3.5-3.5,3.5S8.5,11.93,8.5,10C8.5,8.07,10.07,6.5,12,6.5z"
      />,
      <path
        d="M21,10c0-2.076-0.722-4.033-1.982-5.604l0.689-0.689c0.391-0.39,0.391-1.023,0-1.414s-1.023-0.391-1.414,0l-0.688,0.688
      c-0.234-0.186-0.47-0.371-0.725-0.536c-0.463-0.301-1.082-0.167-1.383,0.296c-0.3,0.464-0.167,1.083,0.297,1.383
      C17.802,5.423,19,7.62,19,10c0,3.859-3.141,7-7,7c-2.38,0-4.577-1.198-5.876-3.205c-0.3-0.464-0.918-0.597-1.383-0.297
      c-0.463,0.301-0.596,0.92-0.296,1.383c0.165,0.255,0.349,0.491,0.536,0.724l-0.688,0.688c-0.391,0.391-0.391,1.023,0,1.414
      C4.488,17.902,4.744,18,5,18s0.512-0.098,0.707-0.293l0.688-0.689c1.316,1.055,2.902,1.73,4.604,1.919V21H7v2h4h2h4v-2h-4v-2.059
      C17.493,18.442,21,14.625,21,10z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-41': {
    element: [
      <path
        d="M6,2C4.895,2,4,2.895,4,4v16c0,1.105,0.895,2,2,2h12c1.105,0,2-0.895,2-2V4c0-1.105-0.895-2-2-2H6z M6,4h12v2H6V4z M6,8h12
      v12H6V8z M8,10v2h2v-2H8z M11,10v2h2v-2H11z M14,10v2h2v-2H14z M8,13v2h2v-2H8z M11,13v2h2v-2H11z M14,13v2h2v-2H14z M8,16v2h2v-2H8
      z M11,16v2h5v-2H11z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-42': {
    element: [
      <path
        d="M7,11h2v2H7V11z M21,6v14c0,1.1-0.9,2-2,2H5c-1.11,0-2-0.9-2-2L3.01,6c0-1.1,0.88-2,1.99-2h1V2h2v2h8V2h2v2h1
      C20.1,4,21,4.9,21,6z M5,8h14V6H5V8z M19,20V10H5v10H19z M15,13h2v-2h-2V13z M11,13h2v-2h-2V13z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-43': {
    element: [
      <path
        d="M12,2C8.024,2,4,3.374,4,6v12c0,2.626,4.024,4,8,4s8-1.374,8-4V6C20,3.374,15.976,2,12,2z M12,4c3.722,0,6,1.295,6,2
      s-2.278,2-6,2C8.278,8,6,6.705,6,6S8.278,4,12,4z M12,20c-3.722,0-6-1.295-6-2v-3.268C7.541,15.57,9.778,16,12,16
      s4.459-0.43,6-1.268V18C18,18.705,15.722,20,12,20z M12,14c-3.722,0-6-1.295-6-2V8.732C7.541,9.57,9.778,10,12,10
      s4.459-0.43,6-1.268V12C18,12.705,15.722,14,12,14z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-44': {
    element: [
      <path
        d="M17,3H5C3.89,3,3,3.9,3,5v14c0,1.1,0.89,2,2,2h14c1.1,0,2-0.9,2-2V7L17,3z M19,19H5V5h11.17L19,7.83V19z M12,12
      c-1.66,0-3,1.34-3,3s1.34,3,3,3s3-1.34,3-3S13.66,12,12,12z M6,6h9v4H6V6z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-45': {
    element: [
      <path
        d="M19,3H5C3.9,3,3,3.9,3,5v14c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2V5C21,3.9,20.1,3,19,3z M19,19H5V5h14V19z M7,10h2v7H7V10z
      M11,7h2v10h-2V7z M15,13h2v4h-2V13z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-46': {
    element: [
      <path
        d="M12,2C6.48,2,2,6.48,2,12s4.48,10,10,10s10-4.48,10-10S17.52,2,12,2z M19.93,11H13V4.07C16.61,4.52,19.48,7.39,19.93,11z
      M4,12c0-4.07,3.06-7.44,7-7.93v15.86C7.06,19.44,4,16.07,4,12z M13,19.93V13h6.93C19.48,16.61,16.61,19.48,13,19.93z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-47': {
    element: [
      <path
        d="M16.95,9.878l-1.099,1.099C15.938,11.306,16,11.644,16,12c0,2.206-1.794,4-4,4s-4-1.794-4-4s1.794-4,4-4
      c0.356,0,0.694,0.062,1.022,0.149l1.099-1.099L13.98,6.342C13.36,6.124,12.695,6,12,6c-3.314,0-6,2.686-6,6s2.686,6,6,6
      s6-2.686,6-6c0-0.695-0.124-1.36-0.342-1.98L16.95,9.878z"
      />,
      <path
        d="M21.242,9.828c-0.375,0.375-0.872,0.581-1.402,0.585C19.944,10.926,20,11.457,20,12c0,4.411-3.589,8-8,8s-8-3.589-8-8
      s3.589-8,8-8c0.546,0,1.079,0.056,1.595,0.161c0.003-0.522,0.2-1.026,0.577-1.403l0.409-0.409C13.756,2.128,12.894,2,12,2
      C6.477,2,2,6.477,2,12s4.477,10,10,10s10-4.477,10-10c0-0.894-0.128-1.756-0.349-2.581L21.242,9.828z"
      />,
      <path
        d="M22.923,5.049L21.394,4.02l1.263-1.263c0.391-0.391,0.391-1.024,0-1.414s-1.024-0.391-1.414,0L19.98,2.606l-1.03-1.528
    c-0.166-0.248-0.436-0.408-0.732-0.437c-0.293-0.032-0.592,0.077-0.804,0.288l-2.535,2.535c-0.236,0.236-0.339,0.575-0.273,0.903
    l0.602,3.011l-2.864,2.864c-0.391,0.391-0.391,1.024,0,1.414s1.024,0.391,1.414,0l2.864-2.864l3.01,0.602
    c0.065,0.013,0.131,0.02,0.196,0.02c0.263,0,0.518-0.104,0.707-0.293l2.536-2.535c0.211-0.211,0.317-0.506,0.288-0.803
    C23.331,5.485,23.171,5.216,22.923,5.049z M19.5,7.329l-2.357-0.471L16.672,4.5l1.298-1.298l1.029,1.528
    c0.071,0.107,0.164,0.199,0.271,0.271l1.529,1.029L19.5,7.329z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-48': {
    element: [
      <path
        d="M6.05,8.05c-2.734,2.734-2.734,7.166,0,9.9s7.166,2.734,9.9,0l0,0C19.43,14.47,20.001,4,20.001,4S9.53,4.57,6.05,8.05z
      M14.54,16.54c-1.594,1.602-4.07,1.922-6.02,0.78c0.907-2.85,2.599-5.387,4.881-7.32c-2.636,1.375-4.84,3.451-6.37,6
     c-1.507-1.984-1.32-4.776,0.44-6.54c1.74-1.74,6.57-2.81,10.33-3.26C17.35,9.96,16.28,14.79,14.54,16.54z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-49': {
    element: [
      <path
        d="M12,3C5.935,3,1,7.935,1,14c0,1.935,0.51,3.837,1.473,5.502l0.289,0.5L4,20h2v-2H3.936C3.323,16.765,3,15.393,3,14
      c0-4.963,4.038-9,9-9s9,4.037,9,9c0,1.393-0.322,2.764-0.936,4H18v2h2h1h0.238l0.289-0.498C22.49,17.837,23,15.935,23,14
      C23,7.935,18.065,3,12,3z M12,6c-0.552,0-1,0.448-1,1s0.448,1,1,1s1-0.448,1-1S12.552,6,12,6z M8.5,7c-0.552,0-1,0.448-1,1
      s0.448,1,1,1s1-0.448,1-1S9.052,7,8.5,7z M15.438,7c-0.552,0-1,0.448-1,1s0.448,1,1,1s1-0.448,1-1S15.99,7,15.438,7z M6,9.5
      c-0.552,0-1,0.448-1,1s0.448,1,1,1s1-0.448,1-1S6.552,9.5,6,9.5z M18.529,10.25c0,0-6.952,1.799-6.967,1.803l-0.059,0.014
      l0.002,0.004C10.642,12.29,10,13.067,10,14c0,1.105,0.895,2,2,2c0.509,0,0.969-0.196,1.322-0.51L18.529,10.25z M5,13
      c-0.552,0-1,0.448-1,1s0.448,1,1,1s1-0.448,1-1S5.552,13,5,13z M19,13c-0.552,0-1,0.448-1,1s0.448,1,1,1s1-0.448,1-1
      S19.552,13,19,13z M9,18.002v2h6v-2H9z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-50': {
    element: [
      <path
        d="M19.66,3.99c-2.64-1.8-5.9-0.96-7.66,1.1c-1.76-2.06-5.02-2.91-7.66-1.1C2.94,4.95,2.06,6.57,2,8.28
      c-0.14,3.88,3.3,6.99,8.55,11.76l0.1,0.09c0.76,0.69,1.93,0.69,2.69-0.01l0.11-0.1c5.25-4.76,8.68-7.87,8.55-11.75
      C21.94,6.57,21.06,4.95,19.66,3.99z M12.1,18.55l-0.1,0.1l-0.1-0.1c-4.934-4.468-8.127-7.366-7.887-10.367
      C4.067,7.5,4.352,6.84,4.79,6.313c1.798-2.168,4.761-1.385,5.957,0.424C11,7.12,11.417,7.36,11.876,7.36h0.25
      c0.471,0,0.888-0.257,1.15-0.648c1.201-1.798,4.17-2.562,5.952-0.375c0.431,0.53,0.712,1.19,0.762,1.871
      C20.21,11.2,17.02,14.095,12.1,18.55z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-51': {
    element: [
      <path
        d="M20,3l-1,1.285L6,9v6l2.451,0.889l-0.283,0.801c-0.213,0.601,0.101,1.26,0.703,1.473l2.178,0.771
      c0.601,0.213,1.262-0.103,1.475-0.705l0.27-0.764L19,19.715L20,21h2V3H20z M20,6.051v11.898l-0.318-0.115L8,13.598v-3.195
      l11.682-4.236L20,6.051z M2,9v6h2V9H2z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-52': {
    element: [
      <path
        d="M12,4C4,4,1,12,1,12s3,8,11,8s11-8,11-8S20,4,12,4z M12,6c5.276,0,7.945,4.267,8.809,5.996C19.944,13.713,17.255,18,12,18
      c-5.276,0-7.945-4.267-8.809-5.996C4.057,10.287,6.745,6,12,6z M12,8c-2.209,0-4,1.791-4,4s1.791,4,4,4s4-1.791,4-4S14.209,8,12,8z
       M12,10c1.105,0,2,0.895,2,2s-0.895,2-2,2s-2-0.895-2-2S10.895,10,12,10z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-53': {
    element: [
      <path d="M6.85,3l-5.145,9l5.145,9h0.58h9.721l5.145-9L17.15,3H6.85z M8.01,5h7.98l4.002,7l-4.002,7H8.01l-4.002-7L8.01,5z" />,
      <path
        d="M12,15.5c-1.93,0-3.5-1.57-3.5-3.5s1.57-3.5,3.5-3.5s3.5,1.57,3.5,3.5S13.93,15.5,12,15.5z M12,10.5
        c-0.827,0-1.5,0.673-1.5,1.5s0.673,1.5,1.5,1.5s1.5-0.673,1.5-1.5S12.827,10.5,12,10.5z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-54': {
    element: [
      <path
        d="M9,2C7.346,2,6,3.346,6,5c0,0.352,0.071,0.686,0.184,1H2v6h1v7.088C3,20.143,3.857,21,4.912,21h14.176
      C20.143,21,21,20.143,21,19.088V12h1V6h-4.184C17.929,5.686,18,5.352,18,5c0-1.654-1.346-3-3-3c-0.771,0-1.468,0.3-2,0.779V2.766
      l-0.078,0.078c-0.027,0.026-0.052,0.051-0.078,0.078L12,3.766l-0.844-0.844c-0.026-0.027-0.051-0.052-0.078-0.078L11,2.766v0.014
      C10.468,2.3,9.771,2,9,2z M9,4c0.552,0,1,0.449,1,1S9.552,6,9,6S8,5.551,8,5S8.448,4,9,4z M15,4c0.552,0,1,0.449,1,1s-0.448,1-1,1
      s-1-0.449-1-1S14.448,4,15,4z M4,8h16v2H4V8z M5,12h6v7H5V12z M13,12h6v7h-6V12z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-55': {
    element: [
      <path
        d="M22,6c0-1.1-0.9-2-2-2H4C2.9,4,2,4.9,2,6v12c0,1.1,0.9,2,2,2h16c1.1,0,2-0.9,2-2V6z M20,6l-8,4.99L4,6H20z M20,18H4V8l8,5
      l8-5V18z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-56': {
    element: [
      <path
        d="M12.5,22C9.46,22,7,19.54,7,16.5V6c0-2.21,1.79-4,4-4s4,1.79,4,4v8.5c0,1.38-1.12,2.5-2.5,2.5S10,15.88,10,14.5V7h2v7.59
      c0,0.55,1,0.55,1,0V6c0-1.1-0.9-2-2-2S9,4.9,9,6v10.5c0,1.93,1.57,3.5,3.5,3.5s3.5-1.57,3.5-3.5V7h2v9.5C18,19.54,15.54,22,12.5,22z
      "
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-57': {
    element: [
      <path
        d="M11,7h2v2h-2V7z M11,11h2v6h-2V11z M12,2C6.48,2,2,6.48,2,12s4.48,10,10,10s10-4.48,10-10S17.52,2,12,2z M12,20
      c-4.41,0-8-3.59-8-8s3.59-8,8-8s8,3.59,8,8S16.41,20,12,20z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-58': {
    element: [
      <path
        d="M11,18h2v-2h-2V18z M12,2C6.48,2,2,6.48,2,12s4.48,10,10,10s10-4.48,10-10S17.52,2,12,2z M12,20c-4.41,0-8-3.59-8-8
      s3.59-8,8-8s8,3.59,8,8S16.41,20,12,20z M12,6c-2.21,0-4,1.79-4,4h2c0-1.1,0.9-2,2-2s2,0.9,2,2c0,2-3,1.75-3,5h2c0-2.25,3-2.5,3-5
      C16,7.79,14.21,6,12,6z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-59': {
    element: [
      <path
        d="M4.039,10.061c-2.719,2.719-2.719,7.18,0,9.899s7.18,2.719,9.899,0c1.962-1.962,2.407-4.79,1.606-7.263l1.929-1.929
      l2.121,2.121l4.243-4.243l-2.121-2.121l1.414-1.414l-4.243-4.243l-0.707,0.707l-6.868,6.868C8.882,7.588,6.047,8.054,4.039,10.061z
       M5.454,11.475c1.612-1.612,3.899-1.889,5.716-1.01l0.639,0.311l7.079-7.079l1.414,1.414l-1.414,1.414l2.121,2.121l-1.414,1.414
      L17.474,7.94l-4.23,4.23l0.273,0.624c0.835,1.909,0.537,4.222-0.993,5.752c-1.948,1.948-5.123,1.948-7.071,0
      S3.506,13.423,5.454,11.475z M6.868,12.89c-1.163,1.163-1.163,3.079,0,4.243c1.163,1.163,3.079,1.163,4.243,0
      c1.163-1.163,1.163-3.079,0-4.243S8.031,11.726,6.868,12.89z M8.282,14.304c0.399-0.399,1.015-0.399,1.414,0
      c0.399,0.399,0.399,1.015,0,1.414c-0.399,0.399-1.015,0.399-1.414,0C7.883,15.319,7.883,14.703,8.282,14.304z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-60': {
    element: [
      <path d="M12.5,4c4.135,0,7.5,3.364,7.5,7.5S16.636,19,12.5,19c-1.08,0-2.134-0.241-3.223-0.737c-0.263-0.12-0.546-0.18-0.829-0.18c-0.231,0-0.462,0.04-0.683,0.12l-3.148,1.144l1.1-3.243c0.161-0.476,0.138-0.995-0.066-1.454C5.219,13.677,5,12.617,5,11.5C5,7.365,8.365,4,12.5,4 M12.5,2C7.262,2,3,6.262,3,11.5c0,1.402,0.277,2.732,0.823,3.962l-1.77,5.217c-0.123,0.364-0.027,0.766,0.248,1.036C2.491,21.9,2.743,22,3,22c0.115,0,0.23-0.02,0.342-0.061l5.106-1.856C9.8,20.699,11.129,21,12.5,21c5.238,0,9.5-4.262,9.5-9.5S17.738,2,12.5,2L12.5,2z" />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-61': {
    element: [
      <path d="M19,5h-2V4c0-0.552-0.448-1-1-1H8C7.448,3,7,3.448,7,4v1H5C3.9,5,3,5.9,3,7v1c0,2.55,1.92,4.63,4.39,4.94c0.63,1.5,1.98,2.63,3.61,2.96V19H8c-0.552,0-1,0.448-1,1v0c0,0.552,0.448,1,1,1h8c0.552,0,1-0.448,1-1v0c0-0.552-0.448-1-1-1h-3v-3.1c1.63-0.33,2.98-1.46,3.61-2.96C19.08,12.63,21,10.55,21,8V7C21,5.9,20.1,5,19,5z M5,8V7h2v3.82C5.84,10.4,5,9.3,5,8z M12,14c-1.65,0-3-1.35-3-3V5h6v6C15,12.65,13.65,14,12,14z M19,8c0,1.3-0.84,2.4-2,2.82V7h2V8z" />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-62': {
    element: [
      <path
        d="M9.943,2C9.708,2.009,9.469,2.055,9.234,2.141C8.295,2.482,7.711,3.35,7.748,4.35c0.004,0.107-0.049,0.173-0.094,0.211
      c-0.046,0.038-0.12,0.077-0.223,0.055c-0.976-0.212-1.936,0.214-2.436,1.08c-0.501,0.866-0.39,1.906,0.281,2.648
      C5.352,8.427,5.35,8.519,5.342,8.566C5.331,8.624,5.299,8.702,5.205,8.752c-0.884,0.468-1.344,1.408-1.17,2.393
      c0.174,0.985,0.927,1.711,1.918,1.848c0.104,0.014,0.162,0.077,0.191,0.127c0.029,0.05,0.054,0.131,0.014,0.23
      c-0.308,0.757-0.187,1.571,0.283,2.195L3.857,20h3.5v0.002l1.49,3.268l3.137-5.229l3.137,5.229l1.49-3.27h3.5l-2.568-4.428
      c0.487-0.627,0.613-1.453,0.301-2.223c-0.039-0.098-0.012-0.179,0.016-0.23c0.029-0.05,0.087-0.113,0.191-0.127
      c0.991-0.137,1.744-0.863,1.918-1.848s-0.286-1.925-1.17-2.393c-0.094-0.05-0.126-0.128-0.137-0.186
      c-0.008-0.047-0.011-0.14,0.064-0.223c0.671-0.742,0.782-1.781,0.281-2.648c-0.5-0.867-1.462-1.291-2.436-1.08
      c-0.103,0.022-0.178-0.017-0.223-0.055s-0.098-0.105-0.094-0.211c0.037-0.999-0.547-1.867-1.486-2.209
      c-0.94-0.342-1.946-0.054-2.561,0.736c-0.131,0.167-0.283,0.168-0.414,0C11.333,2.284,10.651,1.974,9.943,2z M10.08,4.008
      c0.05,0.014,0.095,0.045,0.135,0.096c0.861,1.11,2.707,1.109,3.57,0c0.078-0.1,0.179-0.129,0.297-0.086
      c0.119,0.043,0.178,0.13,0.174,0.256c-0.026,0.702,0.268,1.364,0.807,1.816c0.538,0.452,1.239,0.627,1.928,0.479
      c0.127-0.027,0.219,0.016,0.283,0.125c0.064,0.11,0.052,0.215-0.033,0.309c-0.472,0.522-0.673,1.217-0.551,1.91
      c0.123,0.692,0.549,1.279,1.17,1.607c0.113,0.059,0.159,0.152,0.137,0.277s-0.098,0.196-0.223,0.213
      c-0.697,0.097-1.298,0.502-1.65,1.111c-0.351,0.608-0.4,1.33-0.135,1.98c0.048,0.117,0.023,0.219-0.074,0.301
      c-0.098,0.081-0.204,0.088-0.309,0.021c-0.597-0.374-1.316-0.451-1.977-0.211c-0.66,0.241-1.164,0.762-1.381,1.432
      c-0.076,0.242-0.42,0.242-0.498,0c-0.216-0.669-0.719-1.19-1.379-1.43c-0.254-0.093-0.514-0.139-0.775-0.139
      c-0.418,0-0.833,0.118-1.199,0.35c-0.108,0.068-0.21,0.061-0.309-0.021c-0.096-0.082-0.123-0.183-0.076-0.299
      c0.265-0.651,0.216-1.375-0.135-1.984c-0.351-0.61-0.953-1.012-1.65-1.109c-0.125-0.017-0.2-0.09-0.221-0.215
      c-0.022-0.124,0.023-0.217,0.135-0.277c0.621-0.328,1.047-0.913,1.17-1.605c0.122-0.693-0.077-1.389-0.549-1.91
      C6.677,6.909,6.666,6.805,6.729,6.695C6.793,6.586,6.882,6.542,7.01,6.57c0.69,0.15,1.39-0.026,1.928-0.479
      c0.54-0.451,0.833-1.113,0.807-1.816C9.74,4.148,9.799,4.062,9.918,4.018C9.976,3.997,10.03,3.994,10.08,4.008z M9.586,16.076
      c0.039-0.001,0.074,0.008,0.102,0.018c0.055,0.02,0.128,0.065,0.16,0.166c0.093,0.288,0.239,0.541,0.42,0.76l-1.209,2.014
      C8.705,18.419,8.077,18,7.357,18H7.33l0.889-1.535c0.424,0.006,0.853-0.104,1.24-0.348C9.504,16.089,9.547,16.078,9.586,16.076z
       M14.418,16.076c0.039,0.001,0.083,0.012,0.129,0.041c0.376,0.236,0.789,0.347,1.201,0.348L16.639,18h-0.027
      c-0.719,0-1.348,0.417-1.701,1.033l-1.195-1.992c0.19-0.224,0.344-0.483,0.441-0.781c0.033-0.101,0.106-0.146,0.16-0.166
      C14.343,16.084,14.379,16.075,14.418,16.076z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-63': {
    element: [
      <path
        d="M9.155,4.006c0.104,0,0.207,0.016,0.311,0.05l1.92,0.619l0.615,0.198l0.614-0.199l1.925-0.622
      c0.094-0.031,0.195-0.046,0.299-0.046c0.407,0,0.813,0.238,0.989,0.583l0.92,1.797l0.295,0.575l0.576,0.294l1.798,0.918
      c0.48,0.245,0.699,0.775,0.532,1.29l-0.621,1.92L19.126,12l0.199,0.616l0.622,1.922c0.167,0.513-0.053,1.043-0.532,1.288
      l-1.799,0.918l-0.577,0.295l-0.295,0.577l-0.918,1.797C15.638,19.78,15.28,20,14.867,20c-0.112,0-0.222-0.018-0.332-0.053
      l-1.92-0.621l-0.616-0.199l-0.616,0.2L9.459,19.95c-0.094,0.031-0.194,0.046-0.298,0.046c-0.406,0-0.812-0.24-0.989-0.585
      l-0.92-1.797l-0.295-0.576l-0.577-0.294l-1.795-0.915c-0.481-0.246-0.7-0.776-0.532-1.292l0.621-1.922L4.873,12l-0.199-0.615
      L4.053,9.464C3.887,8.95,4.106,8.419,4.588,8.174l1.797-0.918l0.577-0.295l0.295-0.577l0.918-1.798
      c0.167-0.327,0.54-0.56,0.929-0.58L9.155,4.006 M9.155,2.006c-0.051,0-0.102,0.001-0.153,0.004C7.923,2.065,6.898,2.687,6.393,3.678
      L5.475,5.475L3.678,6.393C2.324,7.084,1.682,8.635,2.15,10.08L2.771,12L2.15,13.922c-0.469,1.445,0.171,2.996,1.525,3.688
      l1.797,0.916l0.92,1.797c0.531,1.04,1.636,1.674,2.769,1.674c0.307,0,0.616-0.047,0.917-0.144L12,21.229l1.92,0.621
      c0.307,0.1,0.625,0.15,0.947,0.15c1.162,0,2.211-0.643,2.74-1.678l0.918-1.797l1.799-0.918c1.353-0.692,1.994-2.243,1.525-3.687
      L21.229,12l0.621-1.92c0.469-1.446-0.171-2.997-1.525-3.688l-1.797-0.918l-0.92-1.797c-0.529-1.039-1.636-1.671-2.769-1.671
      c-0.307,0-0.616,0.046-0.917,0.144L12,2.771l-1.92-0.619C9.776,2.053,9.465,2.006,9.155,2.006L9.155,2.006z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-64': {
    element: [
      <path
        d="M12,1L3,5c0,0,0,4,0,6c0,7.83,6.439,11.486,9,12c2.561-0.514,9-4.17,9-12c0-2,0-6,0-6L12,1z M19,11
      c0,6.134-4.785,9.254-7,9.937C9.785,20.254,5,17.134,5,11V6.3l7-3.111L19,6.3V11z"
      />,
      <path d="M12,6l-1.699,3.801L6,10.199L9.199,12.9L8.301,17L12,14.801L15.801,17l-1.102-4.1L18,10.199l-4.301-0.398L12,6z" />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-65': {
    element: [
      <path
        d="M8.5,3C4.922,3,2,5.922,2,9.5c0,2.489,1.415,4.659,3.48,5.75c-0.003,0.083-0.012,0.166-0.012,0.25
      c0,3.581,2.939,6.5,6.531,6.5s6.531-2.919,6.531-6.5c0-0.084-0.008-0.167-0.012-0.25C20.585,14.159,22,11.989,22,9.5
      C22,5.922,19.078,3,15.5,3c-1.288,0-2.488,0.384-3.5,1.035C10.988,3.384,9.788,3,8.5,3z M8.5,5c0.696,0,1.345,0.169,1.932,0.447
      C9.539,6.561,9,7.969,9,9.5c0,0.078,0.009,0.153,0.012,0.23c-1.414,0.73-2.526,1.956-3.104,3.447C4.754,12.365,4,11.028,4,9.5
      C4,7.003,6.003,5,8.5,5z M15.5,5C17.997,5,20,7.003,20,9.5c0,1.528-0.754,2.865-1.908,3.678c-0.578-1.492-1.69-2.718-3.104-3.447
      C14.991,9.653,15,9.578,15,9.5c0-1.531-0.539-2.939-1.432-4.053C14.155,5.169,14.804,5,15.5,5z M12,6.695
      c0.533,0.666,0.873,1.481,0.957,2.383C12.644,9.032,12.326,9,12,9s-0.644,0.032-0.957,0.078C11.127,8.176,11.467,7.361,12,6.695z
       M12,11c0.242,0,0.474,0.035,0.705,0.07c-0.168,0.453-0.409,0.865-0.705,1.234c-0.296-0.37-0.537-0.781-0.705-1.234
      C11.526,11.035,11.758,11,12,11z M9.426,11.793c0.243,0.641,0.584,1.233,1.006,1.76C9.845,13.831,9.196,14,8.5,14
      c-0.252,0-0.494-0.035-0.734-0.074C8.091,13.055,8.669,12.311,9.426,11.793z M14.574,11.793c0.757,0.518,1.334,1.262,1.66,2.133
      C15.994,13.965,15.752,14,15.5,14c-0.696,0-1.345-0.169-1.932-0.447C13.99,13.026,14.331,12.434,14.574,11.793z M12,14.965
      C13.012,15.616,14.212,16,15.5,16c0.337,0,0.666-0.034,0.99-0.084C16.278,18.21,14.374,20,12,20s-4.278-1.79-4.49-4.084
      C7.834,15.966,8.163,16,8.5,16C9.788,16,10.988,15.616,12,14.965z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-66': {
    element: [
      <path
        d="M7,2C5.895,2,5,2.895,5,4s0.895,2,2,2s2-0.895,2-2S8.105,2,7,2z M12,2c-1.105,0-2,0.895-2,2s0.895,2,2,2s2-0.895,2-2
      S13.105,2,12,2z M17,2c-1.105,0-2,0.895-2,2s0.895,2,2,2s2-0.895,2-2S18.105,2,17,2z M5,7C3.895,7,3,7.895,3,9v7h1v6h2v-8H5V9h1.102
      c0.152-0.743,0.482-1.416,0.924-2H5z M11,7c-1.657,0-3,1.343-3,3v8h1v4h2v-4h2v4h2v-4h1v-8c0-1.657-1.343-3-3-3H11z M16.975,7
      c0.442,0.584,0.773,1.257,0.924,2H19v5h-1v8h2v-6h1V9c0-1.105-0.895-2-2-2H16.975z M11,9h2c0.552,0,1,0.448,1,1v6h-4v-6
      C10,9.448,10.448,9,11,9z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-67': {
    element: [
      <path
        d="M9,13.75c-2.34,0-7,1.17-7,3.5V19h14v-1.75C16,14.92,11.34,13.75,9,13.75z M4.34,17c0.84-0.58,2.87-1.25,4.66-1.25
  	s3.82,0.67,4.66,1.25H4.34z M9,12c1.93,0,3.5-1.57,3.5-3.5S10.93,5,9,5S5.5,6.57,5.5,8.5S7.07,12,9,12z M9,7
  	c0.83,0,1.5,0.67,1.5,1.5S9.83,10,9,10S7.5,9.33,7.5,8.5S8.17,7,9,7z M16.04,13.81C17.2,14.65,18,15.77,18,17.25V19h4v-1.75
  	C22,15.23,18.5,14.08,16.04,13.81z M15,12c1.93,0,3.5-1.57,3.5-3.5S16.93,5,15,5c-0.54,0-1.04,0.13-1.5,0.35
  	c0.63,0.89,1,1.98,1,3.15s-0.37,2.26-1,3.15C13.96,11.87,14.46,12,15,12z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-68': {
    element: [
      <path
        d="M12,3c-1.1,0-2,0.9-2,2s0.9,2,2,2s2-0.9,2-2S13.1,3,12,3z M12,8c-2.1,0-3.8,0.8-4,2H2v2h1.2l0.6,2.5c0.2,0.9,1,1.5,1.9,1.5
      H8v5h2v-5h4v5h2v-5h2.2c0.9,0,1.7-0.6,1.9-1.5l0.6-2.5H22v-2h-6C15.8,8.8,14.1,8,12,8z M5.3,12h13.4l-0.5,2H5.8L5.3,12z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-69': {
    element: [
      <path d="M5,19c-0.668,0-2,0.36-2,1.025V21h4v-0.975C7,19.36,5.668,19,5,19z" />,
      <path d="M12,19c-0.667,0-2,0.36-2,1.025V21h4v-0.975C14,19.36,12.668,19,12,19z" />,
      <path d="M19,19c-0.667,0-2,0.36-2,1.025V21h4v-0.975C21,19.36,19.667,19,19,19z" />,
      <path d="M19.166,5.834v6.332H4.834V5.834H19.166 M21,4H3v10h18V4L21,4z" />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-70': {
    element: [
      <path
        d="M14,3c-1.1,0-2,0.9-2,2v9l3-3h5c1.1,0,2-0.9,2-2V5c0-1.1-0.9-2-2-2H14z M14,5h6v4h-6V5z M7,9c-1.682,0-3,1.317-3,3
      s1.318,3,3,3s3-1.317,3-3S8.682,9,7,9z M7,11c0.58,0,1,0.421,1,1s-0.42,1-1,1s-1-0.421-1-1S6.42,11,7,11z M7,16
      c-2.851,0-5,1.456-5,3.385V21h10v-1.615C12,17.456,9.851,16,7,16z M7,18c1.469,0,2.49,0.504,2.854,1H4.146
      C4.51,18.504,5.531,18,7,18z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-71': {
    element: [
      <path
        d="M9,13c2.21,0,4-1.79,4-4s-1.79-4-4-4S5,6.79,5,9S6.79,13,9,13z M9,7c1.1,0,2,0.9,2,2s-0.9,2-2,2s-2-0.9-2-2S7.9,7,9,7z
      M9,15c-2.67,0-8,1.34-8,4v2h16v-2C17,16.34,11.67,15,9,15z M3,19c0.22-0.72,3.31-2,6-2c2.7,0,5.8,1.29,6,2H3z M15.08,7.05
     c0.84,1.18,0.84,2.71,0,3.89l1.68,1.69c2.02-2.02,2.02-5.07,0-7.27C16.76,5.36,15.08,7.05,15.08,7.05z M20.07,2l-1.63,1.63
     c2.77,3.02,2.77,7.56,0,10.74L20.07,16C23.97,12.11,23.98,6.05,20.07,2z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-72': {
    element: [
      <path
        d="M4.971,4.971C4.549,4.549,3.854,4.59,3.477,5.052C1.929,6.948,1,9.367,1,12s0.929,5.052,2.477,6.948
      c0.378,0.463,1.072,0.503,1.494,0.081h0c0.359-0.359,0.394-0.932,0.072-1.324C3.767,16.15,3,14.163,3,12s0.767-4.15,2.043-5.705
      C5.365,5.903,5.33,5.33,4.971,4.971L4.971,4.971z M19.029,4.971L19.029,4.971c-0.359,0.359-0.394,0.932-0.072,1.324
      C20.233,7.85,21,9.837,21,12s-0.767,4.15-2.043,5.705c-0.322,0.392-0.287,0.965,0.072,1.324l0,0
      c0.422,0.422,1.117,0.382,1.494-0.081C22.071,17.052,23,14.633,23,12s-0.929-5.052-2.477-6.948
      C20.146,4.59,19.451,4.549,19.029,4.971z M7.82,7.82c-0.426-0.426-1.147-0.395-1.5,0.094C5.489,9.064,5,10.476,5,12
      s0.489,2.936,1.32,4.087c0.353,0.489,1.074,0.52,1.5,0.094l0.002-0.002c0.352-0.352,0.377-0.898,0.09-1.304
      C7.337,14.061,7,13.069,7,12c0-1.069,0.338-2.061,0.912-2.874c0.287-0.406,0.261-0.952-0.091-1.304L7.82,7.82z M16.181,7.819
      l-0.003,0.003c-0.351,0.351-0.377,0.897-0.09,1.303C16.662,9.939,17,10.931,17,12c0,1.069-0.338,2.061-0.913,2.875
      c-0.286,0.406-0.261,0.951,0.091,1.303l0.003,0.003c0.426,0.426,1.146,0.394,1.499-0.094C18.51,14.936,19,13.524,19,12
      c0-1.525-0.49-2.937-1.32-4.088C17.327,7.424,16.607,7.393,16.181,7.819z M12,9c-1.657,0-3,1.343-3,3s1.343,3,3,3s3-1.343,3-3
      S13.657,9,12,9z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-73': {
    element: [
      <path
        d="M5.54,8.46L2,12l3.54,3.54l1.76-1.77L5.54,12l1.76-1.77L5.54,8.46z M12,18.46l-1.77-1.76l-1.77,1.76L12,22l3.54-3.54
      l-1.77-1.76L12,18.46z M18.46,8.46l-1.76,1.77L18.46,12l-1.76,1.77l1.76,1.77L22,12L18.46,8.46z M8.46,5.54l1.77,1.76L12,5.54
      l1.77,1.76l1.77-1.76L12,2L8.46,5.54z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-74': {
    element: [
      <path
        d="M4,4v4l4-4H4z M16,4l4,4V4H16z M20,20v-4l-4,4H20z M4,20h4l-4-4V20z M19,12c0-3.87-3.13-7-7-7s-7,3.13-7,7s3.13,7,7,7
      S19,15.87,19,12z M12,17c-2.76,0-5-2.24-5-5s2.24-5,5-5s5,2.24,5,5S14.76,17,12,17z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-a': {
    element: [
      <path
        d="M12,2C6.489,2,2,6.489,2,12s4.489,10,10,10s10-4.489,10-10S17.511,2,12,2z M12,4c4.43,0,8,3.57,8,8s-3.57,8-8,8s-8-3.57-8-8
      S7.57,4,12,4z"
      />,
      <path
        d="M13.67,14.596h-3.339L9.696,16.5H7.671l3.44-9.242h1.765l3.459,9.242h-2.024L13.67,14.596z M10.845,13.053h2.311
        l-1.162-3.459L10.845,13.053z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-b': {
    element: [
      <path
        d="M12,2C6.489,2,2,6.489,2,12s4.489,10,10,10s10-4.489,10-10S17.511,2,12,2z M12,4c4.43,0,8,3.57,8,8s-3.57,8-8,8s-8-3.57-8-8
      S7.57,4,12,4z"
      />,
      <path
        d="M8.677,16.5V7.258h3.237c1.122,0,1.973,0.215,2.552,0.645c0.58,0.43,0.87,1.059,0.87,1.889c0,0.452-0.116,0.852-0.35,1.196
        c-0.232,0.345-0.557,0.598-0.971,0.759c0.474,0.118,0.847,0.357,1.12,0.717c0.272,0.359,0.409,0.8,0.409,1.32
        c0,0.889-0.283,1.562-0.851,2.019c-0.566,0.457-1.375,0.689-2.425,0.698H8.677z M10.581,11.13h1.409
        c0.961-0.017,1.441-0.399,1.441-1.149c0-0.418-0.122-0.72-0.365-0.904c-0.243-0.184-0.627-0.275-1.152-0.275h-1.333V11.13z
         M10.581,12.476v2.495h1.632c0.448,0,0.799-0.107,1.05-0.321c0.252-0.214,0.378-0.509,0.378-0.886c0-0.846-0.438-1.275-1.313-1.288
        H10.581z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-c': {
    element: [
      <path
        d="M12,2C6.489,2,2,6.489,2,12s4.489,10,10,10s10-4.489,10-10S17.511,2,12,2z M12,4c4.43,0,8,3.57,8,8s-3.57,8-8,8s-8-3.57-8-8
  S7.57,4,12,4z"
      />,
      <path
        d="M15.828,13.422c-0.072,0.994-0.439,1.777-1.102,2.348c-0.662,0.572-1.535,0.857-2.618,0.857
    c-1.186,0-2.117-0.398-2.797-1.196c-0.679-0.798-1.019-1.893-1.019-3.285V11.58c0-0.889,0.157-1.671,0.47-2.348
    c0.313-0.678,0.761-1.197,1.343-1.559c0.582-0.362,1.258-0.543,2.028-0.543c1.066,0,1.925,0.285,2.577,0.857
    c0.651,0.57,1.028,1.373,1.13,2.405h-1.904c-0.047-0.597-0.213-1.029-0.499-1.298c-0.285-0.269-0.72-0.403-1.304-0.403
    c-0.635,0-1.11,0.228-1.426,0.683c-0.315,0.455-0.477,1.16-0.485,2.117v0.697c0,0.999,0.151,1.729,0.454,2.19
    c0.302,0.461,0.779,0.692,1.432,0.692c0.588,0,1.027-0.135,1.316-0.403c0.29-0.269,0.456-0.685,0.499-1.247H15.828z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-d': {
    element: [
      <path
        d="M12,2C6.489,2,2,6.489,2,12s4.489,10,10,10s10-4.489,10-10S17.511,2,12,2z M12,4c4.43,0,8,3.57,8,8s-3.57,8-8,8s-8-3.57-8-8
      S7.57,4,12,4z"
      />,
      <path
        d="M8.866,16.5V7.258h2.844c0.812,0,1.539,0.183,2.181,0.549c0.641,0.366,1.142,0.887,1.501,1.562
        c0.36,0.675,0.54,1.442,0.54,2.302v0.425c0,0.859-0.177,1.623-0.53,2.292c-0.354,0.668-0.852,1.187-1.495,1.555
        c-0.643,0.368-1.369,0.555-2.177,0.559H8.866z M10.77,8.801v6.17h0.92c0.745,0,1.314-0.244,1.708-0.73s0.595-1.183,0.604-2.088
        v-0.489c0-0.939-0.195-1.651-0.584-2.136c-0.39-0.484-0.959-0.727-1.708-0.727H10.77z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-e': {
    element: [
      <path
        d="M12,2C6.489,2,2,6.489,2,12s4.489,10,10,10s10-4.489,10-10S17.511,2,12,2z M12,4c4.43,0,8,3.57,8,8s-3.57,8-8,8s-8-3.57-8-8
      S7.57,4,12,4z"
      />,
      <path d="M14.729,12.494h-3.656v2.477h4.291V16.5H9.169V7.258h6.183v1.543h-4.278v2.202h3.656V12.494z" />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-f': {
    element: [
      <path
        d="M12,2C6.489,2,2,6.489,2,12s4.489,10,10,10s10-4.489,10-10S17.511,2,12,2z M12,4c4.43,0,8,3.57,8,8s-3.57,8-8,8s-8-3.57-8-8
      S7.57,4,12,4z"
      />,
      <path d="M14.825,12.723h-3.656V16.5H9.265V7.258h6.018v1.543h-4.113v2.387h3.656V12.723z" />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-g': {
    element: [
      <path
        d="M12,2C6.489,2,2,6.489,2,12s4.489,10,10,10s10-4.489,10-10S17.511,2,12,2z M12,4c4.43,0,8,3.57,8,8s-3.57,8-8,8s-8-3.57-8-8
  S7.57,4,12,4z"
      />,
      <path
        d="M15.71,15.332c-0.343,0.41-0.827,0.729-1.453,0.955c-0.627,0.227-1.32,0.34-2.082,0.34c-0.8,0-1.502-0.175-2.104-0.523
    c-0.604-0.35-1.069-0.856-1.396-1.521c-0.328-0.664-0.497-1.445-0.505-2.343v-0.628c0-0.923,0.155-1.722,0.467-2.396
    c0.311-0.675,0.759-1.191,1.346-1.549c0.586-0.357,1.272-0.536,2.06-0.536c1.097,0,1.953,0.262,2.571,0.784
    c0.617,0.522,0.983,1.283,1.098,2.282h-1.854c-0.084-0.529-0.271-0.917-0.562-1.162s-0.688-0.368-1.196-0.368
    c-0.648,0-1.141,0.243-1.479,0.729c-0.338,0.487-0.51,1.211-0.514,2.172v0.59c0,0.969,0.184,1.701,0.552,2.196
    s0.908,0.743,1.619,0.743c0.715,0,1.225-0.152,1.529-0.457v-1.594h-1.732v-1.402h3.637V15.332z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-h': {
    element: [
      <path
        d="M12,2C6.489,2,2,6.489,2,12s4.489,10,10,10s10-4.489,10-10S17.511,2,12,2z M12,4c4.43,0,8,3.57,8,8s-3.57,8-8,8s-8-3.57-8-8
  S7.57,4,12,4z"
      />,
      <path d="M15.754,16.5H13.85v-3.961h-3.713V16.5H8.232V7.258h1.904v3.745h3.713V7.258h1.904V16.5z" />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-i': {
    element: [
      <path
        d="M12,2C6.489,2,2,6.489,2,12s4.489,10,10,10s10-4.489,10-10S17.511,2,12,2z M12,4c4.43,0,8,3.57,8,8s-3.57,8-8,8s-8-3.57-8-8
      S7.57,4,12,4z"
      />,
      <path d="M12.956,16.5h-1.905V7.258h1.905V16.5z" />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-j': {
    element: [
      <path
        d="M12,2C6.489,2,2,6.489,2,12s4.489,10,10,10s10-4.489,10-10S17.511,2,12,2z M12,4c4.43,0,8,3.57,8,8s-3.57,8-8,8s-8-3.57-8-8
      S7.57,4,12,4z"
      />,
      <path
        d="M12.92,7.258h1.904v6.398c0,0.588-0.13,1.107-0.39,1.559c-0.261,0.45-0.628,0.799-1.102,1.044
        c-0.475,0.245-1.01,0.368-1.606,0.368c-0.978,0-1.739-0.249-2.285-0.746s-0.819-1.2-0.819-2.11h1.917
        c0,0.453,0.095,0.787,0.286,1.003s0.491,0.324,0.901,0.324c0.364,0,0.654-0.125,0.87-0.375s0.323-0.605,0.323-1.066V7.258z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-k': {
    element: [
      <path
        d="M12,2C6.489,2,2,6.489,2,12s4.489,10,10,10s10-4.489,10-10S17.511,2,12,2z M12,4c4.43,0,8,3.57,8,8s-3.57,8-8,8s-8-3.57-8-8
      S7.57,4,12,4z"
      />,
      <path
        d="M11.594,12.793l-0.99,1.066V16.5H8.699V7.258h1.904v4.189l0.838-1.148l2.354-3.041h2.343l-3.282,4.107l3.377,5.135h-2.266
        L11.594,12.793z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-l': {
    element: [
      <path
        d="M12,2C6.489,2,2,6.489,2,12s4.489,10,10,10s10-4.489,10-10S17.511,2,12,2z M12,4c4.43,0,8,3.57,8,8s-3.57,8-8,8s-8-3.57-8-8
      S7.57,4,12,4z"
      />,
      <path d="M11.21,14.971h4.044V16.5H9.306V7.258h1.904V14.971z" />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-m': {
    element: [
      <path
        d="M12,2C6.489,2,2,6.489,2,12s4.489,10,10,10s10-4.489,10-10S17.511,2,12,2z M12,4c4.43,0,8,3.57,8,8s-3.57,8-8,8s-8-3.57-8-8
      S7.57,4,12,4z"
      />,
      <path
        d="M9.62,7.258l2.374,6.703l2.361-6.703h2.501V16.5h-1.911v-2.526l0.19-4.36L12.642,16.5h-1.308L8.846,9.619l0.19,4.354V16.5
        H7.132V7.258H9.62z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-n': {
    element: [
      <path
        d="M12,2C6.489,2,2,6.489,2,12s4.489,10,10,10s10-4.489,10-10S17.511,2,12,2z M12,4c4.43,0,8,3.57,8,8s-3.57,8-8,8s-8-3.57-8-8
      S7.57,4,12,4z"
      />,
      <path d="M15.751,16.5h-1.904l-3.707-6.081V16.5H8.235V7.258h1.904l3.714,6.094V7.258h1.897V16.5z" />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-o': {
    element: [
      <path
        d="M12,2C6.489,2,2,6.489,2,12s4.489,10,10,10s10-4.489,10-10S17.511,2,12,2z M12,4c4.43,0,8,3.57,8,8s-3.57,8-8,8s-8-3.57-8-8
      S7.57,4,12,4z"
      />,
      <path
        d="M15.929,12.088c0,0.91-0.161,1.708-0.482,2.394c-0.322,0.686-0.782,1.215-1.381,1.587s-1.285,0.559-2.06,0.559
        c-0.766,0-1.449-0.184-2.05-0.553c-0.601-0.367-1.066-0.894-1.396-1.577s-0.497-1.47-0.501-2.358v-0.457
        c0-0.909,0.164-1.71,0.492-2.402c0.328-0.691,0.791-1.223,1.39-1.593c0.599-0.37,1.284-0.556,2.054-0.556
        c0.77,0,1.454,0.186,2.054,0.556c0.599,0.37,1.062,0.901,1.39,1.593c0.328,0.692,0.492,1.491,0.492,2.396V12.088z M13.999,11.67
        c0-0.97-0.174-1.706-0.521-2.209c-0.348-0.504-0.843-0.756-1.485-0.756c-0.639,0-1.132,0.249-1.479,0.746s-0.522,1.226-0.527,2.187
        v0.45c0,0.944,0.173,1.676,0.521,2.197c0.347,0.52,0.846,0.78,1.498,0.78c0.639,0,1.13-0.251,1.473-0.752
        c0.343-0.502,0.516-1.232,0.521-2.193V11.67z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-p': {
    element: [
      <path
        d="M12,2C6.489,2,2,6.489,2,12s4.489,10,10,10s10-4.489,10-10S17.511,2,12,2z M12,4c4.43,0,8,3.57,8,8s-3.57,8-8,8s-8-3.57-8-8
      S7.57,4,12,4z"
      />,
      <path
        d="M10.537,13.244V16.5H8.633V7.258h3.605c0.693,0,1.305,0.127,1.831,0.381c0.527,0.254,0.932,0.614,1.216,1.082
        c0.283,0.468,0.425,1,0.425,1.597c0,0.905-0.31,1.62-0.93,2.143s-1.478,0.784-2.574,0.784H10.537z M10.537,11.701h1.701
        c0.503,0,0.888-0.118,1.152-0.355c0.264-0.237,0.396-0.575,0.396-1.016c0-0.453-0.134-0.818-0.4-1.098s-0.635-0.424-1.104-0.432
        h-1.745V11.701z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-q': {
    element: [
      <path
        d="M12,2C6.489,2,2,6.489,2,12s4.489,10,10,10s10-4.489,10-10S17.511,2,12,2z M12,4c4.43,0,8,3.57,8,8s-3.57,8-8,8s-8-3.57-8-8
      S7.57,4,12,4z"
      />,
      <path
        d="M15.916,12.088c0,0.863-0.14,1.614-0.419,2.251s-0.667,1.147-1.162,1.532l1.536,1.207l-1.212,1.072l-1.968-1.58
        c-0.225,0.037-0.457,0.057-0.698,0.057c-0.766,0-1.449-0.184-2.05-0.553c-0.601-0.367-1.066-0.894-1.396-1.577
        s-0.497-1.47-0.501-2.358v-0.457c0-0.909,0.164-1.71,0.492-2.402c0.328-0.691,0.791-1.223,1.39-1.593
        c0.599-0.37,1.284-0.556,2.054-0.556c0.77,0,1.454,0.186,2.054,0.556c0.599,0.37,1.062,0.901,1.39,1.593
        c0.328,0.692,0.492,1.491,0.492,2.396V12.088z M13.986,11.67c0-0.97-0.174-1.706-0.521-2.209c-0.348-0.504-0.843-0.756-1.485-0.756
        c-0.639,0-1.132,0.249-1.479,0.746s-0.522,1.226-0.527,2.187v0.45c0,0.944,0.173,1.676,0.521,2.197
        c0.347,0.52,0.846,0.78,1.498,0.78c0.639,0,1.13-0.251,1.473-0.752c0.343-0.502,0.516-1.232,0.521-2.193V11.67z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-r': {
    element: [
      <path
        d="M12,2C6.489,2,2,6.489,2,12s4.489,10,10,10s10-4.489,10-10S17.511,2,12,2z M12,4c4.43,0,8,3.57,8,8s-3.57,8-8,8s-8-3.57-8-8
      S7.57,4,12,4z"
      />,
      <path
        d="M12.099,13.117h-1.518V16.5H8.677V7.258h3.435c1.092,0,1.934,0.243,2.526,0.73c0.592,0.486,0.889,1.174,0.889,2.062
        c0,0.631-0.137,1.156-0.41,1.577c-0.272,0.421-0.687,0.757-1.24,1.007l1.999,3.776V16.5h-2.044L12.099,13.117z M10.581,11.574
        h1.536c0.479,0,0.849-0.122,1.111-0.365c0.262-0.243,0.394-0.578,0.394-1.006c0-0.436-0.124-0.778-0.372-1.028
        c-0.247-0.25-0.627-0.374-1.139-0.374h-1.53V11.574z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-s': {
    element: [
      <path
        d="M12,2C6.489,2,2,6.489,2,12s4.489,10,10,10s10-4.489,10-10S17.511,2,12,2z M12,4c4.43,0,8,3.57,8,8s-3.57,8-8,8s-8-3.57-8-8
  S7.57,4,12,4z"
      />,
      <path
        d="M13.621,14.075c0-0.359-0.127-0.636-0.381-0.828s-0.711-0.396-1.371-0.609c-0.66-0.214-1.183-0.425-1.568-0.632
    c-1.049-0.567-1.574-1.331-1.574-2.291c0-0.5,0.141-0.945,0.422-1.337c0.282-0.392,0.686-0.697,1.213-0.917
    c0.526-0.22,1.118-0.33,1.773-0.33c0.66,0,1.249,0.119,1.765,0.358c0.517,0.239,0.918,0.577,1.203,1.013
    c0.286,0.436,0.429,0.931,0.429,1.485h-1.904c0-0.423-0.134-0.752-0.4-0.987c-0.267-0.234-0.641-0.352-1.123-0.352
    c-0.465,0-0.827,0.098-1.085,0.295c-0.258,0.196-0.387,0.456-0.387,0.777c0,0.301,0.151,0.553,0.454,0.756
    c0.302,0.203,0.748,0.393,1.336,0.57c1.083,0.326,1.872,0.73,2.367,1.213s0.743,1.083,0.743,1.803c0,0.8-0.303,1.427-0.908,1.882
    c-0.604,0.455-1.42,0.683-2.443,0.683c-0.711,0-1.358-0.13-1.942-0.391c-0.584-0.26-1.029-0.616-1.336-1.069
    c-0.307-0.453-0.46-0.978-0.46-1.574h1.911c0,1.02,0.609,1.53,1.828,1.53c0.452,0,0.806-0.093,1.06-0.276
    C13.494,14.662,13.621,14.405,13.621,14.075z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-t': {
    element: [
      <path
        d="M12,2C6.489,2,2,6.489,2,12s4.489,10,10,10s10-4.489,10-10S17.511,2,12,2z M12,4c4.43,0,8,3.57,8,8s-3.57,8-8,8s-8-3.57-8-8
      S7.57,4,12,4z"
      />,
      <path d="M15.761,8.801H12.93V16.5h-1.904V8.801H8.232V7.258h7.528V8.801z" />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-u': {
    element: [
      <path
        d="M12,2C6.489,2,2,6.489,2,12s4.489,10,10,10s10-4.489,10-10S17.511,2,12,2z M12,4c4.43,0,8,3.57,8,8s-3.57,8-8,8s-8-3.57-8-8
      S7.57,4,12,4z"
      />,
      <path
        d="M15.542,7.258v6.088c0,1.011-0.316,1.811-0.949,2.398c-0.632,0.589-1.496,0.883-2.593,0.883
        c-1.079,0-1.936-0.285-2.571-0.857c-0.635-0.57-0.958-1.355-0.971-2.354V7.258h1.904v6.1c0,0.605,0.145,1.047,0.435,1.324
        c0.29,0.277,0.691,0.416,1.203,0.416c1.071,0,1.614-0.563,1.632-1.689v-6.15H15.542z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-v': {
    element: [
      <path
        d="M12,2C6.489,2,2,6.489,2,12s4.489,10,10,10s10-4.489,10-10S17.511,2,12,2z M12,4c4.43,0,8,3.57,8,8s-3.57,8-8,8s-8-3.57-8-8
      S7.57,4,12,4z"
      />,
      <path d="M11.99,14.209l2.095-6.951h2.12L12.986,16.5H11L7.794,7.258h2.114L11.99,14.209z" />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-w': {
    element: [
      <path
        d="M12,2C6.489,2,2,6.489,2,12s4.489,10,10,10s10-4.489,10-10S17.511,2,12,2z M12,4c4.43,0,8,3.57,8,8s-3.57,8-8,8s-8-3.57-8-8
      S7.57,4,12,4z"
      />,
      <path
        d="M14.339,13.834l1.244-6.576h1.897l-2.05,9.242h-1.917l-1.505-6.183L10.505,16.5H8.588l-2.05-9.242h1.898l1.25,6.563
        l1.523-6.563h1.612L14.339,13.834z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-x': {
    element: [
      <path
        d="M12,2C6.489,2,2,6.489,2,12s4.489,10,10,10s10-4.489,10-10S17.511,2,12,2z M12,4c4.43,0,8,3.57,8,8s-3.57,8-8,8s-8-3.57-8-8
      S7.57,4,12,4z"
      />,
      <path
        d="M12.004,10.444l1.732-3.187h2.19l-2.691,4.583l2.761,4.659h-2.215l-1.777-3.237L10.226,16.5H8.011l2.761-4.659L8.081,7.258
        h2.19L12.004,10.444z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-y': {
    element: [
      <path
        d="M12,2C6.489,2,2,6.489,2,12s4.489,10,10,10s10-4.489,10-10S17.511,2,12,2z M12,4c4.43,0,8,3.57,8,8s-3.57,8-8,8s-8-3.57-8-8
      S7.57,4,12,4z"
      />,
      <path d="M11.994,11.422l1.923-4.164h2.082l-3.034,5.891V16.5h-1.936v-3.352L7.995,7.258h2.088L11.994,11.422z" />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-z': {
    element: [
      <path
        d="M12,2C6.489,2,2,6.489,2,12s4.489,10,10,10s10-4.489,10-10S17.511,2,12,2z M12,4c4.43,0,8,3.57,8,8s-3.57,8-8,8s-8-3.57-8-8
      S7.57,4,12,4z"
      />,
      <path d="M10.905,14.971h4.659V16.5h-7.04v-1.117l4.57-6.582H8.531V7.258h6.932V8.35L10.905,14.971z" />,
    ],
    viewBox: '0 0 24 24',
  },
  link: {
    element: [
      <path
        d="M12.707,15.293c-1.068,0-2.073-0.416-2.828-1.172c-0.391-0.391-0.391-1.023,0-1.414s1.023-0.391,1.414,0
      c0.756,0.756,2.072,0.756,2.828,0l2.829-2.828c0.779-0.78,0.779-2.049,0-2.829c-0.756-0.755-2.072-0.757-2.829,0
      c-0.391,0.391-1.023,0.391-1.414,0s-0.391-1.023,0-1.414c1.56-1.559,4.096-1.561,5.657,0c1.559,1.559,1.559,4.097,0,5.657
      l-2.829,2.828C14.78,14.877,13.775,15.293,12.707,15.293z"
      />,
      <path
        d="M8.464,19.533c-1.024,0-2.048-0.39-2.828-1.169c-0.756-0.756-1.172-1.76-1.172-2.829c0-1.068,0.416-2.072,1.172-2.828
      l2.828-2.828c1.511-1.512,4.145-1.512,5.657,0c0.391,0.391,0.391,1.023,0,1.414s-1.023,0.391-1.414,0
      c-0.756-0.757-2.074-0.756-2.829,0L7.05,14.121c-0.78,0.78-0.78,2.049,0,2.829c0.779,0.779,2.048,0.779,2.829,0
      c0.391-0.391,1.024-0.391,1.415,0c0.39,0.391,0.39,1.024,0,1.414C10.513,19.144,9.489,19.533,8.464,19.533z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  manage: {
    element: [
      <path
        d="M21,15.184V13v-1c0-0.552-0.448-1-1-1h-7V7.816C14.161,7.401,15,6.302,15,5c0-1.654-1.346-3-3-3S9,3.346,9,5
      c0,1.302,0.839,2.401,2,2.816V11H4c-0.552,0-1,0.448-1,1v1v2.184C1.839,15.599,1,16.698,1,18c0,1.654,1.346,3,3,3s3-1.346,3-3
      c0-1.302-0.839-2.401-2-2.816V13h6v2.184C9.839,15.599,9,16.698,9,18c0,1.654,1.346,3,3,3s3-1.346,3-3c0-1.302-0.839-2.401-2-2.816
      V13h6v2.184c-1.161,0.414-2,1.514-2,2.816c0,1.654,1.346,3,3,3s3-1.346,3-3C23,16.698,22.161,15.599,21,15.184z M12,4
      c0.551,0,1,0.449,1,1s-0.449,1-1,1s-1-0.449-1-1S11.449,4,12,4z M4,19c-0.551,0-1-0.448-1-1s0.449-1,1-1s1,0.448,1,1S4.551,19,4,19z
       M12,19c-0.551,0-1-0.448-1-1s0.449-1,1-1s1,0.448,1,1S12.551,19,12,19z M20,19c-0.552,0-1-0.448-1-1s0.448-1,1-1s1,0.448,1,1
      S20.552,19,20,19z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  page: {
    element: [
      <path
        d="M14,2H6C4.9,2,4.01,2.9,4.01,4L4,20c0,1.1,0.89,2,1.99,2H18c1.1,0,2-0.9,2-2V8L14,2z M6,20V4h7v4c0,0.552,0.448,1,1,1h4v11
      H6z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  plan: {
    element: [
      <path
        d="M20.5,3l-0.16,0.03L15,5.1L9,3L3.36,4.9C3.15,4.97,3,5.15,3,5.38V20.5C3,20.78,3.22,21,3.5,21l0.16-0.03L9,18.9l6,2.1
      l5.64-1.9c0.21-0.07,0.36-0.25,0.36-0.48V3.5C21,3.22,20.78,3,20.5,3z M10,5.47l4,1.4v11.66l-4-1.4V5.47z M5,6.46l3-1.01v11.7
      l-3,1.16V6.46z M19,17.54l-3,1.01V6.86l3-1.16V17.54z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  welcome: {
    element: [
      <path
        d="M11.99,2C6.47,2,2,6.48,2,12s4.47,10,9.99,10C17.52,22,22,17.52,22,12S17.52,2,11.99,2z M18.92,8h-2.95
      c-0.32-1.25-0.78-2.45-1.38-3.56C16.43,5.07,17.96,6.35,18.92,8z M12,4.04c0.83,1.2,1.48,2.53,1.91,3.96h-3.82
      C10.52,6.57,11.17,5.24,12,4.04z M4.26,14C4.1,13.36,4,12.69,4,12s0.1-1.36,0.26-2h3.38c-0.08,0.66-0.14,1.32-0.14,2
      s0.06,1.34,0.14,2H4.26z M5.08,16h2.95c0.32,1.25,0.78,2.45,1.38,3.56C7.57,18.93,6.04,17.66,5.08,16z M8.03,8H5.08
      c0.96-1.66,2.49-2.93,4.33-3.56C8.81,5.55,8.35,6.75,8.03,8z M12,19.96c-0.83-1.2-1.48-2.53-1.91-3.96h3.82
      C13.48,17.43,12.83,18.76,12,19.96z M14.34,14H9.66c-0.09-0.66-0.16-1.32-0.16-2s0.07-1.35,0.16-2h4.68c0.09,0.65,0.16,1.32,0.16,2
      S14.43,13.34,14.34,14z M14.59,19.56c0.6-1.11,1.06-2.31,1.38-3.56h2.95C17.96,17.65,16.43,18.93,14.59,19.56z M16.36,14
      c0.08-0.66,0.14-1.32,0.14-2s-0.06-1.34-0.14-2h3.38C19.9,10.64,20,11.31,20,12s-0.1,1.36-0.26,2H16.36z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
};

const googleIcons = {
  ...socialNavIcons,
  browse: {
    element: [
      <path d="M19,5v4H5V5H19 M20,3H4C3.448,3,3,3.448,3,4v6c0,0.552,0.448,1,1,1h16c0.552,0,1-0.448,1-1V4C21,3.448,20.552,3,20,3L20,3z" />,
      <path
        d="M19,15v4H5v-4H19 M20,13H4c-0.552,0-1,0.448-1,1v6c0,0.552,0.448,1,1,1h16c0.552,0,1-0.448,1-1v-6
  C21,13.448,20.552,13,20,13L20,13z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  category: {
    element: [
      <path
        d="M19,5v14H5V5H19 M19,3H5C3.895,3,3,3.895,3,5v14c0,1.105,0.895,2,2,2h14c1.105,0,2-0.895,2-2V5C21,3.895,20.105,3,19,3L19,3
      z M17,7H7v2h10V7L17,7z M17,11H7v2h10V11L17,11z M17,15H7v2h10V15L17,15z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  discover: {
    element: [
      <path
        d="M15.5,14h-0.79l-0.28-0.27C15.41,12.59,16,11.11,16,9.5C16,5.91,13.09,3,9.5,3S3,5.91,3,9.5S5.91,16,9.5,16
      c1.61,0,3.09-0.59,4.23-1.57L14,14.71v0.79l5,4.99L20.49,19L15.5,14z M9.5,14C7.01,14,5,11.99,5,9.5S7.01,5,9.5,5S14,7.01,14,9.5
      S11.99,14,9.5,14z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  events: {
    element: [
      <path
        d="M19,3h-1V1h-2v2H8V1H6v2H5C3.895,3,3,3.895,3,5v14c0,1.105,0.895,2,2,2h14c1.103-0.003,1.997-0.897,2-2V5
      C20.997,3.897,20.103,3.003,19,3z M19,19H5V8h14V19z M9,9.5c-1.381,0-2.5,1.119-2.5,2.5s1.119,2.5,2.5,2.5s2.5-1.119,2.5-2.5
      S10.381,9.5,9,9.5z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  help: {
    element: [
      <path
        d="M11,18h2v-2h-2V18z M12,2C6.48,2,2,6.48,2,12s4.48,10,10,10s10-4.48,10-10S17.52,2,12,2z M12,20c-4.41,0-8-3.59-8-8
      s3.59-8,8-8s8,3.59,8,8S16.41,20,12,20z M12,6c-2.21,0-4,1.79-4,4h2c0-1.1,0.9-2,2-2s2,0.9,2,2c0,2-3,1.75-3,5h2c0-2.25,3-2.5,3-5
      C16,7.79,14.21,6,12,6z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  home: {
    element: [<path d="M12,3L4,9v12h16V9L12,3z M18,19h-3v-6H9v6H6v-9l6-4.5l6,4.5V19z" />],
    viewBox: '0 0 24 24',
  },
  ic_play_arrow_black: {
    element: [<path d="M8,5v14l11-7L8,5z" />],
    viewBox: '0 0 24 24',
  },
  ic_play_circle_filled_black: {
    element: [
      <path d="M12,2C6.48,2,2,6.48,2,12s4.48,10,10,10s10-4.48,10-10S17.52,2,12,2z M10,16.5v-9l6,4.5L10,16.5z" />,
    ],
    viewBox: '0 0 24 24',
  },
  ic_play_circle_outline_black: {
    element: [
      <path
        d="M10,16.5l6-4.5l-6-4.5V16.5z M12,2C6.48,2,2,6.48,2,12s4.48,10,10,10s10-4.48,10-10S17.52,2,12,2z M12,20
      c-4.41,0-8-3.59-8-8s3.59-8,8-8s8,3.59,8,8S16.41,20,12,20z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  ic_playlist_play_black: {
    element: [<path d="M4,10h12v2H4V10z M4,6h12v2H4V6z M4,14h8v2H4V14z M14,14v6l5-3L14,14z" />],
    viewBox: '0 0 24 24',
  },
  live_events: {
    element: [
      <path d="M6.75 6.5V12.5L12 9.5L6.75 6.5ZM15.75 3.5H10.065L12.5325 1.0325L12 0.5L9 3.5H8.9775L5.9775 0.5L5.46 1.0325L7.92 3.5H2.25C1.425 3.5 0.75 4.175 0.75 5V14C0.75 14.825 1.425 15.5 2.25 15.5H15.75C16.575 15.5 17.25 14.825 17.25 14V5C17.25 4.175 16.575 3.5 15.75 3.5ZM15.75 14H2.25V5H15.75V14Z" />,
    ],
    viewBox: '0 0 18 16',
  },
  my_learning: {
    element: [
      <path d="M3 17.15V10C3 9.46667 3.19583 9.01667 3.5875 8.65C3.97917 8.28333 4.44167 8.11667 4.975 8.15C6.29167 8.35 7.54583 8.7375 8.7375 9.3125C9.92917 9.8875 11.0167 10.6333 12 11.55C12.9833 10.6333 14.0708 9.8875 15.2625 9.3125C16.4542 8.7375 17.7083 8.35 19.025 8.15C19.5583 8.11667 20.0208 8.28333 20.4125 8.65C20.8042 9.01667 21 9.46667 21 10V17.15C21 17.6833 20.825 18.1375 20.475 18.5125C20.125 18.8875 19.6833 19.0917 19.15 19.125C18.0833 19.2917 17.05 19.5667 16.05 19.95C15.05 20.3333 14.1167 20.8417 13.25 21.475C13.0667 21.625 12.8708 21.7375 12.6625 21.8125C12.4542 21.8875 12.2333 21.925 12 21.925C11.7667 21.925 11.5458 21.8875 11.3375 21.8125C11.1292 21.7375 10.9333 21.625 10.75 21.475C9.88333 20.8417 8.95 20.3333 7.95 19.95C6.95 19.5667 5.91667 19.2917 4.85 19.125C4.31667 19.0917 3.875 18.8875 3.525 18.5125C3.175 18.1375 3 17.6833 3 17.15ZM12 19.9C13.05 19.1167 14.1667 18.4917 15.35 18.025C16.5333 17.5583 17.75 17.25 19 17.1V10.2C17.7833 10.4167 16.5875 10.8542 15.4125 11.5125C14.2375 12.1708 13.1 13.05 12 14.15C10.9 13.05 9.7625 12.1708 8.5875 11.5125C7.4125 10.8542 6.21667 10.4167 5 10.2V17.1C6.25 17.25 7.46667 17.5583 8.65 18.025C9.83333 18.4917 10.95 19.1167 12 19.9ZM12 9C10.9 9 9.95833 8.60833 9.175 7.825C8.39167 7.04167 8 6.1 8 5C8 3.9 8.39167 2.95833 9.175 2.175C9.95833 1.39167 10.9 1 12 1C13.1 1 14.0417 1.39167 14.825 2.175C15.6083 2.95833 16 3.9 16 5C16 6.1 15.6083 7.04167 14.825 7.825C14.0417 8.60833 13.1 9 12 9ZM12 7C12.55 7 13.0208 6.80417 13.4125 6.4125C13.8042 6.02083 14 5.55 14 5C14 4.45 13.8042 3.97917 13.4125 3.5875C13.0208 3.19583 12.55 3 12 3C11.45 3 10.9792 3.19583 10.5875 3.5875C10.1958 3.97917 10 4.45 10 5C10 5.55 10.1958 6.02083 10.5875 6.4125C10.9792 6.80417 11.45 7 12 7Z" />,
    ],
    viewBox: '0 0 24 24',
  },
  videos: {
    element: [
      <path d="M10 16.5l6-4.5-6-4.5v9zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z" />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-01': {
    element: [
      <path
        d="M20,11V7c0-1.1-0.9-2-2-2h-4c0-1.38-1.12-2.5-2.5-2.5S9,3.62,9,5H5C3.9,5,3.01,5.9,3.01,7v3.8H3.3c1.49,0,2.7,1.21,2.7,2.7
      s-1.21,2.7-2.7,2.7H3V20c0,1.1,0.9,2,2,2h3.8v-0.3c0-1.49,1.21-2.7,2.7-2.7s2.7,1.21,2.7,2.7V22H18c1.1,0,2-0.9,2-2v-4
      c1.38,0,2.5-1.12,2.5-2.5S21.38,11,20,11z M18,20h-2.12c-0.68-1.75-2.39-3-4.38-3s-3.7,1.25-4.38,3H5v-2.12c1.75-0.68,3-2.39,3-4.38
      S6.76,9.8,5.01,9.12L5,7h5h1h1h1h5v5v1v1v1V20z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-02': {
    element: [
      <path
        d="M9,21c0,0.552,0.448,1,1,1h4c0.552,0,1-0.448,1-1v-1H9V21z M12,2C8.134,2.004,5.003,5.141,5.006,9.007
    C5.008,11.292,6.126,13.432,8,14.74V17c0,0.552,0.448,1,1,1h6c0.552,0,1-0.448,1-1v-2.26c3.17-2.213,3.946-6.576,1.733-9.747
    C16.425,3.12,14.285,2.002,12,2z M14.85,13.1L14,13.7V16h-4v-2.3l-0.85-0.6c-2.269-1.574-2.832-4.689-1.258-6.958
    s4.689-2.832,6.958-1.258s2.832,4.689,1.258,6.958C15.767,12.333,15.341,12.759,14.85,13.1z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-03': {
    element: [
      <path
        d="M12,2C6.48,2,2,6.48,2,12s4.48,10,10,10s10-4.48,10-10S17.52,2,12,2z M12,20c-4.41,0-8-3.59-8-8s3.59-8,8-8s8,3.59,8,8
  S16.41,20,12,20z M16.59,7.58L10,14.17l-2.59-2.58L6,13l4,4l8-8L16.59,7.58z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-04': {
    element: [
      <path
        d="M20.71,5.63l-2.34-2.34C18.17,3.09,17.92,3,17.66,3c-0.25,0-0.51,0.1-0.7,0.29L3,17.25V21h3.75L20.71,7.04
  C21.1,6.65,21.1,6.02,20.71,5.63z M5.92,19H5v-0.92L16.545,6.535l0.92,0.92L5.92,19z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-05': {
    element: [
      <path
        d="M6,2C4.906,2,4,2.906,4,4v16c0,1.094,0.906,2,2,2h12c1.094,0,2-0.906,2-2V8l-6-6H6z M6,4h7v5h5v11H6V4z M8,12v2h8v-2H8z
      M8,16v2h8v-2H8z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-06': {
    element: [
      <path
        d="M20,8h-2.81c-0.45-0.78-1.07-1.45-1.82-1.96L17,4.41L15.59,3l-2.17,2.17C12.96,5.06,12.49,5,12,5s-0.96,0.06-1.41,0.17
      L8.41,3L7,4.41l1.62,1.63C7.88,6.55,7.26,7.22,6.81,8H4v2h2.09C6.04,10.33,6,10.66,6,11v1H4v2h2v1c0,0.34,0.04,0.67,0.09,1H4v2h2.81
      c1.04,1.79,2.97,3,5.19,3s4.15-1.21,5.19-3H20v-2h-2.09c0.05-0.33,0.09-0.66,0.09-1v-1h2v-2h-2v-1c0-0.34-0.04-0.67-0.09-1H20V8z
       M16,12v3c0,0.22-0.03,0.47-0.07,0.7l-0.1,0.65L15.46,17c-0.72,1.24-2.04,2-3.46,2s-2.74-0.77-3.46-2l-0.37-0.64l-0.1-0.65
      C8.03,15.48,8,15.23,8,15v-4c0-0.23,0.03-0.48,0.07-0.7l0.1-0.65L8.54,9c0.3-0.52,0.72-0.97,1.21-1.31l0.57-0.39l0.74-0.18
      C11.37,7.04,11.69,7,12,7c0.32,0,0.63,0.04,0.95,0.12l0.68,0.16l0.61,0.42c0.5,0.34,0.91,0.78,1.21,1.31l0.38,0.65l0.1,0.65
      C15.97,10.53,16,10.78,16,11C16,11,16,12,16,12z M10,14h4v2h-4V14z M10,10h4v2h-4V10z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-07': {
    element: [
      <path
        d="M11.99,2C6.47,2,2,6.48,2,12s4.47,10,9.99,10C17.52,22,22,17.52,22,12S17.52,2,11.99,2z M12,20c-4.42,0-8-3.58-8-8
      s3.58-8,8-8s8,3.58,8,8S16.42,20,12,20z M12.5,7H11v6l5.25,3.15L17,14.92l-4.5-2.67V7z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-08': {
    element: [
      <path
        d="M21.383,17.852l-6.87-6.87l0.05-0.05c1.324-3.337-0.308-7.115-3.645-8.439C8.845,1.671,6.495,1.968,4.693,3.282l1.45,1.45
    l0.72,0.72l1.67,1.66l-1.42,1.42l-1.67-1.67l-0.71-0.72l-1.45-1.443c-2.115,2.894-1.484,6.955,1.411,9.071
    c1.772,1.295,4.077,1.607,6.129,0.829l0.13-0.12l6.9,6.9c0.781,0.781,2.047,0.782,2.828,0.002c0.001-0.001,0.001-0.001,0.002-0.002
    l0.71-0.71C22.164,19.886,22.159,18.629,21.383,17.852z M5.353,11.712c-0.899-0.904-1.371-2.147-1.3-3.42l3.06,3.06l4.24-4.24
    L8.3,4.052c2.479-0.13,4.594,1.774,4.725,4.253c0.13,2.479-1.774,4.594-4.253,4.725c-1.276,0.067-2.52-0.412-3.421-1.318H5.353z"
      />,
    ],
    viewBox: '0 0 24 24',
  },

  'icon-09': {
    element: [
      <path
        d="M19,19H5V5h7V3H5C3.89,3,3,3.9,3,5v14c0,1.1,0.89,2,2,2h14c1.1,0,2-0.9,2-2v-7h-2V19z M14,3v2h3.59l-9.83,9.83l1.41,1.41
      L19,6.41V10h2V3H14z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-10': {
    element: [<path d="M21,5H3v2h18V5z M21,9H3v2h18V9z M21,13H3v6h18V13z" />],
    viewBox: '0 0 24 24',
  },
  'icon-11': {
    element: [
      <path d="M17,3H7C5.9,3,5,3.9,5,5v16l7-3l7,3V5C19,3.9,18.1,3,17,3z M17,18l-5-2.18L7,18V5h10V18z" />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-12': {
    element: [
      <path
        d="M19,5v14H5V5H19 M19,3H5C3.897,3.003,3.003,3.897,3,5v14c0.003,1.103,0.897,1.997,2,2h14c1.103-0.003,1.997-0.897,2-2V5
      C20.997,3.897,20.103,3.003,19,3z M14,17H7v-2h7V17z M17,13H7v-2h10V13z M17,9H7V7h10V9z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-13': {
    element: [
      <path
        d="M12,6c1.1,0,2,0.9,2,2s-0.9,2-2,2s-2-0.9-2-2S10.9,6,12,6 M12,15c2.7,0,5.8,1.29,6,2v1H6v-0.99C6.2,16.29,9.3,15,12,15
      M12,4C9.79,4,8,5.79,8,8s1.79,4,4,4s4-1.79,4-4S14.21,4,12,4z M12,13c-2.67,0-8,1.34-8,4v3h16v-3C20,14.34,14.67,13,12,13z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-14': {
    element: [
      <path
        d="M12,2C6.48,2,2,6.48,2,12s4.48,10,10,10s10-4.48,10-10S17.52,2,12,2z M7.07,18.28c0.43-0.9,3.05-1.78,4.93-1.78
      s4.51,0.88,4.93,1.78C15.57,19.36,13.86,20,12,20S8.43,19.36,7.07,18.28z M18.36,16.83c-1.43-1.74-4.9-2.33-6.36-2.33
      s-4.93,0.59-6.36,2.33C4.62,15.49,4,13.82,4,12c0-4.41,3.59-8,8-8s8,3.59,8,8C20,13.82,19.38,15.49,18.36,16.83z M12,6
      c-1.94,0-3.5,1.56-3.5,3.5S10.06,13,12,13s3.5-1.56,3.5-3.5S13.94,6,12,6z M12,11c-0.83,0-1.5-0.67-1.5-1.5S11.17,8,12,8
      s1.5,0.67,1.5,1.5S12.83,11,12,11z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-15': {
    element: [
      <path
        d="M22,9.24l-7.19-0.62L12,2L9.19,8.63L2,9.24l5.46,4.73L5.82,21L12,17.27L18.18,21l-1.63-7.03L22,9.24z M12,15.4l-3.76,2.27
      l1-4.28l-3.32-2.88l4.38-0.38L12,6.1l1.71,4.04l4.38,0.38l-3.32,2.88l1,4.28L12,15.4z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-16': {
    element: [
      <path
        d="M13,3c-4.97,0-9,4.03-9,9H1l3.89,3.89l0.07,0.14L9,12H6c0-3.87,3.13-7,7-7s7,3.13,7,7s-3.13,7-7,7
      c-1.93,0-3.68-0.79-4.94-2.06l-1.42,1.42C8.27,19.99,10.51,21,13,21c4.97,0,9-4.03,9-9S17.97,3,13,3z M12,8v5l4.25,2.52l0.77-1.28
      l-3.52-2.09V8H12z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-17': {
    element: [
      <path
        d="M10.09,15.59L11.5,17l5-5l-5-5l-1.41,1.41L12.67,11H3v2h9.67L10.09,15.59z M19,3H5C3.89,3,3,3.9,3,5v4h2V5h14v14H5v-4H3v4
      c0,1.1,0.89,2,2,2h14c1.1,0,2-0.9,2-2V5C21,3.9,20.1,3,19,3z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-18': {
    element: [
      <path
        d="M19.5,17l-1.41-1.41l-2.59,2.58V11h-2v7.17l-2.59-2.58L9.5,17l5,5L19.5,17z M4.5,7l1.41,1.41L8.5,5.83V13h2V5.83l2.59,2.58
      L14.5,7l-5-5L4.5,7z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-19': {
    element: [
      <path
        d="M12,6c3.79,0,7.17,2.13,8.82,5.5C19.17,14.87,15.79,17,12,17s-7.17-2.13-8.82-5.5C4.83,8.13,8.21,6,12,6 M12,4
      C7,4,2.73,7.11,1,11.5C2.73,15.89,7,19,12,19s9.27-3.11,11-7.5C21.27,7.11,17,4,12,4z M12,9c1.38,0,2.5,1.12,2.5,2.5S13.38,14,12,14
      s-2.5-1.12-2.5-2.5S10.62,9,12,9 M12,7c-2.48,0-4.5,2.02-4.5,4.5S9.52,16,12,16s4.5-2.02,4.5-4.5S14.48,7,12,7z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-20': {
    element: [
      <path d="M20,6H10v2h10v12H4V8h2v4h2V4h6V0H6v6H4C2.9,6,2,6.9,2,8v12c0,1.1,0.9,2,2,2h16c1.1,0,2-0.9,2-2V8C22,6.9,21.1,6,20,6z" />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-21': {
    element: [
      <path d="M9,5v6H5V5H9 M19,13v6h-4v-6H19 M21,3h-8v6h8V3z M11,3H3v10h8V3z M21,11h-8v10h8V11z M11,15H3v6h8V15z" />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-22': {
    element: [
      <path
        d="M21,8.019h-6.31l0.95-4.57l0.03-0.32c-0.001-0.398-0.159-0.779-0.44-1.06l-1.06-1.05c0,0-7.09,6.85-7.17,7H2v13h16
      c0.804,0.003,1.53-0.479,1.84-1.22l3.02-7.05c0.092-0.232,0.14-0.48,0.14-0.73v-2C22.997,8.915,22.103,8.022,21,8.019z M7,19.019H4
      v-9h3V19.019z M21,12.019l-3,7H9v-10l4.34-4.34L12,10.019h9V12.019z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-23': {
    element: [
      <path
        d="M12,6c0-0.55-0.45-1-1-1H5.82l0.66-3.18L6.5,1.59c0-0.31-0.13-0.59-0.33-0.8L5.38,0L0.44,4.94C0.17,5.21,0,5.59,0,6v6.5
      C0,13.33,0.67,14,1.5,14h6.75c0.62,0,1.15-0.38,1.38-0.91l2.26-5.29C11.96,7.63,12,7.44,12,7.25V6z M10,7.13L7.92,12H2V6.21
      l1.93-1.93L3.36,7H10V7.13z M22.5,10h-6.75c-0.62,0-1.15,0.38-1.38,0.91l-2.26,5.29C12.04,16.37,12,16.56,12,16.75V18
      c0,0.55,0.45,1,1,1h5.18l-0.66,3.18l-0.02,0.24c0,0.31,0.13,0.59,0.33,0.8L18.62,24l4.94-4.94C23.83,18.79,24,18.41,24,18v-6.5
      C24,10.67,23.33,10,22.5,10z M22,17.79l-1.93,1.93L20.64,17H14v-0.13L16.08,12H22V17.79z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-24': {
    element: [
      <path
        d="M9.998,15.61l-1.26-0.33l-3.51-0.94c-0.039-0.009-0.08-0.012-0.12-0.01c-0.13-0.001-0.256,0.049-0.35,0.14l-0.4,0.41
    l4.94,5.83c0.183,0.189,0.437,0.294,0.7,0.29h7.6c0.486-0.012,0.886-0.386,0.93-0.87l0.96-5.72c0.006-0.053,0.01-0.107,0.01-0.16
    c-0.003-0.425-0.27-0.804-0.67-0.95l-4.5-2.24c-0.106-0.039-0.217-0.06-0.33-0.06h-2V4c0-0.552-0.448-1-1-1c-0.552,0-1,0.448-1,1
    L9.998,15.61z M8.378,2.55c0.795-1.447,2.612-1.976,4.059-1.181c0.498,0.273,0.908,0.683,1.181,1.181
    c1.629-1.04,3.793-0.563,4.833,1.067s0.563,3.793-1.067,4.833C16.822,8.81,16.167,9.001,15.498,9h-1.5
    c0.372,0.001,0.741,0.069,1.09,0.2l0.1,0.04l4.49,2.24c1.115,0.462,1.841,1.553,1.838,2.76c0,0.12-0.01,0.21-0.03,0.44l-0.97,5.77
    c-0.21,1.455-1.45,2.538-2.92,2.55h-7.6c-0.819-0.005-1.601-0.34-2.17-0.93l-6.18-7.29l0.65-0.65l1.052-1.063
    c0.471-0.467,1.107-0.73,1.77-0.73c0.195,0.003,0.389,0.023,0.58,0.06l2.3,0.61v-4.01h-1.5C4.565,8.999,2.997,7.433,2.995,5.5
    C2.993,3.567,4.559,1.999,6.492,1.997c0.669-0.001,1.323,0.19,1.887,0.55L8.378,2.55z M13.998,5.5V7h1.5c0.828,0,1.5-0.672,1.5-1.5
    S16.327,4,15.498,4S13.998,4.672,13.998,5.5z M7.998,7V5.5c0-0.828-0.672-1.5-1.5-1.5s-1.5,0.672-1.5,1.5S5.67,7,6.498,7H7.998z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-25': {
    element: [<path d="M12,3L4,9v12h16V9L12,3z M18,19h-3v-6H9v6H6v-9l6-4.5l6,4.5V19z" />],
    viewBox: '0 0 24 24',
  },
  'icon-26': {
    element: [
      <path d="M15,4V3H9v1H4v2h1v13c0.003,1.103,0.897,1.997,2,2h10c1.103-0.003,1.997-0.897,2-2V6h1V4H15z M17,19H7V6h10V19z" />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-27': {
    element: [<path d="M9,16.17L4.83,12l-1.42,1.41L9,19L21,7l-1.41-1.41L9,16.17z" />],
    viewBox: '0 0 24 24',
  },
  'icon-28': {
    element: [
      <path
        d="M23,8c0,1.1-0.9,2-2,2c-0.18,0-0.35-0.02-0.51-0.07l-3.56,3.55C16.98,13.64,17,13.82,17,14c0,1.1-0.9,2-2,2s-2-0.9-2-2
      c0-0.18,0.02-0.36,0.07-0.52l-2.55-2.55C10.36,10.98,10.18,11,10,11s-0.36-0.02-0.52-0.07l-4.55,4.56C4.98,15.65,5,15.82,5,16
      c0,1.1-0.9,2-2,2s-2-0.9-2-2s0.9-2,2-2c0.18,0,0.35,0.02,0.51,0.07l4.56-4.55C8.02,9.36,8,9.18,8,9c0-1.1,0.9-2,2-2s2,0.9,2,2
      c0,0.18-0.02,0.36-0.07,0.52l2.55,2.55C14.64,12.02,14.82,12,15,12s0.36,0.02,0.52,0.07l3.55-3.56C19.02,8.35,19,8.18,19,8
      c0-1.1,0.9-2,2-2S23,6.9,23,8z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-29': {
    element: [<path d="M3,15h18v-2H3V15z M3,19h18v-2H3V19z M3,11h18V9H3V11z M3,5v2h18V5H3z" />],
    viewBox: '0 0 24 24',
  },
  'icon-30': {
    element: [<path d="M14,17H4v2h10V17z M20,9H4v2h16V9z M4,15h16v-2H4V15z M4,5v2h16V5H4z" />],
    viewBox: '0 0 24 24',
  },
  'icon-31': {
    element: [
      <path
        d="M4,13L4,13c0.552,0,1-0.448,1-1v0c0-0.552-0.448-1-1-1h0c-0.552,0-1,0.448-1,1v0C3,12.552,3.448,13,4,13z M4,17L4,17
  c0.552,0,1-0.448,1-1v0c0-0.552-0.448-1-1-1h0c-0.552,0-1,0.448-1,1v0C3,16.552,3.448,17,4,17z M4,9L4,9c0.552,0,1-0.448,1-1v0
  c0-0.552-0.448-1-1-1h0C3.448,7,3,7.448,3,8v0C3,8.552,3.448,9,4,9z M7,13h14v-2H7V13z M7,17h14v-2H7V17z M7,7v2h14V7H7z M4,13L4,13
  c0.552,0,1-0.448,1-1v0c0-0.552-0.448-1-1-1h0c-0.552,0-1,0.448-1,1v0C3,12.552,3.448,13,4,13z M4,17L4,17c0.552,0,1-0.448,1-1v0
  c0-0.552-0.448-1-1-1h0c-0.552,0-1,0.448-1,1v0C3,16.552,3.448,17,4,17z M4,9L4,9c0.552,0,1-0.448,1-1v0c0-0.552-0.448-1-1-1h0
  C3.448,7,3,7.448,3,8v0C3,8.552,3.448,9,4,9z M7,13h14v-2H7V13z M7,17h14v-2H7V17z M7,7v2h14V7H7z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-32': {
    element: [<path d="M3,18h6v-2H3V18z M3,6v2h18V6H3z M3,13h12v-2H3V13z" />],
    viewBox: '0 0 24 24',
  },
  'icon-33': {
    element: [
      <path
        d="M21,12L21,12c0-0.552-0.448-1-1-1l0,0c-0.552,0-1,0.448-1,1l0,0c0,0.552,0.448,1,1,1l0,0C20.552,13,21,12.552,21,12z M21,16
      L21,16c0-0.552-0.448-1-1-1l0,0c-0.552,0-1,0.448-1,1l0,0c0,0.552,0.448,1,1,1l0,0C20.552,17,21,16.552,21,16z M21,8L21,8
      c0-0.552-0.448-1-1-1l0,0c-0.552,0-1,0.448-1,1l0,0c0,0.552,0.448,1,1,1l0,0C20.552,9,21,8.552,21,8z M17,11H3v2h14V11z M17,15H3v2
      h14V15z M3,7v2h14V7H3z M21,12L21,12c0-0.552-0.448-1-1-1l0,0c-0.552,0-1,0.448-1,1l0,0c0,0.552,0.448,1,1,1l0,0
      C20.552,13,21,12.552,21,12z M21,16L21,16c0-0.552-0.448-1-1-1l0,0c-0.552,0-1,0.448-1,1l0,0c0,0.552,0.448,1,1,1l0,0
      C20.552,17,21,16.552,21,16z M21,8L21,8c0-0.552-0.448-1-1-1l0,0c-0.552,0-1,0.448-1,1l0,0c0,0.552,0.448,1,1,1l0,0
      C20.552,9,21,8.552,21,8z M17,11H3v2h14V11z M17,15H3v2h14V15z M3,7v2h14V7H3z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-34': {
    element: [
      <path
        d="M21,4H3C2.448,4,2,4.448,2,5v14c0,0.552,0.448,1,1,1h18c0.552,0,1-0.448,1-1V5C22,4.448,21.552,4,21,4z M8,18H4V6h4V18z
     M14,18h-4V6h4V18z M20,18h-4V6h4V18z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-35': {
    element: [
      <path
        d="M16,13c0.552,0,1-0.448,1-1V3c0-0.552-0.448-1-1-1H3C2.448,2,2,2.448,2,3v14l4-4H16z M15,4v7H4V4H15z M21,6h-2v9H6v2
    c0,0.552,0.448,1,1,1h11l4,4V7C22,6.448,21.552,6,21,6z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-36': {
    element: [
      <path
        d="M20,2H4C2.899,2.006,2.01,2.899,2.01,4L2,22l4-4h14c1.103-0.003,1.997-0.897,2-2V4C21.997,2.897,21.103,2.003,20,2z M20,16
      H5.17l-0.59,0.59L4,17.17V4h16V16z M6,12h2v2H6V12z M6,9h2v2H6V9z M6,6h2v2H6V6z M10,12h5v2h-5V12z M10,9h8v2h-8V9z M10,6h8v2h-8V6
      z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-37': {
    element: [
      <path
        d="M18,17v-6.5c0-3.07-1.63-5.64-4.5-6.32V3.5C13.5,2.672,12.828,2,12,2s-1.5,0.672-1.5,1.5v0.68C7.64,4.86,6,7.42,6,10.5V17H4
      v2h16v-2H18z M16,17H8v-6.5C8,8.02,9.51,6,12,6s4,2.02,4,4.5V17z M12,22c1.103-0.003,1.997-0.897,2-2h-4
      C10.003,21.103,10.897,21.997,12,22z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-38': {
    element: [
      <path
        d="M20,2H4C2.899,2.006,2.01,2.899,2.01,4L2,22l4-4h14c1.103-0.003,1.997-0.897,2-2V4C21.997,2.897,21.103,2.003,20,2z M20,16
      H5.17l-0.59,0.59L4,17.17V4h16V16z M11,12h2v2h-2V12z M11,6h2v4h-2V6z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-39': {
    element: [
      <path
        d="M12.75,5l-4.5,8.5h3.14V19l4.36-8.5h-3V5z M12,4c4.411,0,8,3.589,8,8s-3.589,8-8,8s-8-3.589-8-8S7.589,4,12,4 M12,2
      C6.477,2,2,6.477,2,12s4.477,10,10,10s10-4.477,10-10S17.523,2,12,2L12,2z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-40': {
    element: [
      <path
        d="M19.43,12.98c0.04-0.32,0.07-0.64,0.07-0.98c0-0.34-0.03-0.66-0.07-0.98l2.11-1.65c0.19-0.15,0.24-0.42,0.12-0.64l-2-3.46
      c-0.09-0.16-0.26-0.25-0.44-0.25c-0.06,0-0.12,0.01-0.17,0.03l-2.49,1c-0.52-0.4-1.08-0.73-1.69-0.98l-0.38-2.65
      C14.46,2.18,14.25,2,14,2h-4C9.75,2,9.54,2.18,9.51,2.42L9.13,5.07C8.52,5.32,7.96,5.66,7.44,6.05l-2.49-1
      C4.89,5.03,4.83,5.02,4.77,5.02c-0.17,0-0.34,0.09-0.43,0.25l-2,3.46C2.21,8.95,2.27,9.22,2.46,9.37l2.11,1.65
      C4.53,11.34,4.5,11.67,4.5,12c0,0.33,0.03,0.66,0.07,0.98l-2.11,1.65c-0.19,0.15-0.24,0.42-0.12,0.64l2,3.46
      c0.09,0.16,0.26,0.25,0.44,0.25c0.06,0,0.12-0.01,0.17-0.03l2.49-1c0.52,0.4,1.08,0.73,1.69,0.98l0.38,2.65
      C9.54,21.82,9.75,22,10,22h4c0.25,0,0.46-0.18,0.49-0.42l0.38-2.65c0.61-0.25,1.17-0.59,1.69-0.98l2.49,1
      c0.06,0.02,0.12,0.03,0.18,0.03c0.17,0,0.34-0.09,0.43-0.25l2-3.46c0.12-0.22,0.07-0.49-0.12-0.64L19.43,12.98z M17.45,11.27
      c0.04,0.31,0.05,0.52,0.05,0.73c0,0.21-0.02,0.43-0.05,0.73l-0.14,1.13l0.89,0.7l1.08,0.84l-0.7,1.21l-1.27-0.51l-1.04-0.42
      l-0.9,0.68c-0.43,0.32-0.84,0.56-1.25,0.73l-1.06,0.43l-0.16,1.13L12.7,20h-1.4l-0.19-1.35l-0.16-1.13l-1.06-0.43
      c-0.43-0.18-0.83-0.41-1.23-0.71l-0.91-0.7l-1.06,0.43l-1.27,0.51l-0.7-1.21l1.08-0.84l0.89-0.7l-0.14-1.13
      C6.52,12.43,6.5,12.2,6.5,12s0.02-0.43,0.05-0.73l0.14-1.13L5.8,9.44L4.72,8.6l0.7-1.21L6.69,7.9l1.04,0.42l0.9-0.68
      c0.43-0.32,0.84-0.56,1.25-0.73l1.06-0.43l0.16-1.13L11.3,4h1.39l0.19,1.35l0.16,1.13l1.06,0.43c0.43,0.18,0.83,0.41,1.23,0.71
      l0.91,0.7l1.06-0.43l1.27-0.51l0.7,1.21L18.2,9.44l-0.89,0.7C17.31,10.14,17.45,11.27,17.45,11.27z M12,15c-1.65,0-3-1.35-3-3
      s1.35-3,3-3s3,1.35,3,3S13.65,15,12,15z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-41': {
    element: [<path d="M2,3v18l20-9L2,3z M4,14l9-2l-9-2V6.09L17.13,12L4,17.91V14z" />],
    viewBox: '0 0 24 24',
  },
  'icon-42': {
    element: [
      <path
        d="M21,3H7C5.897,3.003,5.003,3.897,5,5v10c0.003,1.103,0.897,1.997,2,2h14c1.103-0.003,1.997-0.897,2-2V5
      C22.997,3.897,22.103,3.003,21,3z M20.5,5L14,9.5L7.5,5H20.5z M7,15V7l7,5l7-5v8H7z M17,19H3V5H1v14c0.003,1.103,0.897,1.997,2,2
      h14V19z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-43': {
    element: [
      <path
        d="M19,3h-1V1h-2v2H8V1H6v2H5C3.9,3.001,3.009,3.892,3.01,4.992c0,0.003,0,0.005,0,0.008L3,19c0,1.105,0.895,2,2,2h14
      c1.103-0.003,1.997-0.897,2-2V5C20.997,3.897,20.103,3.003,19,3z M19,19H5V8h14V19z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-44': {
    element: [
      <path
        d="M19,3h-1V1h-2v2H8V1H6v2H5C3.895,3,3,3.895,3,5v14c0,1.105,0.895,2,2,2h14c1.103-0.003,1.997-0.897,2-2V5
      C20.997,3.897,20.103,3.003,19,3z M19,19H5V8h14V19z M9,9.5c-1.381,0-2.5,1.119-2.5,2.5s1.119,2.5,2.5,2.5s2.5-1.119,2.5-2.5
      S10.381,9.5,9,9.5z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-45': {
    element: [
      <path
        d="M19,3h-1V1h-2v2H8V1H6v2H5C3.9,3.001,3.009,3.892,3.01,4.992c0,0.003,0,0.005,0,0.008L3,19c0,1.105,0.895,2,2,2h14
      c1.103-0.003,1.997-0.897,2-2V5C20.997,3.897,20.103,3.003,19,3z M19,19H5V8h14V19z M8,10c-0.552,0-1,0.448-1,1s0.448,1,1,1
      s1-0.448,1-1S8.552,10,8,10z M12,10c-0.552,0-1,0.448-1,1s0.448,1,1,1s1-0.448,1-1S12.552,10,12,10z M16,10c-0.552,0-1,0.448-1,1
      s0.448,1,1,1s1-0.448,1-1S16.552,10,16,10z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-46': {
    element: [
      <path
        d="M19,3H5C3.897,3.003,3.003,3.897,3,5v14c0.003,1.103,0.897,1.997,2,2h14c1.103-0.003,1.997-0.897,2-2V5
      C20.997,3.897,20.103,3.003,19,3z M19,19H5V5h14V19z M7,12h2v5H7V12z M15,7h2v10h-2V7z M11,14h2v3h-2V14z M11,10h2v2h-2V10z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-47': {
    element: [
      <path
        d="M12,2C8.13,2,5,5.13,5,9c0,5.25,7,13,7,13s7-7.75,7-13C19,5.13,15.87,2,12,2z M7,9c0-2.76,2.24-5,5-5s5,2.24,5,5
  c0,2.88-2.88,7.19-5,9.88C9.92,16.21,7,11.85,7,9z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-48': {
    element: [
      <path
        d="M6.05,8.05c-2.734,2.734-2.734,7.166,0,9.9s7.166,2.734,9.9,0l0,0C19.43,14.47,20.001,4,20.001,4S9.53,4.57,6.05,8.05z
      M14.54,16.54c-1.594,1.602-4.07,1.922-6.02,0.78c0.907-2.85,2.599-5.387,4.881-7.32c-2.636,1.375-4.84,3.451-6.37,6
     c-1.507-1.984-1.32-4.776,0.44-6.54c1.74-1.74,6.57-2.81,10.33-3.26C17.35,9.96,16.28,14.79,14.54,16.54z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-49': {
    element: [
      <path
        d="M18,8h-1V6c0-2.76-2.24-5-5-5S7,3.24,7,6h2c0-1.66,1.34-3,3-3s3,1.34,3,3v2H6c-1.1,0-2,0.9-2,2v10c0,1.1,0.9,2,2,2h12
      c1.1,0,2-0.9,2-2V10C20,8.9,19.1,8,18,8z M18,20H6V10h12V20z M12,17c1.1,0,2-0.9,2-2s-0.9-2-2-2s-2,0.9-2,2S10.9,17,12,17z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-50': {
    element: [
      <path
        d="M16.5,3c-1.74,0-3.41,0.81-4.5,2.09C10.91,3.81,9.24,3,7.5,3C4.42,3,2,5.42,2,8.5c0,3.78,3.4,6.86,8.55,11.54L12,21.35
      l1.45-1.32C18.6,15.36,22,12.28,22,8.5C22,5.42,19.58,3,16.5,3z M12.1,18.55l-0.1,0.1l-0.1-0.1C7.14,14.24,4,11.39,4,8.5
      C4,6.5,5.5,5,7.5,5c1.54,0,3.04,0.99,3.57,2.36h1.87C13.46,5.99,14.96,5,16.5,5c2,0,3.5,1.5,3.5,3.5
      C20,11.39,16.86,14.24,12.1,18.55z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-51': {
    element: [<path d="M7,20l1.41-1.41L5.83,16H13v-2H5.83l2.58-2.59L7,10l-5,5L7,20z" />],
    viewBox: '0 0 24 24',
  },
  'icon-52': {
    element: [
      <path d="M16.79,7.79l-1.41,1.42L17.17,11H3v2h14.17l-1.79,1.79l1.41,1.42L21,12L16.79,7.79z" />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-53': {
    element: [
      <path
        d="M12,2C6.477,2,2,6.477,2,12s4.477,10,10,10s10-4.477,10-10S17.523,2,12,2z M12,20c-4.418,0-8-3.582-8-8s3.582-8,8-8
      s8,3.582,8,8C19.994,16.416,16.416,19.994,12,20z"
      />,
      <path
        d="M15,6l-1.41,1.41L15.17,9H11v2h4.17l-1.58,1.59L15,14l4-4L15,6z M9,18l1.41-1.41L8.83,15H13v-2H8.83l1.58-1.59L9,10l-4,4
      L9,18z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-54': {
    element: [
      <path d="M16,6l2.29,2.29l-4.88,4.88l-4-4L2,16.59L3.41,18l6-6l4,4l6.3-6.29L22,12V6H16z" />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-55': {
    element: [
      <path
        d="M11,5.83V10h2V5.83l1.83,1.83l1.41-1.42L12,2L7.76,6.24l1.41,1.42L11,5.83z M17.76,7.76l-1.42,1.41L18.17,11H14v2h4.17
      l-1.83,1.83l1.42,1.41L22,12L17.76,7.76z M13,18.17V14h-2v4.17l-1.83-1.83l-1.41,1.42L12,22l4.24-4.24l-1.41-1.42L13,18.17z M10,13
      v-2H5.83l1.83-1.83L6.24,7.76L2,12l4.24,4.24l1.42-1.41L5.83,13H10z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-56': {
    element: [
      <path
        d="M18,8h-1V6c0-2.76-2.24-5-5-5S7,3.24,7,6v2H6c-1.1,0-2,0.9-2,2v10c0,1.1,0.9,2,2,2h12c1.1,0,2-0.9,2-2V10
      C20,8.9,19.1,8,18,8z M9,6c0-1.66,1.34-3,3-3s3,1.34,3,3v2H9V6z M18,20H6V10h12V20z M12,17c1.1,0,2-0.9,2-2s-0.9-2-2-2s-2,0.9-2,2
      S10.9,17,12,17z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-57': {
    element: [
      <path
        d="M11,7h2v2h-2V7z M11,11h2v6h-2V11z M12,2C6.48,2,2,6.48,2,12s4.48,10,10,10s10-4.48,10-10S17.52,2,12,2z M12,20
      c-4.41,0-8-3.59-8-8s3.59-8,8-8s8,3.59,8,8S16.41,20,12,20z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-58': {
    element: [
      <path
        d="M11,18h2v-2h-2V18z M12,2C6.48,2,2,6.48,2,12s4.48,10,10,10s10-4.48,10-10S17.52,2,12,2z M12,20c-4.41,0-8-3.59-8-8
      s3.59-8,8-8s8,3.59,8,8S16.41,20,12,20z M12,6c-2.21,0-4,1.79-4,4h2c0-1.1,0.9-2,2-2s2,0.9,2,2c0,2-3,1.75-3,5h2c0-2.25,3-2.5,3-5
      C16,7.79,14.21,6,12,6z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-59': {
    element: [
      <path
        d="M4.039,10.061c-2.719,2.719-2.719,7.18,0,9.899s7.18,2.719,9.899,0c1.962-1.962,2.407-4.79,1.606-7.263l1.929-1.929
      l2.121,2.121l4.243-4.243l-2.121-2.121l1.414-1.414l-4.243-4.243l-0.707,0.707l-6.868,6.868C8.882,7.588,6.047,8.054,4.039,10.061z
       M5.454,11.475c1.612-1.612,3.899-1.889,5.716-1.01l0.639,0.311l7.079-7.079l1.414,1.414l-1.414,1.414l2.121,2.121l-1.414,1.414
      L17.474,7.94l-4.23,4.23l0.273,0.624c0.835,1.909,0.537,4.222-0.993,5.752c-1.948,1.948-5.123,1.948-7.071,0
      S3.506,13.423,5.454,11.475z M6.868,12.89c-1.163,1.163-1.163,3.079,0,4.243c1.163,1.163,3.079,1.163,4.243,0
      c1.163-1.163,1.163-3.079,0-4.243S8.031,11.726,6.868,12.89z M8.282,14.304c0.399-0.399,1.015-0.399,1.414,0
      c0.399,0.399,0.399,1.015,0,1.414c-0.399,0.399-1.015,0.399-1.414,0C7.883,15.319,7.883,14.703,8.282,14.304z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-60': {
    element: [
      <path
        d="M12.5,4c4.135,0,7.5,3.364,7.5,7.5S16.636,19,12.5,19c-1.08,0-2.134-0.241-3.223-0.737c-0.263-0.12-0.546-0.18-0.829-0.18
  		c-0.231,0-0.462,0.04-0.683,0.12l-3.148,1.144l1.1-3.243c0.161-0.476,0.138-0.995-0.066-1.454C5.219,13.677,5,12.617,5,11.5
  		C5,7.365,8.365,4,12.5,4 M12.5,2C7.262,2,3,6.262,3,11.5c0,1.402,0.277,2.732,0.823,3.962l-1.77,5.217
  		c-0.123,0.364-0.027,0.766,0.248,1.036C2.491,21.9,2.743,22,3,22c0.115,0,0.23-0.02,0.342-0.061l5.106-1.856
  		C9.8,20.699,11.129,21,12.5,21c5.238,0,9.5-4.262,9.5-9.5S17.738,2,12.5,2L12.5,2z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-61': {
    element: [
      <path
        d="M19,5h-2V4c0-0.552-0.448-1-1-1H8C7.448,3,7,3.448,7,4v1H5C3.9,5,3,5.9,3,7v1c0,2.55,1.92,4.63,4.39,4.94
			c0.63,1.5,1.98,2.63,3.61,2.96V19H8c-0.552,0-1,0.448-1,1v0c0,0.552,0.448,1,1,1h8c0.552,0,1-0.448,1-1v0c0-0.552-0.448-1-1-1h-3
			v-3.1c1.63-0.33,2.98-1.46,3.61-2.96C19.08,12.63,21,10.55,21,8V7C21,5.9,20.1,5,19,5z M5,8V7h2v3.82C5.84,10.4,5,9.3,5,8z M12,14
			c-1.65,0-3-1.35-3-3V5h6v6C15,12.65,13.65,14,12,14z M19,8c0,1.3-0.84,2.4-2,2.82V7h2V8z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-62': {
    element: [
      <path
        d="M9.943,2C9.708,2.009,9.469,2.055,9.234,2.141C8.295,2.482,7.711,3.35,7.748,4.35c0.004,0.107-0.049,0.173-0.094,0.211
      c-0.046,0.038-0.12,0.077-0.223,0.055c-0.976-0.212-1.936,0.214-2.436,1.08c-0.501,0.866-0.39,1.906,0.281,2.648
      C5.352,8.427,5.35,8.519,5.342,8.566C5.331,8.624,5.299,8.702,5.205,8.752c-0.884,0.468-1.344,1.408-1.17,2.393
      c0.174,0.985,0.927,1.711,1.918,1.848c0.104,0.014,0.162,0.077,0.191,0.127c0.029,0.05,0.054,0.131,0.014,0.23
      c-0.308,0.757-0.187,1.571,0.283,2.195L3.857,20h3.5v0.002l1.49,3.268l3.137-5.229l3.137,5.229l1.49-3.27h3.5l-2.568-4.428
      c0.487-0.627,0.613-1.453,0.301-2.223c-0.039-0.098-0.012-0.179,0.016-0.23c0.029-0.05,0.087-0.113,0.191-0.127
      c0.991-0.137,1.744-0.863,1.918-1.848s-0.286-1.925-1.17-2.393c-0.094-0.05-0.126-0.128-0.137-0.186
      c-0.008-0.047-0.011-0.14,0.064-0.223c0.671-0.742,0.782-1.781,0.281-2.648c-0.5-0.867-1.462-1.291-2.436-1.08
      c-0.103,0.022-0.178-0.017-0.223-0.055s-0.098-0.105-0.094-0.211c0.037-0.999-0.547-1.867-1.486-2.209
      c-0.94-0.342-1.946-0.054-2.561,0.736c-0.131,0.167-0.283,0.168-0.414,0C11.333,2.284,10.651,1.974,9.943,2z M10.08,4.008
      c0.05,0.014,0.095,0.045,0.135,0.096c0.861,1.11,2.707,1.109,3.57,0c0.078-0.1,0.179-0.129,0.297-0.086
      c0.119,0.043,0.178,0.13,0.174,0.256c-0.026,0.702,0.268,1.364,0.807,1.816c0.538,0.452,1.239,0.627,1.928,0.479
      c0.127-0.027,0.219,0.016,0.283,0.125c0.064,0.11,0.052,0.215-0.033,0.309c-0.472,0.522-0.673,1.217-0.551,1.91
      c0.123,0.692,0.549,1.279,1.17,1.607c0.113,0.059,0.159,0.152,0.137,0.277s-0.098,0.196-0.223,0.213
      c-0.697,0.097-1.298,0.502-1.65,1.111c-0.351,0.608-0.4,1.33-0.135,1.98c0.048,0.117,0.023,0.219-0.074,0.301
      c-0.098,0.081-0.204,0.088-0.309,0.021c-0.597-0.374-1.316-0.451-1.977-0.211c-0.66,0.241-1.164,0.762-1.381,1.432
      c-0.076,0.242-0.42,0.242-0.498,0c-0.216-0.669-0.719-1.19-1.379-1.43c-0.254-0.093-0.514-0.139-0.775-0.139
      c-0.418,0-0.833,0.118-1.199,0.35c-0.108,0.068-0.21,0.061-0.309-0.021c-0.096-0.082-0.123-0.183-0.076-0.299
      c0.265-0.651,0.216-1.375-0.135-1.984c-0.351-0.61-0.953-1.012-1.65-1.109c-0.125-0.017-0.2-0.09-0.221-0.215
      c-0.022-0.124,0.023-0.217,0.135-0.277c0.621-0.328,1.047-0.913,1.17-1.605c0.122-0.693-0.077-1.389-0.549-1.91
      C6.677,6.909,6.666,6.805,6.729,6.695C6.793,6.586,6.882,6.542,7.01,6.57c0.69,0.15,1.39-0.026,1.928-0.479
      c0.54-0.451,0.833-1.113,0.807-1.816C9.74,4.148,9.799,4.062,9.918,4.018C9.976,3.997,10.03,3.994,10.08,4.008z M9.586,16.076
      c0.039-0.001,0.074,0.008,0.102,0.018c0.055,0.02,0.128,0.065,0.16,0.166c0.093,0.288,0.239,0.541,0.42,0.76l-1.209,2.014
      C8.705,18.419,8.077,18,7.357,18H7.33l0.889-1.535c0.424,0.006,0.853-0.104,1.24-0.348C9.504,16.089,9.547,16.078,9.586,16.076z
       M14.418,16.076c0.039,0.001,0.083,0.012,0.129,0.041c0.376,0.236,0.789,0.347,1.201,0.348L16.639,18h-0.027
      c-0.719,0-1.348,0.417-1.701,1.033l-1.195-1.992c0.19-0.224,0.344-0.483,0.441-0.781c0.033-0.101,0.106-0.146,0.16-0.166
      C14.343,16.084,14.379,16.075,14.418,16.076z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-63': {
    element: [
      <path
        d="M9.155,4.006c0.104,0,0.207,0.016,0.311,0.05l1.92,0.619l0.615,0.198l0.614-0.199l1.925-0.622
		c0.094-0.031,0.195-0.046,0.299-0.046c0.407,0,0.813,0.238,0.989,0.583l0.92,1.797l0.295,0.575l0.576,0.294l1.798,0.918
		c0.48,0.245,0.699,0.775,0.532,1.29l-0.621,1.92L19.126,12l0.199,0.616l0.622,1.922c0.167,0.513-0.053,1.043-0.532,1.288
		l-1.799,0.918l-0.577,0.295l-0.295,0.577l-0.918,1.797C15.638,19.78,15.28,20,14.867,20c-0.112,0-0.222-0.018-0.332-0.053
		l-1.92-0.621l-0.616-0.199l-0.616,0.2L9.459,19.95c-0.094,0.031-0.194,0.046-0.298,0.046c-0.406,0-0.812-0.24-0.989-0.585
		l-0.92-1.797l-0.295-0.576l-0.577-0.294l-1.795-0.915c-0.481-0.246-0.7-0.776-0.532-1.292l0.621-1.922L4.873,12l-0.199-0.615
		L4.053,9.464C3.887,8.95,4.106,8.419,4.588,8.174l1.797-0.918l0.577-0.295l0.295-0.577l0.918-1.798
		c0.167-0.327,0.54-0.56,0.929-0.58L9.155,4.006 M9.155,2.006c-0.051,0-0.102,0.001-0.153,0.004C7.923,2.065,6.898,2.687,6.393,3.678
		L5.475,5.475L3.678,6.393C2.324,7.084,1.682,8.635,2.15,10.08L2.771,12L2.15,13.922c-0.469,1.445,0.171,2.996,1.525,3.688
		l1.797,0.916l0.92,1.797c0.531,1.04,1.636,1.674,2.769,1.674c0.307,0,0.616-0.047,0.917-0.144L12,21.229l1.92,0.621
		c0.307,0.1,0.625,0.15,0.947,0.15c1.162,0,2.211-0.643,2.74-1.678l0.918-1.797l1.799-0.918c1.353-0.692,1.994-2.243,1.525-3.687
		L21.229,12l0.621-1.92c0.469-1.446-0.171-2.997-1.525-3.688l-1.797-0.918l-0.92-1.797c-0.529-1.039-1.636-1.671-2.769-1.671
		c-0.307,0-0.616,0.046-0.917,0.144L12,2.771l-1.92-0.619C9.776,2.053,9.465,2.006,9.155,2.006L9.155,2.006z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-64': {
    element: [
      <path
        d="M12,1L3,5c0,0,0,4,0,6c0,7.83,6.439,11.486,9,12c2.561-0.514,9-4.17,9-12c0-2,0-6,0-6L12,1z M19,11
      c0,6.134-4.785,9.254-7,9.937C9.785,20.254,5,17.134,5,11V6.3l7-3.111L19,6.3V11z"
      />,
      <path d="M12,6l-1.699,3.801L6,10.199L9.199,12.9L8.301,17L12,14.801L15.801,17l-1.102-4.1L18,10.199l-4.301-0.398L12,6z" />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-65': {
    element: [
      <path
        d="M8.5,3C4.922,3,2,5.922,2,9.5c0,2.489,1.415,4.659,3.48,5.75c-0.003,0.083-0.012,0.166-0.012,0.25
		c0,3.581,2.939,6.5,6.531,6.5s6.531-2.919,6.531-6.5c0-0.084-0.008-0.167-0.012-0.25C20.585,14.159,22,11.989,22,9.5
		C22,5.922,19.078,3,15.5,3c-1.288,0-2.488,0.384-3.5,1.035C10.988,3.384,9.788,3,8.5,3z M8.5,5c0.696,0,1.345,0.169,1.932,0.447
		C9.539,6.561,9,7.969,9,9.5c0,0.078,0.009,0.153,0.012,0.23c-1.414,0.73-2.526,1.956-3.104,3.447C4.754,12.365,4,11.028,4,9.5
		C4,7.003,6.003,5,8.5,5z M15.5,5C17.997,5,20,7.003,20,9.5c0,1.528-0.754,2.865-1.908,3.678c-0.578-1.492-1.69-2.718-3.104-3.447
		C14.991,9.653,15,9.578,15,9.5c0-1.531-0.539-2.939-1.432-4.053C14.155,5.169,14.804,5,15.5,5z M12,6.695
		c0.533,0.666,0.873,1.481,0.957,2.383C12.644,9.032,12.326,9,12,9s-0.644,0.032-0.957,0.078C11.127,8.176,11.467,7.361,12,6.695z
		 M12,11c0.242,0,0.474,0.035,0.705,0.07c-0.168,0.453-0.409,0.865-0.705,1.234c-0.296-0.37-0.537-0.781-0.705-1.234
		C11.526,11.035,11.758,11,12,11z M9.426,11.793c0.243,0.641,0.584,1.233,1.006,1.76C9.845,13.831,9.196,14,8.5,14
		c-0.252,0-0.494-0.035-0.734-0.074C8.091,13.055,8.669,12.311,9.426,11.793z M14.574,11.793c0.757,0.518,1.334,1.262,1.66,2.133
		C15.994,13.965,15.752,14,15.5,14c-0.696,0-1.345-0.169-1.932-0.447C13.99,13.026,14.331,12.434,14.574,11.793z M12,14.965
		C13.012,15.616,14.212,16,15.5,16c0.337,0,0.666-0.034,0.99-0.084C16.278,18.21,14.374,20,12,20s-4.278-1.79-4.49-4.084
		C7.834,15.966,8.163,16,8.5,16C9.788,16,10.988,15.616,12,14.965z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-66': {
    element: [
      <path
        d="M7,2C5.895,2,5,2.895,5,4s0.895,2,2,2s2-0.895,2-2S8.105,2,7,2z M12,2c-1.105,0-2,0.895-2,2s0.895,2,2,2s2-0.895,2-2
  	S13.105,2,12,2z M17,2c-1.105,0-2,0.895-2,2s0.895,2,2,2s2-0.895,2-2S18.105,2,17,2z M5,7C3.895,7,3,7.895,3,9v7h1v6h2v-8H5V9h1.102
  	c0.152-0.743,0.482-1.416,0.924-2H5z M11,7c-1.657,0-3,1.343-3,3v8h1v4h2v-4h2v4h2v-4h1v-8c0-1.657-1.343-3-3-3H11z M16.975,7
  	c0.442,0.584,0.773,1.257,0.924,2H19v5h-1v8h2v-6h1V9c0-1.105-0.895-2-2-2H16.975z M11,9h2c0.552,0,1,0.448,1,1v6h-4v-6
  	C10,9.448,10.448,9,11,9z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-67': {
    element: [
      <path
        d="M9,13.75c-2.34,0-7,1.17-7,3.5V19h14v-1.75C16,14.92,11.34,13.75,9,13.75z M4.34,17c0.84-0.58,2.87-1.25,4.66-1.25
  	s3.82,0.67,4.66,1.25H4.34z M9,12c1.93,0,3.5-1.57,3.5-3.5S10.93,5,9,5S5.5,6.57,5.5,8.5S7.07,12,9,12z M9,7
  	c0.83,0,1.5,0.67,1.5,1.5S9.83,10,9,10S7.5,9.33,7.5,8.5S8.17,7,9,7z M16.04,13.81C17.2,14.65,18,15.77,18,17.25V19h4v-1.75
  	C22,15.23,18.5,14.08,16.04,13.81z M15,12c1.93,0,3.5-1.57,3.5-3.5S16.93,5,15,5c-0.54,0-1.04,0.13-1.5,0.35
  	c0.63,0.89,1,1.98,1,3.15s-0.37,2.26-1,3.15C13.96,11.87,14.46,12,15,12z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-68': {
    element: [
      <path
        d="M12,3c-1.1,0-2,0.9-2,2s0.9,2,2,2s2-0.9,2-2S13.1,3,12,3z M12,8c-2.1,0-3.8,0.8-4,2H2v2h1.2l0.6,2.5c0.2,0.9,1,1.5,1.9,1.5
    H8v5h2v-5h4v5h2v-5h2.2c0.9,0,1.7-0.6,1.9-1.5l0.6-2.5H22v-2h-6C15.8,8.8,14.1,8,12,8z M5.3,12h13.4l-0.5,2H5.8L5.3,12z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-69': {
    element: [
      <path d="M5,19c-0.668,0-2,0.36-2,1.025V21h4v-0.975C7,19.36,5.668,19,5,19z" />,
      <path d="M12,19c-0.667,0-2,0.36-2,1.025V21h4v-0.975C14,19.36,12.668,19,12,19z" />,
      <path d="M19,19c-0.667,0-2,0.36-2,1.025V21h4v-0.975C21,19.36,19.667,19,19,19z" />,
      <path d="M19.166,5.834v6.332H4.834V5.834H19.166 M21,4H3v10h18V4L21,4z" />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-70': {
    element: [
      <path
        d="M14,3c-1.1,0-2,0.9-2,2v9l3-3h5c1.1,0,2-0.9,2-2V5c0-1.1-0.9-2-2-2H14z M14,5h6v4h-6V5z M7,9c-1.682,0-3,1.317-3,3
      s1.318,3,3,3s3-1.317,3-3S8.682,9,7,9z M7,11c0.58,0,1,0.421,1,1s-0.42,1-1,1s-1-0.421-1-1S6.42,11,7,11z M7,16
      c-2.851,0-5,1.456-5,3.385V21h10v-1.615C12,17.456,9.851,16,7,16z M7,18c1.469,0,2.49,0.504,2.854,1H4.146
      C4.51,18.504,5.531,18,7,18z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-71': {
    element: [
      <path
        d="M9,13c2.21,0,4-1.79,4-4s-1.79-4-4-4S5,6.79,5,9S6.79,13,9,13z M9,7c1.1,0,2,0.9,2,2s-0.9,2-2,2s-2-0.9-2-2S7.9,7,9,7z
  	 M9,15c-2.67,0-8,1.34-8,4v2h16v-2C17,16.34,11.67,15,9,15z M3,19c0.22-0.72,3.31-2,6-2c2.7,0,5.8,1.29,6,2H3z M15.08,7.05
  	c0.84,1.18,0.84,2.71,0,3.89l1.68,1.69c2.02-2.02,2.02-5.07,0-7.27C16.76,5.36,15.08,7.05,15.08,7.05z M20.07,2l-1.63,1.63
  	c2.77,3.02,2.77,7.56,0,10.74L20.07,16C23.97,12.11,23.98,6.05,20.07,2z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-72': {
    element: [
      <path
        d="M4.971,4.971C4.549,4.549,3.854,4.59,3.477,5.052C1.929,6.948,1,9.367,1,12s0.929,5.052,2.477,6.948
      c0.378,0.463,1.072,0.503,1.494,0.081h0c0.359-0.359,0.394-0.932,0.072-1.324C3.767,16.15,3,14.163,3,12s0.767-4.15,2.043-5.705
      C5.365,5.903,5.33,5.33,4.971,4.971L4.971,4.971z M19.029,4.971L19.029,4.971c-0.359,0.359-0.394,0.932-0.072,1.324
      C20.233,7.85,21,9.837,21,12s-0.767,4.15-2.043,5.705c-0.322,0.392-0.287,0.965,0.072,1.324l0,0
      c0.422,0.422,1.117,0.382,1.494-0.081C22.071,17.052,23,14.633,23,12s-0.929-5.052-2.477-6.948
      C20.146,4.59,19.451,4.549,19.029,4.971z M7.82,7.82c-0.426-0.426-1.147-0.395-1.5,0.094C5.489,9.064,5,10.476,5,12
      s0.489,2.936,1.32,4.087c0.353,0.489,1.074,0.52,1.5,0.094l0.002-0.002c0.352-0.352,0.377-0.898,0.09-1.304
      C7.337,14.061,7,13.069,7,12c0-1.069,0.338-2.061,0.912-2.874c0.287-0.406,0.261-0.952-0.091-1.304L7.82,7.82z M16.181,7.819
      l-0.003,0.003c-0.351,0.351-0.377,0.897-0.09,1.303C16.662,9.939,17,10.931,17,12c0,1.069-0.338,2.061-0.913,2.875
      c-0.286,0.406-0.261,0.951,0.091,1.303l0.003,0.003c0.426,0.426,1.146,0.394,1.499-0.094C18.51,14.936,19,13.524,19,12
      c0-1.525-0.49-2.937-1.32-4.088C17.327,7.424,16.607,7.393,16.181,7.819z M12,9c-1.657,0-3,1.343-3,3s1.343,3,3,3s3-1.343,3-3
      S13.657,9,12,9z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-73': {
    element: [
      <path
        d="M5.54,8.46L2,12l3.54,3.54l1.76-1.77L5.54,12l1.76-1.77L5.54,8.46z M12,18.46l-1.77-1.76l-1.77,1.76L12,22l3.54-3.54
      l-1.77-1.76L12,18.46z M18.46,8.46l-1.76,1.77L18.46,12l-1.76,1.77l1.76,1.77L22,12L18.46,8.46z M8.46,5.54l1.77,1.76L12,5.54
      l1.77,1.76l1.77-1.76L12,2L8.46,5.54z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-74': {
    element: [
      <path
        d="M4,4v4l4-4H4z M16,4l4,4V4H16z M20,20v-4l-4,4H20z M4,20h4l-4-4V20z M19,12c0-3.87-3.13-7-7-7s-7,3.13-7,7s3.13,7,7,7
      S19,15.87,19,12z M12,17c-2.76,0-5-2.24-5-5s2.24-5,5-5s5,2.24,5,5S14.76,17,12,17z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-a': {
    element: [
      <path
        d="M12,2C6.489,2,2,6.489,2,12s4.489,10,10,10s10-4.489,10-10S17.511,2,12,2z M12,4c4.43,0,8,3.57,8,8s-3.57,8-8,8s-8-3.57-8-8
      S7.57,4,12,4z"
      />,
      <path
        d="M13.67,14.596h-3.339L9.696,16.5H7.671l3.44-9.242h1.765l3.459,9.242h-2.024L13.67,14.596z M10.845,13.053h2.311
        l-1.162-3.459L10.845,13.053z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-b': {
    element: [
      <path
        d="M12,2C6.489,2,2,6.489,2,12s4.489,10,10,10s10-4.489,10-10S17.511,2,12,2z M12,4c4.43,0,8,3.57,8,8s-3.57,8-8,8s-8-3.57-8-8
      S7.57,4,12,4z"
      />,
      <path
        d="M8.677,16.5V7.258h3.237c1.122,0,1.973,0.215,2.552,0.645c0.58,0.43,0.87,1.059,0.87,1.889c0,0.452-0.116,0.852-0.35,1.196
        c-0.232,0.345-0.557,0.598-0.971,0.759c0.474,0.118,0.847,0.357,1.12,0.717c0.272,0.359,0.409,0.8,0.409,1.32
        c0,0.889-0.283,1.562-0.851,2.019c-0.566,0.457-1.375,0.689-2.425,0.698H8.677z M10.581,11.13h1.409
        c0.961-0.017,1.441-0.399,1.441-1.149c0-0.418-0.122-0.72-0.365-0.904c-0.243-0.184-0.627-0.275-1.152-0.275h-1.333V11.13z
         M10.581,12.476v2.495h1.632c0.448,0,0.799-0.107,1.05-0.321c0.252-0.214,0.378-0.509,0.378-0.886c0-0.846-0.438-1.275-1.313-1.288
        H10.581z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-c': {
    element: [
      <path
        d="M12,2C6.489,2,2,6.489,2,12s4.489,10,10,10s10-4.489,10-10S17.511,2,12,2z M12,4c4.43,0,8,3.57,8,8s-3.57,8-8,8s-8-3.57-8-8
      S7.57,4,12,4z"
      />,
      <path
        d="M15.828,13.422c-0.072,0.994-0.439,1.777-1.102,2.348c-0.662,0.572-1.535,0.857-2.618,0.857
        c-1.186,0-2.117-0.398-2.797-1.196c-0.679-0.798-1.019-1.893-1.019-3.285V11.58c0-0.889,0.157-1.671,0.47-2.348
        c0.313-0.678,0.761-1.197,1.343-1.559c0.582-0.362,1.258-0.543,2.028-0.543c1.066,0,1.925,0.285,2.577,0.857
        c0.651,0.57,1.028,1.373,1.13,2.405h-1.904c-0.047-0.597-0.213-1.029-0.499-1.298c-0.285-0.269-0.72-0.403-1.304-0.403
        c-0.635,0-1.11,0.228-1.426,0.683c-0.315,0.455-0.477,1.16-0.485,2.117v0.697c0,0.999,0.151,1.729,0.454,2.19
        c0.302,0.461,0.779,0.692,1.432,0.692c0.588,0,1.027-0.135,1.316-0.403c0.29-0.269,0.456-0.685,0.499-1.247H15.828z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-d': {
    element: [
      <path
        d="M12,2C6.489,2,2,6.489,2,12s4.489,10,10,10s10-4.489,10-10S17.511,2,12,2z M12,4c4.43,0,8,3.57,8,8s-3.57,8-8,8s-8-3.57-8-8
      S7.57,4,12,4z"
      />,
      <path
        d="M8.866,16.5V7.258h2.844c0.812,0,1.539,0.183,2.181,0.549c0.641,0.366,1.142,0.887,1.501,1.562
        c0.36,0.675,0.54,1.442,0.54,2.302v0.425c0,0.859-0.177,1.623-0.53,2.292c-0.354,0.668-0.852,1.187-1.495,1.555
        c-0.643,0.368-1.369,0.555-2.177,0.559H8.866z M10.77,8.801v6.17h0.92c0.745,0,1.314-0.244,1.708-0.73s0.595-1.183,0.604-2.088
        v-0.489c0-0.939-0.195-1.651-0.584-2.136c-0.39-0.484-0.959-0.727-1.708-0.727H10.77z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-e': {
    element: [
      <path
        d="M12,2C6.489,2,2,6.489,2,12s4.489,10,10,10s10-4.489,10-10S17.511,2,12,2z M12,4c4.43,0,8,3.57,8,8s-3.57,8-8,8s-8-3.57-8-8
      S7.57,4,12,4z"
      />,
      <path d="M14.729,12.494h-3.656v2.477h4.291V16.5H9.169V7.258h6.183v1.543h-4.278v2.202h3.656V12.494z" />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-f': {
    element: [
      <path
        d="M12,2C6.489,2,2,6.489,2,12s4.489,10,10,10s10-4.489,10-10S17.511,2,12,2z M12,4c4.43,0,8,3.57,8,8s-3.57,8-8,8s-8-3.57-8-8
      S7.57,4,12,4z"
      />,
      <path d="M14.825,12.723h-3.656V16.5H9.265V7.258h6.018v1.543h-4.113v2.387h3.656V12.723z" />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-g': {
    element: [
      <path
        d="M12,2C6.489,2,2,6.489,2,12s4.489,10,10,10s10-4.489,10-10S17.511,2,12,2z M12,4c4.43,0,8,3.57,8,8s-3.57,8-8,8s-8-3.57-8-8
      S7.57,4,12,4z"
      />,
      <path
        d="M15.71,15.332c-0.343,0.41-0.827,0.729-1.453,0.955c-0.627,0.227-1.32,0.34-2.082,0.34c-0.8,0-1.502-0.175-2.104-0.523
        c-0.604-0.35-1.069-0.856-1.396-1.521c-0.328-0.664-0.497-1.445-0.505-2.343v-0.628c0-0.923,0.155-1.722,0.467-2.396
        c0.311-0.675,0.759-1.191,1.346-1.549c0.586-0.357,1.272-0.536,2.06-0.536c1.097,0,1.953,0.262,2.571,0.784
        c0.617,0.522,0.983,1.283,1.098,2.282h-1.854c-0.084-0.529-0.271-0.917-0.562-1.162s-0.688-0.368-1.196-0.368
        c-0.648,0-1.141,0.243-1.479,0.729c-0.338,0.487-0.51,1.211-0.514,2.172v0.59c0,0.969,0.184,1.701,0.552,2.196
        s0.908,0.743,1.619,0.743c0.715,0,1.225-0.152,1.529-0.457v-1.594h-1.732v-1.402h3.637V15.332z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-h': {
    element: [
      <path
        d="M12,2C6.489,2,2,6.489,2,12s4.489,10,10,10s10-4.489,10-10S17.511,2,12,2z M12,4c4.43,0,8,3.57,8,8s-3.57,8-8,8s-8-3.57-8-8
      S7.57,4,12,4z"
      />,
      <path d="M15.754,16.5H13.85v-3.961h-3.713V16.5H8.232V7.258h1.904v3.745h3.713V7.258h1.904V16.5z" />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-i': {
    element: [
      <path
        d="M12,2C6.489,2,2,6.489,2,12s4.489,10,10,10s10-4.489,10-10S17.511,2,12,2z M12,4c4.43,0,8,3.57,8,8s-3.57,8-8,8s-8-3.57-8-8
      S7.57,4,12,4z"
      />,
      <path d="M12.956,16.5h-1.905V7.258h1.905V16.5z" />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-j': {
    element: [
      <path
        d="M12,2C6.489,2,2,6.489,2,12s4.489,10,10,10s10-4.489,10-10S17.511,2,12,2z M12,4c4.43,0,8,3.57,8,8s-3.57,8-8,8s-8-3.57-8-8
      S7.57,4,12,4z"
      />,
      <path
        d="M12.92,7.258h1.904v6.398c0,0.588-0.13,1.107-0.39,1.559c-0.261,0.45-0.628,0.799-1.102,1.044
        c-0.475,0.245-1.01,0.368-1.606,0.368c-0.978,0-1.739-0.249-2.285-0.746s-0.819-1.2-0.819-2.11h1.917
        c0,0.453,0.095,0.787,0.286,1.003s0.491,0.324,0.901,0.324c0.364,0,0.654-0.125,0.87-0.375s0.323-0.605,0.323-1.066V7.258z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-k': {
    element: [
      <path
        d="M12,2C6.489,2,2,6.489,2,12s4.489,10,10,10s10-4.489,10-10S17.511,2,12,2z M12,4c4.43,0,8,3.57,8,8s-3.57,8-8,8s-8-3.57-8-8
      S7.57,4,12,4z"
      />,
      <path
        d="M11.594,12.793l-0.99,1.066V16.5H8.699V7.258h1.904v4.189l0.838-1.148l2.354-3.041h2.343l-3.282,4.107l3.377,5.135h-2.266
        L11.594,12.793z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-l': {
    element: [
      <path
        d="M12,2C6.489,2,2,6.489,2,12s4.489,10,10,10s10-4.489,10-10S17.511,2,12,2z M12,4c4.43,0,8,3.57,8,8s-3.57,8-8,8s-8-3.57-8-8
      S7.57,4,12,4z"
      />,
      <path d="M11.21,14.971h4.044V16.5H9.306V7.258h1.904V14.971z" />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-m': {
    element: [
      <path
        d="M12,2C6.489,2,2,6.489,2,12s4.489,10,10,10s10-4.489,10-10S17.511,2,12,2z M12,4c4.43,0,8,3.57,8,8s-3.57,8-8,8s-8-3.57-8-8
      S7.57,4,12,4z"
      />,
      <path
        d="M9.62,7.258l2.374,6.703l2.361-6.703h2.501V16.5h-1.911v-2.526l0.19-4.36L12.642,16.5h-1.308L8.846,9.619l0.19,4.354V16.5
        H7.132V7.258H9.62z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-n': {
    element: [
      <path
        d="M12,2C6.489,2,2,6.489,2,12s4.489,10,10,10s10-4.489,10-10S17.511,2,12,2z M12,4c4.43,0,8,3.57,8,8s-3.57,8-8,8s-8-3.57-8-8
      S7.57,4,12,4z"
      />,
      <path d="M15.751,16.5h-1.904l-3.707-6.081V16.5H8.235V7.258h1.904l3.714,6.094V7.258h1.897V16.5z" />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-o': {
    element: [
      <path
        d="M12,2C6.489,2,2,6.489,2,12s4.489,10,10,10s10-4.489,10-10S17.511,2,12,2z M12,4c4.43,0,8,3.57,8,8s-3.57,8-8,8s-8-3.57-8-8
      S7.57,4,12,4z"
      />,
      <path
        d="M15.929,12.088c0,0.91-0.161,1.708-0.482,2.394c-0.322,0.686-0.782,1.215-1.381,1.587s-1.285,0.559-2.06,0.559
        c-0.766,0-1.449-0.184-2.05-0.553c-0.601-0.367-1.066-0.894-1.396-1.577s-0.497-1.47-0.501-2.358v-0.457
        c0-0.909,0.164-1.71,0.492-2.402c0.328-0.691,0.791-1.223,1.39-1.593c0.599-0.37,1.284-0.556,2.054-0.556
        c0.77,0,1.454,0.186,2.054,0.556c0.599,0.37,1.062,0.901,1.39,1.593c0.328,0.692,0.492,1.491,0.492,2.396V12.088z M13.999,11.67
        c0-0.97-0.174-1.706-0.521-2.209c-0.348-0.504-0.843-0.756-1.485-0.756c-0.639,0-1.132,0.249-1.479,0.746s-0.522,1.226-0.527,2.187
        v0.45c0,0.944,0.173,1.676,0.521,2.197c0.347,0.52,0.846,0.78,1.498,0.78c0.639,0,1.13-0.251,1.473-0.752
        c0.343-0.502,0.516-1.232,0.521-2.193V11.67z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-p': {
    element: [
      <path
        d="M12,2C6.489,2,2,6.489,2,12s4.489,10,10,10s10-4.489,10-10S17.511,2,12,2z M12,4c4.43,0,8,3.57,8,8s-3.57,8-8,8s-8-3.57-8-8
      S7.57,4,12,4z"
      />,
      <path
        d="M10.537,13.244V16.5H8.633V7.258h3.605c0.693,0,1.305,0.127,1.831,0.381c0.527,0.254,0.932,0.614,1.216,1.082
        c0.283,0.468,0.425,1,0.425,1.597c0,0.905-0.31,1.62-0.93,2.143s-1.478,0.784-2.574,0.784H10.537z M10.537,11.701h1.701
        c0.503,0,0.888-0.118,1.152-0.355c0.264-0.237,0.396-0.575,0.396-1.016c0-0.453-0.134-0.818-0.4-1.098s-0.635-0.424-1.104-0.432
        h-1.745V11.701z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-q': {
    element: [
      <path
        d="M12,2C6.489,2,2,6.489,2,12s4.489,10,10,10s10-4.489,10-10S17.511,2,12,2z M12,4c4.43,0,8,3.57,8,8s-3.57,8-8,8s-8-3.57-8-8
      S7.57,4,12,4z"
      />,
      <path
        d="M15.916,12.088c0,0.863-0.14,1.614-0.419,2.251s-0.667,1.147-1.162,1.532l1.536,1.207l-1.212,1.072l-1.968-1.58
        c-0.225,0.037-0.457,0.057-0.698,0.057c-0.766,0-1.449-0.184-2.05-0.553c-0.601-0.367-1.066-0.894-1.396-1.577
        s-0.497-1.47-0.501-2.358v-0.457c0-0.909,0.164-1.71,0.492-2.402c0.328-0.691,0.791-1.223,1.39-1.593
        c0.599-0.37,1.284-0.556,2.054-0.556c0.77,0,1.454,0.186,2.054,0.556c0.599,0.37,1.062,0.901,1.39,1.593
        c0.328,0.692,0.492,1.491,0.492,2.396V12.088z M13.986,11.67c0-0.97-0.174-1.706-0.521-2.209c-0.348-0.504-0.843-0.756-1.485-0.756
        c-0.639,0-1.132,0.249-1.479,0.746s-0.522,1.226-0.527,2.187v0.45c0,0.944,0.173,1.676,0.521,2.197
        c0.347,0.52,0.846,0.78,1.498,0.78c0.639,0,1.13-0.251,1.473-0.752c0.343-0.502,0.516-1.232,0.521-2.193V11.67z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-r': {
    element: [
      <path
        d="M12,2C6.489,2,2,6.489,2,12s4.489,10,10,10s10-4.489,10-10S17.511,2,12,2z M12,4c4.43,0,8,3.57,8,8s-3.57,8-8,8s-8-3.57-8-8
      S7.57,4,12,4z"
      />,
      <path
        d="M12.099,13.117h-1.518V16.5H8.677V7.258h3.435c1.092,0,1.934,0.243,2.526,0.73c0.592,0.486,0.889,1.174,0.889,2.062
        c0,0.631-0.137,1.156-0.41,1.577c-0.272,0.421-0.687,0.757-1.24,1.007l1.999,3.776V16.5h-2.044L12.099,13.117z M10.581,11.574
        h1.536c0.479,0,0.849-0.122,1.111-0.365c0.262-0.243,0.394-0.578,0.394-1.006c0-0.436-0.124-0.778-0.372-1.028
        c-0.247-0.25-0.627-0.374-1.139-0.374h-1.53V11.574z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-s': {
    element: [
      <path
        d="M12,2C6.489,2,2,6.489,2,12s4.489,10,10,10s10-4.489,10-10S17.511,2,12,2z M12,4c4.43,0,8,3.57,8,8s-3.57,8-8,8s-8-3.57-8-8
      S7.57,4,12,4z"
      />,
      <path
        d="M13.621,14.075c0-0.359-0.127-0.636-0.381-0.828s-0.711-0.396-1.371-0.609c-0.66-0.214-1.183-0.425-1.568-0.632
        c-1.049-0.567-1.574-1.331-1.574-2.291c0-0.5,0.141-0.945,0.422-1.337c0.282-0.392,0.686-0.697,1.213-0.917
        c0.526-0.22,1.118-0.33,1.773-0.33c0.66,0,1.249,0.119,1.765,0.358c0.517,0.239,0.918,0.577,1.203,1.013
        c0.286,0.436,0.429,0.931,0.429,1.485h-1.904c0-0.423-0.134-0.752-0.4-0.987c-0.267-0.234-0.641-0.352-1.123-0.352
        c-0.465,0-0.827,0.098-1.085,0.295c-0.258,0.196-0.387,0.456-0.387,0.777c0,0.301,0.151,0.553,0.454,0.756
        c0.302,0.203,0.748,0.393,1.336,0.57c1.083,0.326,1.872,0.73,2.367,1.213s0.743,1.083,0.743,1.803c0,0.8-0.303,1.427-0.908,1.882
        c-0.604,0.455-1.42,0.683-2.443,0.683c-0.711,0-1.358-0.13-1.942-0.391c-0.584-0.26-1.029-0.616-1.336-1.069
        c-0.307-0.453-0.46-0.978-0.46-1.574h1.911c0,1.02,0.609,1.53,1.828,1.53c0.452,0,0.806-0.093,1.06-0.276
        C13.494,14.662,13.621,14.405,13.621,14.075z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-t': {
    element: [
      <path
        d="M12,2C6.489,2,2,6.489,2,12s4.489,10,10,10s10-4.489,10-10S17.511,2,12,2z M12,4c4.43,0,8,3.57,8,8s-3.57,8-8,8s-8-3.57-8-8
      S7.57,4,12,4z"
      />,
      <path d="M15.761,8.801H12.93V16.5h-1.904V8.801H8.232V7.258h7.528V8.801z" />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-u': {
    element: [
      <path
        d="M12,2C6.489,2,2,6.489,2,12s4.489,10,10,10s10-4.489,10-10S17.511,2,12,2z M12,4c4.43,0,8,3.57,8,8s-3.57,8-8,8s-8-3.57-8-8
      S7.57,4,12,4z"
      />,
      <path
        d="M15.542,7.258v6.088c0,1.011-0.316,1.811-0.949,2.398c-0.632,0.589-1.496,0.883-2.593,0.883
        c-1.079,0-1.936-0.285-2.571-0.857c-0.635-0.57-0.958-1.355-0.971-2.354V7.258h1.904v6.1c0,0.605,0.145,1.047,0.435,1.324
        c0.29,0.277,0.691,0.416,1.203,0.416c1.071,0,1.614-0.563,1.632-1.689v-6.15H15.542z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-v': {
    element: [
      <path
        d="M12,2C6.489,2,2,6.489,2,12s4.489,10,10,10s10-4.489,10-10S17.511,2,12,2z M12,4c4.43,0,8,3.57,8,8s-3.57,8-8,8s-8-3.57-8-8
      S7.57,4,12,4z"
      />,
      <path d="M11.99,14.209l2.095-6.951h2.12L12.986,16.5H11L7.794,7.258h2.114L11.99,14.209z" />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-w': {
    element: [
      <path
        d="M12,2C6.489,2,2,6.489,2,12s4.489,10,10,10s10-4.489,10-10S17.511,2,12,2z M12,4c4.43,0,8,3.57,8,8s-3.57,8-8,8s-8-3.57-8-8
      S7.57,4,12,4z"
      />,
      <path
        d="M14.339,13.834l1.244-6.576h1.897l-2.05,9.242h-1.917l-1.505-6.183L10.505,16.5H8.588l-2.05-9.242h1.898l1.25,6.563
        l1.523-6.563h1.612L14.339,13.834z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-x': {
    element: [
      <path
        d="M12,2C6.489,2,2,6.489,2,12s4.489,10,10,10s10-4.489,10-10S17.511,2,12,2z M12,4c4.43,0,8,3.57,8,8s-3.57,8-8,8s-8-3.57-8-8
      S7.57,4,12,4z"
      />,
      <path
        d="M12.004,10.444l1.732-3.187h2.19l-2.691,4.583l2.761,4.659h-2.215l-1.777-3.237L10.226,16.5H8.011l2.761-4.659L8.081,7.258
        h2.19L12.004,10.444z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-y': {
    element: [
      <path
        d="M12,2C6.489,2,2,6.489,2,12s4.489,10,10,10s10-4.489,10-10S17.511,2,12,2z M12,4c4.43,0,8,3.57,8,8s-3.57,8-8,8s-8-3.57-8-8
      S7.57,4,12,4z"
      />,
      <path d="M11.994,11.422l1.923-4.164h2.082l-3.034,5.891V16.5h-1.936v-3.352L7.995,7.258h2.088L11.994,11.422z" />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-z': {
    element: [
      <path
        d="M12,2C6.489,2,2,6.489,2,12s4.489,10,10,10s10-4.489,10-10S17.511,2,12,2z M12,4c4.43,0,8,3.57,8,8s-3.57,8-8,8s-8-3.57-8-8
      S7.57,4,12,4z"
      />,
      <path d="M10.905,14.971h4.659V16.5h-7.04v-1.117l4.57-6.582H8.531V7.258h6.932V8.35L10.905,14.971z" />,
    ],
    viewBox: '0 0 24 24',
  },
  link: {
    element: [
      <path
        d="M12.707,15.293c-1.068,0-2.073-0.416-2.828-1.172c-0.391-0.391-0.391-1.023,0-1.414s1.023-0.391,1.414,0
      c0.756,0.756,2.072,0.756,2.828,0l2.829-2.828c0.779-0.78,0.779-2.049,0-2.829c-0.756-0.755-2.072-0.757-2.829,0
      c-0.391,0.391-1.023,0.391-1.414,0s-0.391-1.023,0-1.414c1.56-1.559,4.096-1.561,5.657,0c1.559,1.559,1.559,4.097,0,5.657
      l-2.829,2.828C14.78,14.877,13.775,15.293,12.707,15.293z"
      />,
      <path
        d="M8.464,19.533c-1.024,0-2.048-0.39-2.828-1.169c-0.756-0.756-1.172-1.76-1.172-2.829c0-1.068,0.416-2.072,1.172-2.828
      l2.828-2.828c1.511-1.512,4.145-1.512,5.657,0c0.391,0.391,0.391,1.023,0,1.414s-1.023,0.391-1.414,0
      c-0.756-0.757-2.074-0.756-2.829,0L7.05,14.121c-0.78,0.78-0.78,2.049,0,2.829c0.779,0.779,2.048,0.779,2.829,0
      c0.391-0.391,1.024-0.391,1.415,0c0.39,0.391,0.39,1.024,0,1.414C10.513,19.144,9.489,19.533,8.464,19.533z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  manage: {
    element: [
      <path
        d="M16.95,18c1.1,0,2-0.9,2-2s-0.9-2-2-2c-1.1,0-2,0.9-2,2S15.85,18,16.95,18z M20.85,16c0,0.2,0,0.3,0,0.5l1.1,0.8
      c0.1,0.1,0.1,0.2,0.1,0.3l-1,1.7c-0.2,0.2-0.4,0.2-0.5,0.2l-1.3-0.5c-0.3,0.2-0.5,0.4-0.9,0.5l-0.2,1.3c0,0.1-0.1,0.2-0.2,0.2h-2.1
      c-0.1,0-0.2-0.1-0.3-0.2l-0.1-1.3c-0.3-0.1-0.6-0.3-0.9-0.5l-1.2,0.5c-0.1,0-0.2,0-0.3-0.1l-1-1.7c-0.1-0.1,0-0.2,0.1-0.3l1.1-0.8
      c0-0.2,0-0.3,0-0.5s0-0.3,0.1-0.5l-1.1-0.8c-0.1-0.1-0.1-0.2-0.1-0.3l1-1.7c0.1-0.1,0.2-0.2,0.3-0.1l1.3,0.5
      c0.3-0.2,0.6-0.4,0.9-0.5l0.2-1.3c0-0.1,0.1-0.2,0.2-0.2h2.1c0.1,0,0.2,0.1,0.3,0.2v1.1c0.3,0.1,0.6,0.3,0.9,0.5l1.3-0.5
      c0.1,0,0.2,0,0.3,0.1l1,1.7c0.1,0.1,0,0.2-0.1,0.3l-1.1,0.9C20.75,15.7,20.85,15.8,20.85,16z M9.95,6c1.1,0,2,0.9,2,2s-0.9,2-2,2
      s-2-0.9-2-2S8.85,6,9.95,6z M10.95,13l-1,2c-2.7,0-5.8,1.3-6,2v1h6l1,2h-9v-3c0-2.7,5.3-4,8-4C10.25,13,10.55,13,10.95,13z
       M9.95,12c2.2,0,4-1.8,4-4s-1.8-4-4-4s-4,1.8-4,4S7.75,12,9.95,12z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  page: {
    element: [
      <path
        d="M14,2H6C4.9,2,4.01,2.9,4.01,4L4,20c0,1.1,0.89,2,1.99,2H18c1.1,0,2-0.9,2-2V8L14,2z M6,20V4h7v4c0,0.552,0.448,1,1,1h4v11
      H6z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  plan: {
    element: [
      <path
        d="M20.5,3l-0.16,0.03L15,5.1L9,3L3.36,4.9C3.15,4.97,3,5.15,3,5.38V20.5C3,20.78,3.22,21,3.5,21l0.16-0.03L9,18.9l6,2.1
      l5.64-1.9c0.21-0.07,0.36-0.25,0.36-0.48V3.5C21,3.22,20.78,3,20.5,3z M10,5.47l4,1.4v11.66l-4-1.4V5.47z M5,6.46l3-1.01v11.7
      l-3,1.16V6.46z M19,17.54l-3,1.01V6.86l3-1.16V17.54z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  welcome: {
    element: [
      <path
        d="M11.99,2C6.47,2,2,6.48,2,12s4.47,10,9.99,10C17.52,22,22,17.52,22,12S17.52,2,11.99,2z M18.92,8h-2.95
      c-0.32-1.25-0.78-2.45-1.38-3.56C16.43,5.07,17.96,6.35,18.92,8z M12,4.04c0.83,1.2,1.48,2.53,1.91,3.96h-3.82
      C10.52,6.57,11.17,5.24,12,4.04z M4.26,14C4.1,13.36,4,12.69,4,12s0.1-1.36,0.26-2h3.38c-0.08,0.66-0.14,1.32-0.14,2
      s0.06,1.34,0.14,2H4.26z M5.08,16h2.95c0.32,1.25,0.78,2.45,1.38,3.56C7.57,18.93,6.04,17.66,5.08,16z M8.03,8H5.08
      c0.96-1.66,2.49-2.93,4.33-3.56C8.81,5.55,8.35,6.75,8.03,8z M12,19.96c-0.83-1.2-1.48-2.53-1.91-3.96h3.82
      C13.48,17.43,12.83,18.76,12,19.96z M14.34,14H9.66c-0.09-0.66-0.16-1.32-0.16-2s0.07-1.35,0.16-2h4.68c0.09,0.65,0.16,1.32,0.16,2
      S14.43,13.34,14.34,14z M14.59,19.56c0.6-1.11,1.06-2.31,1.38-3.56h2.95C17.96,17.65,16.43,18.93,14.59,19.56z M16.36,14
      c0.08-0.66,0.14-1.32,0.14-2s-0.06-1.34-0.14-2h3.38C19.9,10.64,20,11.31,20,12s-0.1,1.36-0.26,2H16.36z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
};

const intellumIcons = {
  ...socialNavIcons,
  browse: {
    element: [
      <path
        d="M9,5v4H5V5H9 M10,3H4C3.448,3,3,3.448,3,4v6c0,0.552,0.448,1,1,1h6c0.552,0,1-0.448,1-1V4C11,3.448,10.552,3,10,3L10,3z
   M19,5v4h-4V5H19 M20,3h-6c-0.552,0-1,0.448-1,1v6c0,0.552,0.448,1,1,1h6c0.552,0,1-0.448,1-1V4C21,3.448,20.552,3,20,3L20,3z M9,15
  v4H5v-4H9 M10,13H4c-0.552,0-1,0.448-1,1v6c0,0.552,0.448,1,1,1h6c0.552,0,1-0.448,1-1v-6C11,13.448,10.552,13,10,13L10,13z M19,15
  v4h-4v-4H19 M20,13h-6c-0.552,0-1,0.448-1,1v6c0,0.552,0.448,1,1,1h6c0.552,0,1-0.448,1-1v-6C21,13.448,20.552,13,20,13L20,13z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  category: {
    element: [
      <path
        d="M19,5v14H5V5H19 M19,3H5C3.895,3,3,3.895,3,5v14c0,1.105,0.895,2,2,2h14c1.105,0,2-0.895,2-2V5C21,3.895,20.105,3,19,3L19,3
      z M17,7H7v2h10V7L17,7z M17,11H7v2h10V11L17,11z M17,15H7v2h10V15L17,15z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  discover: {
    element: [
      <path
        d="M12,2C6.48,2,2,6.48,2,12s4.48,10,10,10s10-4.48,10-10S17.52,2,12,2z M12,20c-4.41,0-8-3.59-8-8s3.59-8,8-8s8,3.59,8,8
      S16.41,20,12,20z M7.741,16.923l6.104-2.836c0.107-0.05,0.193-0.136,0.243-0.243l2.836-6.104c0.196-0.423-0.241-0.861-0.664-0.664
      l-6.104,2.836c-0.107,0.05-0.193,0.136-0.243,0.243l-2.836,6.104C6.88,16.682,7.318,17.12,7.741,16.923z M12,10.9
      c0.61,0,1.1,0.49,1.1,1.1s-0.49,1.1-1.1,1.1s-1.1-0.49-1.1-1.1S11.39,10.9,12,10.9z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  events: {
    element: [
      <path
        d="M20,4h-1V3c0-0.552-0.448-1-1-1l0,0c-0.552,0-1,0.448-1,1v1H7V3c0-0.552-0.448-1-1-1l0,0C5.448,2,5,2.448,5,3v1H4
      C2.9,4,2,4.9,2,6v14c0,1.1,0.9,2,2,2h16c1.1,0,2-0.9,2-2V6C22,4.9,21.1,4,20,4z M20,20H4v-9h16V20z M20,9H4V6h16V9z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  help: {
    element: [
      <path
        d="M11,18h2v-2h-2V18z M12,2C6.48,2,2,6.48,2,12s4.48,10,10,10s10-4.48,10-10S17.52,2,12,2z M12,20c-4.41,0-8-3.59-8-8
      s3.59-8,8-8s8,3.59,8,8S16.41,20,12,20z M12,6c-2.21,0-4,1.79-4,4h2c0-1.1,0.9-2,2-2s2,0.9,2,2c0,2-3,1.75-3,5h2c0-2.25,3-2.5,3-5
      C16,7.79,14.21,6,12,6z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  home: {
    element: [
      <path
        d="M12,5.69l5,4.5V18h-2v-5c0-0.552-0.448-1-1-1h-4c-0.552,0-1,0.448-1,1v5H7v-7.81L12,5.69 M11.666,3.301l-8.697,7.827
      C2.628,11.435,2.845,12,3.303,12H5v7c0,0.552,0.448,1,1,1h4c0.552,0,1-0.448,1-1v-5h2v5c0,0.552,0.448,1,1,1h4c0.552,0,1-0.448,1-1
      v-7h1.697c0.458,0,0.675-0.565,0.334-0.872l-8.697-7.827C12.144,3.13,11.856,3.13,11.666,3.301z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  live_events: {
    element: [
      <path d="M6.75 6.5V12.5L12 9.5L6.75 6.5ZM15.75 3.5H10.065L12.5325 1.0325L12 0.5L9 3.5H8.9775L5.9775 0.5L5.46 1.0325L7.92 3.5H2.25C1.425 3.5 0.75 4.175 0.75 5V14C0.75 14.825 1.425 15.5 2.25 15.5H15.75C16.575 15.5 17.25 14.825 17.25 14V5C17.25 4.175 16.575 3.5 15.75 3.5ZM15.75 14H2.25V5H15.75V14Z" />,
    ],
    viewBox: '0 0 18 16',
  },
  my_learning: {
    element: [
      <path d="M3 17.15V10C3 9.46667 3.19583 9.01667 3.5875 8.65C3.97917 8.28333 4.44167 8.11667 4.975 8.15C6.29167 8.35 7.54583 8.7375 8.7375 9.3125C9.92917 9.8875 11.0167 10.6333 12 11.55C12.9833 10.6333 14.0708 9.8875 15.2625 9.3125C16.4542 8.7375 17.7083 8.35 19.025 8.15C19.5583 8.11667 20.0208 8.28333 20.4125 8.65C20.8042 9.01667 21 9.46667 21 10V17.15C21 17.6833 20.825 18.1375 20.475 18.5125C20.125 18.8875 19.6833 19.0917 19.15 19.125C18.0833 19.2917 17.05 19.5667 16.05 19.95C15.05 20.3333 14.1167 20.8417 13.25 21.475C13.0667 21.625 12.8708 21.7375 12.6625 21.8125C12.4542 21.8875 12.2333 21.925 12 21.925C11.7667 21.925 11.5458 21.8875 11.3375 21.8125C11.1292 21.7375 10.9333 21.625 10.75 21.475C9.88333 20.8417 8.95 20.3333 7.95 19.95C6.95 19.5667 5.91667 19.2917 4.85 19.125C4.31667 19.0917 3.875 18.8875 3.525 18.5125C3.175 18.1375 3 17.6833 3 17.15ZM12 19.9C13.05 19.1167 14.1667 18.4917 15.35 18.025C16.5333 17.5583 17.75 17.25 19 17.1V10.2C17.7833 10.4167 16.5875 10.8542 15.4125 11.5125C14.2375 12.1708 13.1 13.05 12 14.15C10.9 13.05 9.7625 12.1708 8.5875 11.5125C7.4125 10.8542 6.21667 10.4167 5 10.2V17.1C6.25 17.25 7.46667 17.5583 8.65 18.025C9.83333 18.4917 10.95 19.1167 12 19.9ZM12 9C10.9 9 9.95833 8.60833 9.175 7.825C8.39167 7.04167 8 6.1 8 5C8 3.9 8.39167 2.95833 9.175 2.175C9.95833 1.39167 10.9 1 12 1C13.1 1 14.0417 1.39167 14.825 2.175C15.6083 2.95833 16 3.9 16 5C16 6.1 15.6083 7.04167 14.825 7.825C14.0417 8.60833 13.1 9 12 9ZM12 7C12.55 7 13.0208 6.80417 13.4125 6.4125C13.8042 6.02083 14 5.55 14 5C14 4.45 13.8042 3.97917 13.4125 3.5875C13.0208 3.19583 12.55 3 12 3C11.45 3 10.9792 3.19583 10.5875 3.5875C10.1958 3.97917 10 4.45 10 5C10 5.55 10.1958 6.02083 10.5875 6.4125C10.9792 6.80417 11.45 7 12 7Z" />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-01': {
    element: [
      <path
        d="M7,15h7v2H7V15z M7,11h10v2H7V11z M7,7h10v2H7V7z M19,3h-4.18C14.4,1.84,13.3,1,12,1S9.6,1.84,9.18,3H5
      C4.86,3,4.73,3.01,4.6,3.04C4.21,3.12,3.86,3.32,3.59,3.59c-0.18,0.18-0.33,0.4-0.43,0.64C3.06,4.46,3,4.72,3,5v14
      c0,0.27,0.06,0.54,0.16,0.78s0.25,0.45,0.43,0.64c0.27,0.27,0.62,0.47,1.01,0.55C4.73,20.99,4.86,21,5,21h14c1.1,0,2-0.9,2-2V5
      C21,3.9,20.1,3,19,3z M12,2.75c0.41,0,0.75,0.34,0.75,0.75S12.41,4.25,12,4.25s-0.75-0.34-0.75-0.75S11.59,2.75,12,2.75z M19,19H5V5
      h14V19z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-02': {
    element: [
      <path
        d="M12,3c-0.46,0-0.93,0.04-1.4,0.14C7.84,3.67,5.64,5.9,5.12,8.66c-0.48,2.61,0.48,5.01,2.22,6.56C7.77,15.6,8,16.13,8,16.69
      V19c0,1.1,0.9,2,2,2h0.28c0.35,0.6,0.98,1,1.72,1s1.38-0.4,1.72-1H14c1.1,0,2-0.9,2-2v-2.31c0-0.55,0.22-1.09,0.64-1.46
      C18.09,13.95,19,12.08,19,10C19,6.13,15.87,3,12,3z M14,17h-4v-1h4V17z M10,19v-1h4v1H10z M15.31,13.74
      c-0.09,0.08-0.16,0.18-0.24,0.26H8.92c-0.08-0.09-0.15-0.19-0.24-0.27c-1.32-1.18-1.91-2.94-1.59-4.7c0.36-1.94,1.96-3.55,3.89-3.93
      C11.32,5.03,11.66,5,12,5c2.76,0,5,2.24,5,5C17,11.43,16.39,12.79,15.31,13.74z M9,10.5c-0.276,0-0.5-0.224-0.5-0.5
      c0-1.93,1.57-3.5,3.5-3.5c0.276,0,0.5,0.224,0.5,0.5S12.276,7.5,12,7.5c-1.378,0-2.5,1.122-2.5,2.5C9.5,10.276,9.276,10.5,9,10.5z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-03': {
    element: [
      <path
        d="M11.594,2.681l-8,3.556C3.233,6.397,3,6.755,3,7.15V8c0,0.552,0.448,1,1,1h1v7c0,0.552,0.448,1,1,1l0,0c0.552,0,1-0.448,1-1
      V9h2v7c0,0.552,0.448,1,1,1l0,0c0.552,0,1-0.448,1-1V9h2v7c0,0.552,0.448,1,1,1l0,0c0.552,0,1-0.448,1-1V9h2v7c0,0.552,0.448,1,1,1
      l0,0c0.552,0,1-0.448,1-1V9h1c0.552,0,1-0.448,1-1V7.15c0-0.395-0.233-0.753-0.594-0.914l-8-3.556
      C12.148,2.566,11.852,2.566,11.594,2.681z M12,4.689L17.201,7H6.799L12,4.689z M3,20L3,20c0,0.552,0.448,1,1,1h16
      c0.552,0,1-0.448,1-1l0,0c0-0.552-0.448-1-1-1H4C3.448,19,3,19.448,3,20z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-04': {
    element: [
      <path
        d="M6,2C4.906,2,4,2.906,4,4v16c0,1.094,0.906,2,2,2h12c1.094,0,2-0.906,2-2V8l-6-6H6z M6,4h7v5h5v11H6V4z M8,12v2h8v-2H8z
      M8,16v2h8v-2H8z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-05': {
    element: [
      <path
        d="M9.015,12.554l1.76-2.765C11.163,9.914,11.57,10,12,10c2.209,0,4-1.791,4-4s-1.791-4-4-4S8,3.791,8,6
      c0,1.055,0.416,2.006,1.083,2.721l-1.751,2.751C7.955,11.736,8.52,12.107,9.015,12.554z M12,4c1.103,0,2,0.897,2,2s-0.897,2-2,2
      s-2-0.897-2-2S10.897,4,12,4z"
      />,
      <path
        d="M19,13c-0.43,0-0.837,0.086-1.225,0.211l-1.76-2.765c-0.495,0.447-1.06,0.818-1.682,1.082l1.751,2.751
      c-0.532,0.571-0.894,1.294-1.021,2.101C15.026,16.582,15,16.787,15,17s0.026,0.418,0.063,0.621C15.363,19.533,17.003,21,19,21
      c2.209,0,4-1.791,4-4S21.209,13,19,13z M19,19c-1.103,0-2-0.897-2-2s0.897-2,2-2s2,0.897,2,2S20.103,19,19,19z"
      />,
      <path
        d="M8.859,16C8.413,14.278,6.862,13,5,13c-2.209,0-4,1.791-4,4s1.791,4,4,4c1.862,0,3.413-1.278,3.859-3h4.232
      C13.035,17.674,13,17.341,13,17s0.035-0.674,0.09-1H8.859z M5,19c-1.103,0-2-0.897-2-2s0.897-2,2-2s2,0.897,2,2S6.103,19,5,19z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-06': {
    element: [
      <path
        d="M11,2v1H2v2h1v10c0,1.105,0.895,2,2,2h4.6L8,21h2l1.6-4h0.8l1.6,4h2l-1.6-4H19c1.105,0,2-0.895,2-2V5h1V3h-9V2H11z M5,5h14
      v10H5V5z"
      />,
      <path d="M9,7c-1.657,0-3,1.343-3,3s1.343,3,3,3s2.969-1.359,3-3H9V7z M14,7v2h4V7H14z M14,11v2h4v-2H14z" />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-07': {
    element: [
      <path
        d="M2,4v14c0,1.105,0.895,2,2,2h6.277c0.346,0.596,0.984,1,1.723,1s1.376-0.404,1.723-1H20c1.105,0,2-0.895,2-2V4h-8
      c-0.772,0-1.468,0.3-2,0.779C11.468,4.3,10.772,4,10,4H2z M4,6h6c0.551,0,1,0.449,1,1v11H4V6z M14,6h6v12h-7V7
      C13,6.449,13.449,6,14,6z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-08': {
    element: [
      <path
        d="M20.995,6.016c-0.553,0-1,0.448-1,1v10.988H12.41l0.297-0.297C15.369,15.045,17.955,15,18.002,15L19,14.996V4h-1
      c-0.206,0-2.747,0.032-6,2.658C8.747,4.032,6.206,4,6,4H5l0.002,10.996L5.998,15c0.045,0,2.633,0.045,5.295,2.707l0.297,0.297H3.953
      V7.016c0-0.552-0.448-1-1-1s-1,0.448-1,1v10.988c0,1.103,0.897,2,2,2h16.042c1.103,0,2-0.898,2-2V7.016
      C21.995,6.464,21.548,6.016,20.995,6.016z M13,8.455c1.894-1.688,2.563-2.223,4-2.383v6.984c-1.348,0.13-1.819,0.55-4,1.9V8.455z
       M11,14.957c-2.181-1.351-2.652-1.772-4-1.9V6.07c1.436,0.161,2.106,0.696,4,2.383V14.957z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-09': {
    element: [
      <path
        d="M7,2C5.355,2,4,3.355,4,5v14c0,1.645,1.355,3,3,3h13V2H7z M18,20H7c-0.565,0-1-0.435-1-1s0.435-1,1-1h11V20z M18,16H9.998
      V6h-2v10H7c-0.352,0-0.685,0.074-1,0.188V5c0-0.565,0.435-1,1-1h11V16z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-10': {
    element: [
      <path
        d="M16,2h-6H7C5.355,2,4,3.355,4,5v14c0,1.645,1.355,3,3,3h13v-0.535V20v-2v-2v-2.809V2H16z M12,4h2v4.277l-1-0.701l-1,0.701V4
      z M18,20H7c-0.565,0-1-0.435-1-1s0.435-1,1-1h11V20z M18,16H7c-0.352,0-0.685,0.074-1,0.188V5c0-0.565,0.435-1,1-1h3v8.123
      l1.574-1.104L13,10.018l3,2.105V4h2v9.191V16z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-11': {
    element: [
      <path
        d="M18,4H9H8.5C6.579,4,5,5.579,5,7.5C5,8.038,5.135,8.543,5.355,9H5H4.5C2.579,9,1,10.579,1,12.5
      c0,1.874,1.506,3.412,3.363,3.486C4.138,16.447,4,16.956,4,17.5C4,19.421,5.579,21,7.5,21H8h10h2v-2v-3v-2v-3V9V6V4H18z M4.5,14
      C3.659,14,3,13.341,3,12.5S3.659,11,4.5,11H5h5v3H4.5z M18,19H8H7.5C6.659,19,6,18.341,6,17.5S6.659,16,7.5,16H10v2l3-1.5l3,1.5v-2
      h2V19z M12,14.764V11h2v3.764l-0.105-0.053L13,14.264l-0.895,0.447L12,14.764z M18,14h-2v-3h2V14z M18,9h-2h-6H8.5
      C7.659,9,7,8.341,7,7.5S7.659,6,8.5,6H9h9V9z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-12': {
    element: [
      <path
        d="M12,2c-0.552,0-1,0.448-1,1v2H4C3.448,5,3,5.448,3,6v14c0,0.552,0.448,1,1,1h8h8c0.552,0,1-0.448,1-1V3c0-0.552-0.448-1-1-1
      H12z M13,4h6v2h-4v2h4v7h-4v2h4v2h-6V6V4z M5,7h6v2H7v2h4v4H7v2h4v2H5V7z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-13': {
    element: [
      <path
        d="M5,2C3.346,2,2,3.346,2,5v3h2v12h5v-2H6V8h11V5c0-0.551,0.448-1,1-1c0.565,0,1,0.435,1,1v15h2V5c0-1.645-1.355-3-3-3H5z
      M5,4h10.172C15.061,4.313,15,4.65,15,5v1H4V5C4,4.449,4.449,4,5,4z M8,10v2h9v-2H8z M8,14v2h2v-2H8z M14,14c-1.645,0-3,1.355-3,3
     c0,0.876,0.392,1.662,1,2.213v3.592l2-1.25l2,1.25v-3.592c0.608-0.551,1-1.336,1-2.213C17,15.355,15.645,14,14,14z M14,16
     c0.564,0,1,0.436,1,1s-0.436,1-1,1s-1-0.436-1-1S13.436,16,14,16z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-14': {
    element: [
      <path
        d="M4,4C2.895,4,2,4.895,2,6v12c0,1.105,0.895,2,2,2h2v-2H4V6h16v12h-2v2h2c1.105,0,2-0.895,2-2V6c0-1.105-0.895-2-2-2H4z
      M12,10c-2.209,0-4,1.791-4,4v10l4-2l4,2V14C16,11.791,14.209,10,12,10z M12,12c1.105,0,2,0.895,2,2s-0.895,2-2,2s-2-0.895-2-2
     S10.895,12,12,12z M10,17.445C10.59,17.789,11.268,18,12,18s1.41-0.211,2-0.555v3.318l-2-1l-2,1V17.445z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-15': {
    element: [
      <path
        d="M10,2C9.448,2,9,2.448,9,3v2H4C2.907,5,2,5.907,2,7v11c0,1.093,0.907,2,2,2h16c1.093,0,2-0.907,2-2V7c0-1.093-0.907-2-2-2
      h-5V3c0-0.552-0.448-1-1-1H10z M11,4h2v1h-2V4z M4,7h2v2h2V7h8v2h2V7h2v11H4V7z M14.5,10c-0.828,0-1.5,0.672-1.5,1.5
      s0.672,1.5,1.5,1.5s1.5-0.672,1.5-1.5S15.328,10,14.5,10z M18,12.684L13.342,15l1,2L19,14.684L18,12.684z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-16': {
    element: [
      <path
        d="M3.99,2.99c-0.552,0-1,0.448-1,1c0,0.046,0.003,0.093,0.01,0.138V16c0,0.265,0.105,0.52,0.293,0.707l3.912,3.912
  c0.223,0.293,0.59,0.439,0.953,0.381H20c0.552,0,1-0.448,1-1V8.168c0.062-0.365-0.083-0.735-0.377-0.961
  c-0.002-0.001-0.004-0.003-0.006-0.004l-3.91-3.91C16.52,3.105,16.265,3,16,3H4.117C4.075,2.994,4.033,2.991,3.99,2.99z M6.414,5
  h9.172l2,2H8.414L6.414,5z M5,6.414l2,2v9.172l-2-2V6.414z M9,9h10v10H9V9z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-17': {
    element: [
      <path
        d="M19,5v14H5V5H19 M19,3H5C3.9,3,3,3.9,3,5v14c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2V5C21,3.9,20.1,3,19,3z M14.14,11.86
      l-3,3.87L9,13.14L6,17h12C18,17,14.14,11.86,14.14,11.86z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-18': {
    element: [
      <path
        d="M4,6h16v2H4V6z M6,2h12v2H6V2z M20,10H4c-1.1,0-2,0.9-2,2v8c0,1.1,0.9,2,2,2h16c1.1,0,2-0.9,2-2v-8C22,10.9,21.1,10,20,10z
      M20,20H4v-8h16V20z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-19': {
    element: [
      <path
        d="M16,7c0.551,0,1,0.449,1,1c0,0.551-0.449,1-1,1c-0.551,0-1-0.449-1-1C15,7.449,15.449,7,16,7 M16,5c-1.657,0-3,1.343-3,3
      s1.343,3,3,3s3-1.343,3-3S17.657,5,16,5L16,5z"
      />,
      <path
        d="M16,15c0.551,0,1,0.449,1,1c0,0.551-0.449,1-1,1c-0.551,0-1-0.449-1-1C15,15.449,15.449,15,16,15 M16,13
        c-1.657,0-3,1.343-3,3s1.343,3,3,3s3-1.343,3-3S17.657,13,16,13L16,13z"
      />,
      <path
        d="M8,7c0.551,0,1,0.449,1,1c0,0.551-0.449,1-1,1S7,8.551,7,8C7,7.449,7.449,7,8,7 M8,5C6.343,5,5,6.343,5,8s1.343,3,3,3
        s3-1.343,3-3S9.657,5,8,5L8,5z"
      />,
      <path
        d="M8,15c0.551,0,1,0.449,1,1c0,0.551-0.449,1-1,1s-1-0.449-1-1C7,15.449,7.449,15,8,15 M8,13c-1.657,0-3,1.343-3,3
        s1.343,3,3,3s3-1.343,3-3S9.657,13,8,13L8,13z"
      />,
      <path d="M16.5,1C15.672,1,15,1.672,15,2.5S15.672,4,16.5,4S18,3.328,18,2.5S17.328,1,16.5,1L16.5,1z" />,
      <path d="M7.5,1C6.672,1,6,1.672,6,2.5S6.672,4,7.5,4S9,3.328,9,2.5S8.328,1,7.5,1L7.5,1z" />,
      <path d="M2.5,6C1.672,6,1,6.672,1,7.5S1.672,9,2.5,9S4,8.328,4,7.5S3.328,6,2.5,6L2.5,6z" />,
      <path d="M2.5,15C1.672,15,1,15.672,1,16.5S1.672,18,2.5,18S4,17.328,4,16.5S3.328,15,2.5,15L2.5,15z" />,
      <path d="M7.5,20C6.672,20,6,20.672,6,21.5S6.672,23,7.5,23S9,22.328,9,21.5S8.328,20,7.5,20L7.5,20z" />,
      <path d="M16.5,20c-0.828,0-1.5,0.672-1.5,1.5s0.672,1.5,1.5,1.5s1.5-0.672,1.5-1.5S17.328,20,16.5,20L16.5,20z" />,
      <path d="M21.5,15c-0.828,0-1.5,0.672-1.5,1.5s0.672,1.5,1.5,1.5s1.5-0.672,1.5-1.5S22.328,15,21.5,15L21.5,15z" />,
      <path d="M21.5,6C20.672,6,20,6.672,20,7.5S20.672,9,21.5,9S23,8.328,23,7.5S22.328,6,21.5,6L21.5,6z" />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-20': {
    element: [
      <path
        d="M5,3C3.907,3,3,3.907,3,5v14c0,1.093,0.907,2,2,2h14c1.093,0,2-0.907,2-2V5c0-1.093-0.907-2-2-2H5z M5,5h14v14H5V5z M7,7v2
      h2V7H7z M11,7v2h2V7H11z M15,7v2h2V7H15z M7,11v2h2v-2H7z M11,11v2h2v-2H11z M15,11v2h2v-2H15z M7,15v2h2v-2H7z M11,15v2h2v-2H11z
       M15,15v2h2v-2H15z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-21': {
    element: [
      <path
        d="M21,4H3C1.9,4,1,4.9,1,6v13c0,1.1,0.9,2,2,2h18c1.1,0,2-0.9,2-2V6C23,4.9,22.1,4,21,4z M3,19V6h8v13H3z M21,19h-8V6h8V19z
      M14,9.5h6V11h-6V9.5z M14,12h6v1.5h-6V12z M14,14.5h6V16h-6V14.5z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-22': {
    element: [
      <path
        d="M11,2v1H2v2h1v10c0,1.105,0.895,2,2,2h4.6L8,21h2l1.6-4h0.8l1.6,4h2l-1.6-4H19c1.105,0,2-0.895,2-2V5h1V3h-9V2H11z M5,5
      h14v10H5V5z"
      />,
      <path d="M14.14,8.86l-3,3.87L9,10.14L6,14h12L14.14,8.86z" />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-23': {
    element: [
      <path
        d="M13.001,3v2.121h4.463l-7.71,7.71C8.964,12.308,8.019,12,7,12c-2.761,0-5,2.239-5,5s2.239,5,5,5s5-2.239,5-5
      c0-1.019-0.308-1.964-0.832-2.754l7.71-7.71v4.463H21V3H13.001z M7,20c-1.654,0-3-1.346-3-3s1.346-3,3-3s3,1.346,3,3S8.654,20,7,20z
       M18.879,18.464L21,20.586L19.586,22l-2.121-2.121L15.343,22l-1.414-1.414l2.121-2.121l-2.121-2.121l1.414-1.414l2.121,2.121
      l2.121-2.121L21,16.343L18.879,18.464z M6.95,6.536l2.121,2.121l-1.414,1.414L5.536,7.95l-2.121,2.121L2,8.657l2.121-2.121L2,4.414
      L3.414,3l2.121,2.121L7.657,3l1.414,1.414L6.95,6.536z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-24': {
    element: [
      <path
        d="M8,8h8c0.552,0,1-0.448,1-1V3c0-0.551-0.449-1-1-1s-1,0.449-1,1v2c0,0.551-0.449,1-1,1s-1-0.449-1-1V3c0-0.551-0.449-1-1-1
      s-1,0.449-1,1v2c0,0.551-0.449,1-1,1S9,5.551,9,5V3c0-0.551-0.449-1-1-1S7,2.449,7,3v4C7,7.552,7.448,8,8,8z"
      />,
      <path
        d="M18.512,20.658L15.364,12H17c0.552,0,1-0.448,1-1s-0.448-1-1-1H7c-0.552,0-1,0.448-1,1s0.448,1,1,1h1.636l-3.148,8.658
      C5.251,21.31,5.734,22,6.428,22h11.145C18.266,22,18.749,21.31,18.512,20.658z M7.855,20l2.545-7h3.198l2.545,7H7.855z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-25': {
    element: [
      <path
        d="M20,6h2V4h-8.271C13.372,3.382,12.713,3.001,12,3c-0.714,0.001-1.373,0.382-1.73,1H2v2h2l-4,8c0,2.761,2.239,5,5,5
      s5-2.239,5-5L6,6h4.271C10.449,6.308,10.703,6.557,11,6.73V20H9v2h6v-2h-2V6.731C13.298,6.558,13.552,6.309,13.73,6H18l-4,8
      c0,2.761,2.239,5,5,5s5-2.239,5-5L20,6z M5,17c-1.305,0-2.403-0.837-2.816-2h5.633C7.403,16.163,6.305,17,5,17z M7.488,13H2.512
      L5,8.021L7.488,13z M19,8.021L21.488,13h-4.977L19,8.021z M19,17c-1.305,0-2.403-0.837-2.816-2h5.633C21.403,16.163,20.305,17,19,17
      z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-26': {
    element: [
      <path
        d="M14,3L14,3c-0.39,0.39-0.39,1.024,0,1.414l0.389,0.389L8.189,9.775L7.414,9C7.024,8.61,6.39,8.61,6,9l0,0
      c-0.39,0.39-0.39,1.024,0,1.414l3.094,3.094L3,19.6V21h1.4l6.092-6.094L13.586,18c0.39,0.39,1.024,0.39,1.414,0h0
      c0.39-0.39,0.39-1.024,0-1.414l-0.689-0.689l4.904-6.268L19.586,10c0.39,0.39,1.024,0.39,1.414,0v0c0.39-0.39,0.39-1.024,0-1.414
      L15.414,3C15.024,2.61,14.39,2.61,14,3z M15.799,6.236l1.98,1.98l-4.803,6.143l-3.252-3.252L15.799,6.236z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-27': {
    element: [
      <path
        d="M19.887,3H8.004c-0.265,0-0.52,0.105-0.707,0.293l-3.91,3.91C3.385,7.204,3.383,7.206,3.381,7.207
      C3.087,7.433,2.942,7.803,3.004,8.168V20c0,0.552,0.448,1,1,1h11.842c0.363,0.058,0.73-0.088,0.953-0.381l3.912-3.912
      c0.188-0.187,0.293-0.442,0.293-0.707V4.128c0.007-0.045,0.01-0.092,0.01-0.138c0-0.552-0.448-1-1-1
      C19.971,2.991,19.929,2.994,19.887,3z M15.59,7H6.418l2-2h9.172L15.59,7z M19.004,15.586l-2,2V8.414l2-2V15.586z M15.004,19h-10V9
      h10V19z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-28': {
    element: [
      <path
        d="M12,3c-0.46,0-0.93,0.04-1.4,0.14C7.84,3.67,5.64,5.9,5.12,8.66c-0.48,2.61,0.48,5.01,2.22,6.56C7.77,15.6,8,16.13,8,16.69
      V19c0,1.1,0.9,2,2,2h0.28c0.35,0.6,0.98,1,1.72,1s1.38-0.4,1.72-1H14c1.1,0,2-0.9,2-2v-2.31c0-0.55,0.22-1.09,0.64-1.46
      C18.09,13.95,19,12.08,19,10C19,6.13,15.87,3,12,3z M14,19h-4v-1h4V19z M14,17h-4v-1h4V17z M15.31,13.74
      c-0.09,0.08-0.16,0.18-0.24,0.26H12.5v-2.58l1.829-1.829l-0.707-0.707L12.006,10.5L10.38,8.874L9.672,9.581l1.828,1.828V14H8.92
      c-0.08-0.09-0.15-0.19-0.24-0.27c-1.32-1.18-1.91-2.94-1.59-4.7c0.36-1.94,1.96-3.55,3.89-3.93C11.32,5.03,11.66,5,12,5
      c2.76,0,5,2.24,5,5C17,11.43,16.39,12.79,15.31,13.74z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-29': {
    element: [
      <path
        d="M4,6h16v2H4V6z M6,2h12v2H6V2z M20,10H4c-1.1,0-2,0.9-2,2v8c0,1.1,0.9,2,2,2h16c1.1,0,2-0.9,2-2v-8C22,10.9,21.1,10,20,10z
      M20,20H4v-8h16V20z M17,14h-2v2H9v-2.008H7V18h10V14z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-30': {
    element: [
      <path
        d="M22,12c0-2.243-0.753-4.31-2.007-5.981c0.33-0.573,0.275-1.307-0.215-1.797c-0.49-0.49-1.224-0.545-1.797-0.215
      C16.31,2.753,14.243,2,12,2S7.69,2.753,6.019,4.007c-0.573-0.33-1.307-0.275-1.797,0.215c-0.49,0.49-0.545,1.224-0.215,1.797
      C2.753,7.69,2,9.757,2,12s0.753,4.31,2.007,5.981c-0.33,0.573-0.275,1.307,0.215,1.797c0.49,0.49,1.224,0.545,1.797,0.215
      C7.69,21.247,9.757,22,12,22s4.31-0.753,5.981-2.007c0.573,0.33,1.307,0.275,1.797-0.215c0.49-0.49,0.545-1.224,0.215-1.797
      C21.247,16.31,22,14.243,22,12z M18.621,16.5l-1.461-1.461C17.689,14.146,18,13.109,18,12s-0.311-2.146-0.84-3.039L18.621,7.5
      C19.491,8.781,20,10.329,20,12S19.491,15.219,18.621,16.5z M14.121,14.121c-0.396,0.396-0.502,0.955-0.362,1.459
      C13.227,15.841,12.636,16,12,16s-1.227-0.159-1.76-0.419c0.14-0.504,0.035-1.063-0.362-1.459c-0.396-0.396-0.955-0.502-1.459-0.362
      C8.159,13.227,8,12.636,8,12s0.159-1.227,0.419-1.76c0.504,0.14,1.063,0.035,1.459-0.362c0.396-0.396,0.502-0.955,0.362-1.459
      C10.773,8.159,11.364,8,12,8s1.227,0.159,1.76,0.419c-0.14,0.504-0.034,1.063,0.362,1.459s0.955,0.502,1.459,0.362
      C15.841,10.773,16,11.364,16,12s-0.159,1.227-0.419,1.76C15.076,13.62,14.518,13.725,14.121,14.121z M16.5,5.379L15.039,6.84
      C14.146,6.311,13.109,6,12,6S9.854,6.311,8.961,6.84L7.5,5.379C8.781,4.509,10.329,4,12,4S15.219,4.509,16.5,5.379z M5.379,7.5
      L6.84,8.961C6.311,9.854,6,10.891,6,12s0.311,2.146,0.84,3.039L5.379,16.5C4.509,15.219,4,13.671,4,12S4.509,8.781,5.379,7.5z
       M7.5,18.621l1.461-1.461C9.854,17.689,10.891,18,12,18s2.146-0.311,3.039-0.84l1.461,1.461C15.219,19.491,13.671,20,12,20
      S8.781,19.491,7.5,18.621z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-31': {
    element: [
      <path
        d="M17,2H4v20h13c1.645,0,3-1.355,3-3V5C20,3.355,18.645,2,17,2z M9,4h2v4.277l-1-0.701L9,8.277V4z M6,4h1v8.123l3-2.105
      l1.426,1.002L13,12.123V4h2v16H6V4z M18,19c0,0.565-0.435,1-1,1V4c0.565,0,1,0.435,1,1V19z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-32': {
    element: [
      <path
        d="M20,7h-4V5l-2-2h-4L8,5v2H4C2.9,7,2,7.9,2,9v5c0,0.75,0.4,1.38,1,1.73V19c0,1.11,0.89,2,2,2h14c1.11,0,2-0.89,2-2v-3.28
      c0.59-0.35,1-0.99,1-1.72V9C22,7.9,21.1,7,20,7z M10,5h4v2h-4V5z M4,9h16v5h-5v-3H9v3H4V9z M13,15h-2v-2h2V15z M19,19H5v-3h4v1h6v-1
      h4V19z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-33': {
    element: [
      <path
        d="M6,2C4.907,2,4,2.907,4,4v1H3C2.448,5,2,5.448,2,6s0.448,1,1,1h1v2H3c-0.552,0-1,0.448-1,1s0.448,1,1,1h1v2H3
      c-0.552,0-1,0.448-1,1s0.448,1,1,1h1v2H3c-0.552,0-1,0.448-1,1s0.448,1,1,1h1v1c0,1.093,0.907,2,2,2h12c1.093,0,2-0.907,2-2V4
      c0-1.093-0.907-2-2-2H6z M6,4h12v16H6V4z M8,7v3h8V7H8z M8,12v2h8v-2H8z M8,15v2h8v-2H8z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-34': {
    element: [
      <path
        d="M20.66,7c-0.521-0.902-1.682-1.34-3.208-1.34c-0.586,0-1.229,0.071-1.906,0.198C14.723,3.514,13.442,2,12,2
      S9.277,3.514,8.454,5.859C7.776,5.731,7.133,5.66,6.547,5.66C5.022,5.66,3.861,6.098,3.34,7c-0.721,1.249-0.051,3.115,1.568,5
      c-1.619,1.885-2.289,3.751-1.568,5c0.521,0.902,1.682,1.34,3.208,1.34c0.586,0,1.229-0.071,1.906-0.198
      C9.277,20.486,10.558,22,12,22s2.723-1.514,3.546-3.859c0.677,0.127,1.321,0.198,1.906,0.198c1.525,0,2.687-0.437,3.208-1.34
      c0.721-1.249,0.051-3.115-1.568-5C20.711,10.115,21.381,8.249,20.66,7z M17.453,7.66c1.052,0,1.437,0.272,1.476,0.34
      c0.076,0.132,0.02,0.863-0.836,2.051c-0.125,0.174-0.262,0.348-0.407,0.523c-0.412-0.369-0.858-0.732-1.334-1.086
      c-0.069-0.588-0.16-1.155-0.273-1.696C16.564,7.708,17.028,7.66,17.453,7.66z M13.25,14.165c-0.414,0.239-0.832,0.454-1.25,0.658
      c-0.418-0.204-0.836-0.419-1.25-0.658c-0.413-0.238-0.81-0.492-1.197-0.754C9.522,12.96,9.5,12.494,9.5,12s0.022-0.96,0.053-1.411
      c0.386-0.261,0.784-0.515,1.197-0.754c0.414-0.239,0.832-0.454,1.25-0.658c0.418,0.204,0.836,0.419,1.25,0.658
      c0.413,0.238,0.81,0.492,1.197,0.754C14.478,11.04,14.5,11.506,14.5,12s-0.022,0.96-0.053,1.411
      C14.06,13.673,13.663,13.927,13.25,14.165z M12,4c0.333,0,1.025,0.82,1.597,2.368C13.074,6.54,12.541,6.741,12,6.974
      c-0.541-0.234-1.074-0.435-1.597-0.606C10.975,4.82,11.667,4,12,4z M5.072,8c0.039-0.067,0.424-0.34,1.476-0.34
      c0.425,0,0.888,0.048,1.374,0.132C7.809,8.333,7.718,8.9,7.649,9.488c-0.476,0.354-0.921,0.717-1.334,1.086
      c-0.146-0.175-0.282-0.349-0.407-0.523C5.052,8.863,4.996,8.132,5.072,8z M6.547,16.34c-1.052,0-1.437-0.272-1.476-0.34
      c-0.076-0.132-0.02-0.863,0.836-2.051c0.125-0.174,0.262-0.348,0.407-0.523c0.412,0.369,0.858,0.732,1.334,1.086
      c0.069,0.588,0.16,1.155,0.273,1.696C7.436,16.292,6.972,16.34,6.547,16.34z M12,20c-0.333,0-1.025-0.82-1.597-2.368
      c0.523-0.172,1.056-0.373,1.597-0.606c0.541,0.234,1.074,0.435,1.597,0.606C13.025,19.18,12.333,20,12,20z M18.928,16
      c-0.039,0.067-0.424,0.34-1.476,0.34c-0.425,0-0.888-0.048-1.375-0.132c0.113-0.541,0.205-1.108,0.273-1.696
      c0.476-0.354,0.921-0.717,1.334-1.086c0.146,0.175,0.282,0.349,0.407,0.523C18.948,15.137,19.004,15.868,18.928,16z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-35': {
    element: [
      <path
        d="M11,2v1H2v2h1v10c0,1.105,0.895,2,2,2h4.6L8,21h2l1.6-4h0.8l1.6,4h2l-1.6-4H19c1.105,0,2-0.895,2-2V5h1V3h-9V2H11z M5,5h14
      v10H5V5z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-36': {
    element: [
      <path
        d="M20,9c-1.396,0-2.559,0.958-2.894,2.25h-3.212C13.559,9.958,12.396,9,11,9c-0.473,0-0.915,0.12-1.313,0.315L7.457,6.714
      C7.797,6.228,8,5.638,8,5c0-1.657-1.343-3-3-3S2,3.343,2,5s1.343,3,3,3c0.474,0,0.915-0.12,1.314-0.315l2.229,2.601
      C8.203,10.772,8,11.361,8,12c0,0.639,0.203,1.228,0.543,1.714l-2.229,2.601C5.915,16.12,5.474,16,5,16c-1.657,0-3,1.343-3,3
      s1.343,3,3,3s3-1.343,3-3c0-0.639-0.203-1.228-0.543-1.714l2.229-2.601C10.085,14.88,10.526,15,11,15
      c1.396,0,2.559-0.958,2.894-2.25h3.212C17.441,14.042,18.604,15,20,15c1.657,0,3-1.343,3-3S21.657,9,20,9z M3.5,5
      c0-0.827,0.673-1.5,1.5-1.5S6.5,4.173,6.5,5S5.827,6.5,5,6.5S3.5,5.827,3.5,5z M5,20.5c-0.827,0-1.5-0.673-1.5-1.5
      s0.673-1.5,1.5-1.5s1.5,0.673,1.5,1.5S5.827,20.5,5,20.5z M11,13.5c-0.827,0-1.5-0.673-1.5-1.5s0.673-1.5,1.5-1.5s1.5,0.673,1.5,1.5
      S11.827,13.5,11,13.5z M20,13.5c-0.827,0-1.5-0.673-1.5-1.5s0.673-1.5,1.5-1.5s1.5,0.673,1.5,1.5S20.827,13.5,20,13.5z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-37': {
    element: [
      <path
        d="M6,2C4.897,2,4,2.897,4,4v16c0,1.103,0.897,2,2,2h6.26c-0.422-0.604-0.75-1.277-0.965-2H6V4h7v5h5v2
      c0.695,0,1.366,0.106,2,0.295V8l-6-6H6z M18,13c-2.8,0-5,2.2-5,5s2.2,5,5,5c1,0,2.001-0.301,2.801-0.801L22.6,24l1.4-1.4
      l-1.801-1.799C22.699,20.001,23,19,23,18C23,15.2,20.8,13,18,13z M18,15c1.7,0,3,1.3,3,3s-1.3,3-3,3s-3-1.3-3-3S16.3,15,18,15z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-38': {
    element: [
      <path
        d="M20,15h-7c-0.552,0-1,0.448-1,1s0.448,1,1,1h3v2h-5.104C10.592,17.438,9.54,15.495,7,15.086v-6.09
      c0-0.009,0.023-0.911,0.566-1.48L12.5,12.45c0.39,0.39,0.902,0.584,1.414,0.584s1.024-0.194,1.414-0.584l2.121-2.121
      c0.378-0.377,0.586-0.88,0.586-1.415c0-0.534-0.208-1.036-0.586-1.414L12.5,2.55c-0.756-0.756-2.075-0.756-2.828,0L7.551,4.671
      C7.33,4.892,7.175,5.157,7.078,5.444C6.746,5.612,6.435,5.813,6.169,6.081C5.025,7.229,4.999,8.826,5,9v10H4c-0.552,0-1,0.448-1,1
      s0.448,1,1,1h14c0.552,0,1-0.448,1-1s-0.448-1-1-1v-2h2c0.552,0,1-0.448,1-1S20.552,15,20,15z M11.086,3.964l4.949,4.95l-2.12,2.123
      L8.994,6.115V6.057L11.086,3.964z M7,17.128C8.144,17.444,8.635,18.29,8.844,19H7V17.128z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-39': {
    element: [
      <path
        d="M22.293,19.293L4.707,1.707c-0.204-0.204-0.454-0.295-0.7-0.295C3.493,1.412,3,1.811,3,2.414V21h18.586
      C22.477,21,22.923,19.923,22.293,19.293z M5,19v-1h1c0.552,0,1-0.448,1-1s-0.448-1-1-1H5v-2h1c0.552,0,1-0.448,1-1s-0.448-1-1-1H5
      v-2h1c0.552,0,1-0.448,1-1S6.552,8,6,8H5V4.828L19.172,19H5z"
      />,
      <path d="M9,17h3.586c0.891,0,1.337-1.077,0.707-1.707l-3.586-3.586C9.077,11.077,8,11.523,8,12.414V16C8,16.552,8.448,17,9,17z" />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-40': {
    element: [
      <path
        d="M12,15.5c3.038,0,5.5-2.462,5.5-5.5c0-3.038-2.462-5.5-5.5-5.5S6.5,6.962,6.5,10C6.5,13.038,8.962,15.5,12,15.5z M12,6.5
      c1.93,0,3.5,1.57,3.5,3.5c0,1.93-1.57,3.5-3.5,3.5S8.5,11.93,8.5,10C8.5,8.07,10.07,6.5,12,6.5z"
      />,
      <path
        d="M21,10c0-2.076-0.722-4.033-1.982-5.604l0.689-0.689c0.391-0.39,0.391-1.023,0-1.414s-1.023-0.391-1.414,0l-0.688,0.688
      c-0.234-0.186-0.47-0.371-0.725-0.536c-0.463-0.301-1.082-0.167-1.383,0.296c-0.3,0.464-0.167,1.083,0.297,1.383
      C17.802,5.423,19,7.62,19,10c0,3.859-3.141,7-7,7c-2.38,0-4.577-1.198-5.876-3.205c-0.3-0.464-0.918-0.597-1.383-0.297
      c-0.463,0.301-0.596,0.92-0.296,1.383c0.165,0.255,0.349,0.491,0.536,0.724l-0.688,0.688c-0.391,0.391-0.391,1.023,0,1.414
      C4.488,17.902,4.744,18,5,18s0.512-0.098,0.707-0.293l0.688-0.689c1.316,1.055,2.902,1.73,4.604,1.919V21H7v2h4h2h4v-2h-4v-2.059
      C17.493,18.442,21,14.625,21,10z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-41': {
    element: [
      <path
        d="M6,2C4.895,2,4,2.895,4,4v16c0,1.105,0.895,2,2,2h12c1.105,0,2-0.895,2-2V4c0-1.105-0.895-2-2-2H6z M6,4h12v2H6V4z M6,8h12
      v12H6V8z M8,10v2h2v-2H8z M11,10v2h2v-2H11z M14,10v2h2v-2H14z M8,13v2h2v-2H8z M11,13v2h2v-2H11z M14,13v2h2v-2H14z M8,16v2h2v-2H8
      z M11,16v2h5v-2H11z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-42': {
    element: [
      <path
        d="M7,11h2v2H7V11z M21,6v14c0,1.1-0.9,2-2,2H5c-1.11,0-2-0.9-2-2L3.01,6c0-1.1,0.88-2,1.99-2h1V2h2v2h8V2h2v2h1
      C20.1,4,21,4.9,21,6z M5,8h14V6H5V8z M19,20V10H5v10H19z M15,13h2v-2h-2V13z M11,13h2v-2h-2V13z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-43': {
    element: [
      <path
        d="M12,2C8.024,2,4,3.374,4,6v12c0,2.626,4.024,4,8,4s8-1.374,8-4V6C20,3.374,15.976,2,12,2z M12,4c3.722,0,6,1.295,6,2
      s-2.278,2-6,2C8.278,8,6,6.705,6,6S8.278,4,12,4z M12,20c-3.722,0-6-1.295-6-2v-3.268C7.541,15.57,9.778,16,12,16
      s4.459-0.43,6-1.268V18C18,18.705,15.722,20,12,20z M12,14c-3.722,0-6-1.295-6-2V8.732C7.541,9.57,9.778,10,12,10
      s4.459-0.43,6-1.268V12C18,12.705,15.722,14,12,14z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-44': {
    element: [
      <path
        d="M17,3H5C3.89,3,3,3.9,3,5v14c0,1.1,0.89,2,2,2h14c1.1,0,2-0.9,2-2V7L17,3z M19,19H5V5h11.17L19,7.83V19z M12,12
      c-1.66,0-3,1.34-3,3s1.34,3,3,3s3-1.34,3-3S13.66,12,12,12z M6,6h9v4H6V6z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-45': {
    element: [
      <path
        d="M19,3H5C3.9,3,3,3.9,3,5v14c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2V5C21,3.9,20.1,3,19,3z M19,19H5V5h14V19z M7,10h2v7H7V10z
      M11,7h2v10h-2V7z M15,13h2v4h-2V13z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-46': {
    element: [
      <path
        d="M12,2C6.48,2,2,6.48,2,12s4.48,10,10,10s10-4.48,10-10S17.52,2,12,2z M19.93,11H13V4.07C16.61,4.52,19.48,7.39,19.93,11z
      M4,12c0-4.07,3.06-7.44,7-7.93v15.86C7.06,19.44,4,16.07,4,12z M13,19.93V13h6.93C19.48,16.61,16.61,19.48,13,19.93z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-47': {
    element: [
      <path
        d="M16.95,9.878l-1.099,1.099C15.938,11.306,16,11.644,16,12c0,2.206-1.794,4-4,4s-4-1.794-4-4s1.794-4,4-4
      c0.356,0,0.694,0.062,1.022,0.149l1.099-1.099L13.98,6.342C13.36,6.124,12.695,6,12,6c-3.314,0-6,2.686-6,6s2.686,6,6,6
      s6-2.686,6-6c0-0.695-0.124-1.36-0.342-1.98L16.95,9.878z"
      />,
      <path
        d="M21.242,9.828c-0.375,0.375-0.872,0.581-1.402,0.585C19.944,10.926,20,11.457,20,12c0,4.411-3.589,8-8,8s-8-3.589-8-8
      s3.589-8,8-8c0.546,0,1.079,0.056,1.595,0.161c0.003-0.522,0.2-1.026,0.577-1.403l0.409-0.409C13.756,2.128,12.894,2,12,2
      C6.477,2,2,6.477,2,12s4.477,10,10,10s10-4.477,10-10c0-0.894-0.128-1.756-0.349-2.581L21.242,9.828z"
      />,
      <path
        d="M22.923,5.049L21.394,4.02l1.263-1.263c0.391-0.391,0.391-1.024,0-1.414s-1.024-0.391-1.414,0L19.98,2.606l-1.03-1.528
    c-0.166-0.248-0.436-0.408-0.732-0.437c-0.293-0.032-0.592,0.077-0.804,0.288l-2.535,2.535c-0.236,0.236-0.339,0.575-0.273,0.903
    l0.602,3.011l-2.864,2.864c-0.391,0.391-0.391,1.024,0,1.414s1.024,0.391,1.414,0l2.864-2.864l3.01,0.602
    c0.065,0.013,0.131,0.02,0.196,0.02c0.263,0,0.518-0.104,0.707-0.293l2.536-2.535c0.211-0.211,0.317-0.506,0.288-0.803
    C23.331,5.485,23.171,5.216,22.923,5.049z M19.5,7.329l-2.357-0.471L16.672,4.5l1.298-1.298l1.029,1.528
    c0.071,0.107,0.164,0.199,0.271,0.271l1.529,1.029L19.5,7.329z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-48': {
    element: [
      <path
        d="M6.05,8.05c-2.734,2.734-2.734,7.166,0,9.9s7.166,2.734,9.9,0l0,0C19.43,14.47,20.001,4,20.001,4S9.53,4.57,6.05,8.05z
      M14.54,16.54c-1.594,1.602-4.07,1.922-6.02,0.78c0.907-2.85,2.599-5.387,4.881-7.32c-2.636,1.375-4.84,3.451-6.37,6
     c-1.507-1.984-1.32-4.776,0.44-6.54c1.74-1.74,6.57-2.81,10.33-3.26C17.35,9.96,16.28,14.79,14.54,16.54z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-49': {
    element: [
      <path
        d="M12,3C5.935,3,1,7.935,1,14c0,1.935,0.51,3.837,1.473,5.502l0.289,0.5L4,20h2v-2H3.936C3.323,16.765,3,15.393,3,14
      c0-4.963,4.038-9,9-9s9,4.037,9,9c0,1.393-0.322,2.764-0.936,4H18v2h2h1h0.238l0.289-0.498C22.49,17.837,23,15.935,23,14
      C23,7.935,18.065,3,12,3z M12,6c-0.552,0-1,0.448-1,1s0.448,1,1,1s1-0.448,1-1S12.552,6,12,6z M8.5,7c-0.552,0-1,0.448-1,1
      s0.448,1,1,1s1-0.448,1-1S9.052,7,8.5,7z M15.438,7c-0.552,0-1,0.448-1,1s0.448,1,1,1s1-0.448,1-1S15.99,7,15.438,7z M6,9.5
      c-0.552,0-1,0.448-1,1s0.448,1,1,1s1-0.448,1-1S6.552,9.5,6,9.5z M18.529,10.25c0,0-6.952,1.799-6.967,1.803l-0.059,0.014
      l0.002,0.004C10.642,12.29,10,13.067,10,14c0,1.105,0.895,2,2,2c0.509,0,0.969-0.196,1.322-0.51L18.529,10.25z M5,13
      c-0.552,0-1,0.448-1,1s0.448,1,1,1s1-0.448,1-1S5.552,13,5,13z M19,13c-0.552,0-1,0.448-1,1s0.448,1,1,1s1-0.448,1-1
      S19.552,13,19,13z M9,18.002v2h6v-2H9z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-50': {
    element: [
      <path
        d="M19.66,3.99c-2.64-1.8-5.9-0.96-7.66,1.1c-1.76-2.06-5.02-2.91-7.66-1.1C2.94,4.95,2.06,6.57,2,8.28
      c-0.14,3.88,3.3,6.99,8.55,11.76l0.1,0.09c0.76,0.69,1.93,0.69,2.69-0.01l0.11-0.1c5.25-4.76,8.68-7.87,8.55-11.75
      C21.94,6.57,21.06,4.95,19.66,3.99z M12.1,18.55l-0.1,0.1l-0.1-0.1c-4.934-4.468-8.127-7.366-7.887-10.367
      C4.067,7.5,4.352,6.84,4.79,6.313c1.798-2.168,4.761-1.385,5.957,0.424C11,7.12,11.417,7.36,11.876,7.36h0.25
      c0.471,0,0.888-0.257,1.15-0.648c1.201-1.798,4.17-2.562,5.952-0.375c0.431,0.53,0.712,1.19,0.762,1.871
      C20.21,11.2,17.02,14.095,12.1,18.55z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-51': {
    element: [
      <path
        d="M20,3l-1,1.285L6,9v6l2.451,0.889l-0.283,0.801c-0.213,0.601,0.101,1.26,0.703,1.473l2.178,0.771
      c0.601,0.213,1.262-0.103,1.475-0.705l0.27-0.764L19,19.715L20,21h2V3H20z M20,6.051v11.898l-0.318-0.115L8,13.598v-3.195
      l11.682-4.236L20,6.051z M2,9v6h2V9H2z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-52': {
    element: [
      <path
        d="M12,4C4,4,1,12,1,12s3,8,11,8s11-8,11-8S20,4,12,4z M12,6c5.276,0,7.945,4.267,8.809,5.996C19.944,13.713,17.255,18,12,18
  c-5.276,0-7.945-4.267-8.809-5.996C4.057,10.287,6.745,6,12,6z M12,8c-2.209,0-4,1.791-4,4s1.791,4,4,4s4-1.791,4-4S14.209,8,12,8z
   M12,10c1.105,0,2,0.895,2,2s-0.895,2-2,2s-2-0.895-2-2S10.895,10,12,10z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-53': {
    element: [
      <path d="M6.85,3l-5.145,9l5.145,9h0.58h9.721l5.145-9L17.15,3H6.85z M8.01,5h7.98l4.002,7l-4.002,7H8.01l-4.002-7L8.01,5z" />,
      <path
        d="M12,15.5c-1.93,0-3.5-1.57-3.5-3.5s1.57-3.5,3.5-3.5s3.5,1.57,3.5,3.5S13.93,15.5,12,15.5z M12,10.5
        c-0.827,0-1.5,0.673-1.5,1.5s0.673,1.5,1.5,1.5s1.5-0.673,1.5-1.5S12.827,10.5,12,10.5z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-54': {
    element: [
      <path
        d="M9,2C7.346,2,6,3.346,6,5c0,0.352,0.071,0.686,0.184,1H2v6h1v7.088C3,20.143,3.857,21,4.912,21h14.176
      C20.143,21,21,20.143,21,19.088V12h1V6h-4.184C17.929,5.686,18,5.352,18,5c0-1.654-1.346-3-3-3c-0.771,0-1.468,0.3-2,0.779V2.766
      l-0.078,0.078c-0.027,0.026-0.052,0.051-0.078,0.078L12,3.766l-0.844-0.844c-0.026-0.027-0.051-0.052-0.078-0.078L11,2.766v0.014
      C10.468,2.3,9.771,2,9,2z M9,4c0.552,0,1,0.449,1,1S9.552,6,9,6S8,5.551,8,5S8.448,4,9,4z M15,4c0.552,0,1,0.449,1,1s-0.448,1-1,1
      s-1-0.449-1-1S14.448,4,15,4z M4,8h16v2H4V8z M5,12h6v7H5V12z M13,12h6v7h-6V12z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-55': {
    element: [
      <path
        d="M22,6c0-1.1-0.9-2-2-2H4C2.9,4,2,4.9,2,6v12c0,1.1,0.9,2,2,2h16c1.1,0,2-0.9,2-2V6z M20,6l-8,4.99L4,6H20z M20,18H4V8l8,5
      l8-5V18z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-56': {
    element: [
      <path
        d="M12.5,22C9.46,22,7,19.54,7,16.5V6c0-2.21,1.79-4,4-4s4,1.79,4,4v8.5c0,1.38-1.12,2.5-2.5,2.5S10,15.88,10,14.5V7h2v7.59
  c0,0.55,1,0.55,1,0V6c0-1.1-0.9-2-2-2S9,4.9,9,6v10.5c0,1.93,1.57,3.5,3.5,3.5s3.5-1.57,3.5-3.5V7h2v9.5C18,19.54,15.54,22,12.5,22z
  "
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-57': {
    element: [
      <path
        d="M11,7h2v2h-2V7z M11,11h2v6h-2V11z M12,2C6.48,2,2,6.48,2,12s4.48,10,10,10s10-4.48,10-10S17.52,2,12,2z M12,20
      c-4.41,0-8-3.59-8-8s3.59-8,8-8s8,3.59,8,8S16.41,20,12,20z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-58': {
    element: [
      <path
        d="M11,18h2v-2h-2V18z M12,2C6.48,2,2,6.48,2,12s4.48,10,10,10s10-4.48,10-10S17.52,2,12,2z M12,20c-4.41,0-8-3.59-8-8
      s3.59-8,8-8s8,3.59,8,8S16.41,20,12,20z M12,6c-2.21,0-4,1.79-4,4h2c0-1.1,0.9-2,2-2s2,0.9,2,2c0,2-3,1.75-3,5h2c0-2.25,3-2.5,3-5
      C16,7.79,14.21,6,12,6z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-59': {
    element: [
      <path
        d="M4.039,10.061c-2.719,2.719-2.719,7.18,0,9.899s7.18,2.719,9.899,0c1.962-1.962,2.407-4.79,1.606-7.263l1.929-1.929
      l2.121,2.121l4.243-4.243l-2.121-2.121l1.414-1.414l-4.243-4.243l-0.707,0.707l-6.868,6.868C8.882,7.588,6.047,8.054,4.039,10.061z
       M5.454,11.475c1.612-1.612,3.899-1.889,5.716-1.01l0.639,0.311l7.079-7.079l1.414,1.414l-1.414,1.414l2.121,2.121l-1.414,1.414
      L17.474,7.94l-4.23,4.23l0.273,0.624c0.835,1.909,0.537,4.222-0.993,5.752c-1.948,1.948-5.123,1.948-7.071,0
      S3.506,13.423,5.454,11.475z M6.868,12.89c-1.163,1.163-1.163,3.079,0,4.243c1.163,1.163,3.079,1.163,4.243,0
      c1.163-1.163,1.163-3.079,0-4.243S8.031,11.726,6.868,12.89z M8.282,14.304c0.399-0.399,1.015-0.399,1.414,0
      c0.399,0.399,0.399,1.015,0,1.414c-0.399,0.399-1.015,0.399-1.414,0C7.883,15.319,7.883,14.703,8.282,14.304z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-60': {
    element: [
      <path
        d="M12.5,4c4.135,0,7.5,3.364,7.5,7.5S16.636,19,12.5,19c-1.08,0-2.134-0.241-3.223-0.737c-0.263-0.12-0.546-0.18-0.829-0.18
  		c-0.231,0-0.462,0.04-0.683,0.12l-3.148,1.144l1.1-3.243c0.161-0.476,0.138-0.995-0.066-1.454C5.219,13.677,5,12.617,5,11.5
  		C5,7.365,8.365,4,12.5,4 M12.5,2C7.262,2,3,6.262,3,11.5c0,1.402,0.277,2.732,0.823,3.962l-1.77,5.217
  		c-0.123,0.364-0.027,0.766,0.248,1.036C2.491,21.9,2.743,22,3,22c0.115,0,0.23-0.02,0.342-0.061l5.106-1.856
  		C9.8,20.699,11.129,21,12.5,21c5.238,0,9.5-4.262,9.5-9.5S17.738,2,12.5,2L12.5,2z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-61': {
    element: [
      <path
        d="M19,5h-2V4c0-0.552-0.448-1-1-1H8C7.448,3,7,3.448,7,4v1H5C3.9,5,3,5.9,3,7v1c0,2.55,1.92,4.63,4.39,4.94
			c0.63,1.5,1.98,2.63,3.61,2.96V19H8c-0.552,0-1,0.448-1,1v0c0,0.552,0.448,1,1,1h8c0.552,0,1-0.448,1-1v0c0-0.552-0.448-1-1-1h-3
			v-3.1c1.63-0.33,2.98-1.46,3.61-2.96C19.08,12.63,21,10.55,21,8V7C21,5.9,20.1,5,19,5z M5,8V7h2v3.82C5.84,10.4,5,9.3,5,8z M12,14
			c-1.65,0-3-1.35-3-3V5h6v6C15,12.65,13.65,14,12,14z M19,8c0,1.3-0.84,2.4-2,2.82V7h2V8z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-62': {
    element: [
      <path
        d="M9.943,2C9.708,2.009,9.469,2.055,9.234,2.141C8.295,2.482,7.711,3.35,7.748,4.35c0.004,0.107-0.049,0.173-0.094,0.211
      c-0.046,0.038-0.12,0.077-0.223,0.055c-0.976-0.212-1.936,0.214-2.436,1.08c-0.501,0.866-0.39,1.906,0.281,2.648
      C5.352,8.427,5.35,8.519,5.342,8.566C5.331,8.624,5.299,8.702,5.205,8.752c-0.884,0.468-1.344,1.408-1.17,2.393
      c0.174,0.985,0.927,1.711,1.918,1.848c0.104,0.014,0.162,0.077,0.191,0.127c0.029,0.05,0.054,0.131,0.014,0.23
      c-0.308,0.757-0.187,1.571,0.283,2.195L3.857,20h3.5v0.002l1.49,3.268l3.137-5.229l3.137,5.229l1.49-3.27h3.5l-2.568-4.428
      c0.487-0.627,0.613-1.453,0.301-2.223c-0.039-0.098-0.012-0.179,0.016-0.23c0.029-0.05,0.087-0.113,0.191-0.127
      c0.991-0.137,1.744-0.863,1.918-1.848s-0.286-1.925-1.17-2.393c-0.094-0.05-0.126-0.128-0.137-0.186
      c-0.008-0.047-0.011-0.14,0.064-0.223c0.671-0.742,0.782-1.781,0.281-2.648c-0.5-0.867-1.462-1.291-2.436-1.08
      c-0.103,0.022-0.178-0.017-0.223-0.055s-0.098-0.105-0.094-0.211c0.037-0.999-0.547-1.867-1.486-2.209
      c-0.94-0.342-1.946-0.054-2.561,0.736c-0.131,0.167-0.283,0.168-0.414,0C11.333,2.284,10.651,1.974,9.943,2z M10.08,4.008
      c0.05,0.014,0.095,0.045,0.135,0.096c0.861,1.11,2.707,1.109,3.57,0c0.078-0.1,0.179-0.129,0.297-0.086
      c0.119,0.043,0.178,0.13,0.174,0.256c-0.026,0.702,0.268,1.364,0.807,1.816c0.538,0.452,1.239,0.627,1.928,0.479
      c0.127-0.027,0.219,0.016,0.283,0.125c0.064,0.11,0.052,0.215-0.033,0.309c-0.472,0.522-0.673,1.217-0.551,1.91
      c0.123,0.692,0.549,1.279,1.17,1.607c0.113,0.059,0.159,0.152,0.137,0.277s-0.098,0.196-0.223,0.213
      c-0.697,0.097-1.298,0.502-1.65,1.111c-0.351,0.608-0.4,1.33-0.135,1.98c0.048,0.117,0.023,0.219-0.074,0.301
      c-0.098,0.081-0.204,0.088-0.309,0.021c-0.597-0.374-1.316-0.451-1.977-0.211c-0.66,0.241-1.164,0.762-1.381,1.432
      c-0.076,0.242-0.42,0.242-0.498,0c-0.216-0.669-0.719-1.19-1.379-1.43c-0.254-0.093-0.514-0.139-0.775-0.139
      c-0.418,0-0.833,0.118-1.199,0.35c-0.108,0.068-0.21,0.061-0.309-0.021c-0.096-0.082-0.123-0.183-0.076-0.299
      c0.265-0.651,0.216-1.375-0.135-1.984c-0.351-0.61-0.953-1.012-1.65-1.109c-0.125-0.017-0.2-0.09-0.221-0.215
      c-0.022-0.124,0.023-0.217,0.135-0.277c0.621-0.328,1.047-0.913,1.17-1.605c0.122-0.693-0.077-1.389-0.549-1.91
      C6.677,6.909,6.666,6.805,6.729,6.695C6.793,6.586,6.882,6.542,7.01,6.57c0.69,0.15,1.39-0.026,1.928-0.479
      c0.54-0.451,0.833-1.113,0.807-1.816C9.74,4.148,9.799,4.062,9.918,4.018C9.976,3.997,10.03,3.994,10.08,4.008z M9.586,16.076
      c0.039-0.001,0.074,0.008,0.102,0.018c0.055,0.02,0.128,0.065,0.16,0.166c0.093,0.288,0.239,0.541,0.42,0.76l-1.209,2.014
      C8.705,18.419,8.077,18,7.357,18H7.33l0.889-1.535c0.424,0.006,0.853-0.104,1.24-0.348C9.504,16.089,9.547,16.078,9.586,16.076z
       M14.418,16.076c0.039,0.001,0.083,0.012,0.129,0.041c0.376,0.236,0.789,0.347,1.201,0.348L16.639,18h-0.027
      c-0.719,0-1.348,0.417-1.701,1.033l-1.195-1.992c0.19-0.224,0.344-0.483,0.441-0.781c0.033-0.101,0.106-0.146,0.16-0.166
      C14.343,16.084,14.379,16.075,14.418,16.076z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-63': {
    element: [
      <path
        d="M9.155,4.006c0.104,0,0.207,0.016,0.311,0.05l1.92,0.619l0.615,0.198l0.614-0.199l1.925-0.622
      c0.094-0.031,0.195-0.046,0.299-0.046c0.407,0,0.813,0.238,0.989,0.583l0.92,1.797l0.295,0.575l0.576,0.294l1.798,0.918
      c0.48,0.245,0.699,0.775,0.532,1.29l-0.621,1.92L19.126,12l0.199,0.616l0.622,1.922c0.167,0.513-0.053,1.043-0.532,1.288
      l-1.799,0.918l-0.577,0.295l-0.295,0.577l-0.918,1.797C15.638,19.78,15.28,20,14.867,20c-0.112,0-0.222-0.018-0.332-0.053
      l-1.92-0.621l-0.616-0.199l-0.616,0.2L9.459,19.95c-0.094,0.031-0.194,0.046-0.298,0.046c-0.406,0-0.812-0.24-0.989-0.585
      l-0.92-1.797l-0.295-0.576l-0.577-0.294l-1.795-0.915c-0.481-0.246-0.7-0.776-0.532-1.292l0.621-1.922L4.873,12l-0.199-0.615
      L4.053,9.464C3.887,8.95,4.106,8.419,4.588,8.174l1.797-0.918l0.577-0.295l0.295-0.577l0.918-1.798
      c0.167-0.327,0.54-0.56,0.929-0.58L9.155,4.006 M9.155,2.006c-0.051,0-0.102,0.001-0.153,0.004C7.923,2.065,6.898,2.687,6.393,3.678
      L5.475,5.475L3.678,6.393C2.324,7.084,1.682,8.635,2.15,10.08L2.771,12L2.15,13.922c-0.469,1.445,0.171,2.996,1.525,3.688
      l1.797,0.916l0.92,1.797c0.531,1.04,1.636,1.674,2.769,1.674c0.307,0,0.616-0.047,0.917-0.144L12,21.229l1.92,0.621
      c0.307,0.1,0.625,0.15,0.947,0.15c1.162,0,2.211-0.643,2.74-1.678l0.918-1.797l1.799-0.918c1.353-0.692,1.994-2.243,1.525-3.687
      L21.229,12l0.621-1.92c0.469-1.446-0.171-2.997-1.525-3.688l-1.797-0.918l-0.92-1.797c-0.529-1.039-1.636-1.671-2.769-1.671
      c-0.307,0-0.616,0.046-0.917,0.144L12,2.771l-1.92-0.619C9.776,2.053,9.465,2.006,9.155,2.006L9.155,2.006z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-64': {
    element: [
      <path
        d="M12,1L3,5c0,0,0,4,0,6c0,7.83,6.439,11.486,9,12c2.561-0.514,9-4.17,9-12c0-2,0-6,0-6L12,1z M19,11
      c0,6.134-4.785,9.254-7,9.937C9.785,20.254,5,17.134,5,11V6.3l7-3.111L19,6.3V11z"
      />,
      <path d="M12,6l-1.699,3.801L6,10.199L9.199,12.9L8.301,17L12,14.801L15.801,17l-1.102-4.1L18,10.199l-4.301-0.398L12,6z" />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-65': {
    element: [
      <path
        d="M8.5,3C4.922,3,2,5.922,2,9.5c0,2.489,1.415,4.659,3.48,5.75c-0.003,0.083-0.012,0.166-0.012,0.25
		c0,3.581,2.939,6.5,6.531,6.5s6.531-2.919,6.531-6.5c0-0.084-0.008-0.167-0.012-0.25C20.585,14.159,22,11.989,22,9.5
		C22,5.922,19.078,3,15.5,3c-1.288,0-2.488,0.384-3.5,1.035C10.988,3.384,9.788,3,8.5,3z M8.5,5c0.696,0,1.345,0.169,1.932,0.447
		C9.539,6.561,9,7.969,9,9.5c0,0.078,0.009,0.153,0.012,0.23c-1.414,0.73-2.526,1.956-3.104,3.447C4.754,12.365,4,11.028,4,9.5
		C4,7.003,6.003,5,8.5,5z M15.5,5C17.997,5,20,7.003,20,9.5c0,1.528-0.754,2.865-1.908,3.678c-0.578-1.492-1.69-2.718-3.104-3.447
		C14.991,9.653,15,9.578,15,9.5c0-1.531-0.539-2.939-1.432-4.053C14.155,5.169,14.804,5,15.5,5z M12,6.695
		c0.533,0.666,0.873,1.481,0.957,2.383C12.644,9.032,12.326,9,12,9s-0.644,0.032-0.957,0.078C11.127,8.176,11.467,7.361,12,6.695z
		 M12,11c0.242,0,0.474,0.035,0.705,0.07c-0.168,0.453-0.409,0.865-0.705,1.234c-0.296-0.37-0.537-0.781-0.705-1.234
		C11.526,11.035,11.758,11,12,11z M9.426,11.793c0.243,0.641,0.584,1.233,1.006,1.76C9.845,13.831,9.196,14,8.5,14
		c-0.252,0-0.494-0.035-0.734-0.074C8.091,13.055,8.669,12.311,9.426,11.793z M14.574,11.793c0.757,0.518,1.334,1.262,1.66,2.133
		C15.994,13.965,15.752,14,15.5,14c-0.696,0-1.345-0.169-1.932-0.447C13.99,13.026,14.331,12.434,14.574,11.793z M12,14.965
		C13.012,15.616,14.212,16,15.5,16c0.337,0,0.666-0.034,0.99-0.084C16.278,18.21,14.374,20,12,20s-4.278-1.79-4.49-4.084
		C7.834,15.966,8.163,16,8.5,16C9.788,16,10.988,15.616,12,14.965z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-66': {
    element: [
      <path
        d="M7,2C5.895,2,5,2.895,5,4s0.895,2,2,2s2-0.895,2-2S8.105,2,7,2z M12,2c-1.105,0-2,0.895-2,2s0.895,2,2,2s2-0.895,2-2
      S13.105,2,12,2z M17,2c-1.105,0-2,0.895-2,2s0.895,2,2,2s2-0.895,2-2S18.105,2,17,2z M5,7C3.895,7,3,7.895,3,9v7h1v6h2v-8H5V9h1.102
      c0.152-0.743,0.482-1.416,0.924-2H5z M11,7c-1.657,0-3,1.343-3,3v8h1v4h2v-4h2v4h2v-4h1v-8c0-1.657-1.343-3-3-3H11z M16.975,7
      c0.442,0.584,0.773,1.257,0.924,2H19v5h-1v8h2v-6h1V9c0-1.105-0.895-2-2-2H16.975z M11,9h2c0.552,0,1,0.448,1,1v6h-4v-6
      C10,9.448,10.448,9,11,9z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-67': {
    element: [
      <path
        d="M9,13.75c-2.34,0-7,1.17-7,3.5V19h14v-1.75C16,14.92,11.34,13.75,9,13.75z M4.34,17c0.84-0.58,2.87-1.25,4.66-1.25
  	s3.82,0.67,4.66,1.25H4.34z M9,12c1.93,0,3.5-1.57,3.5-3.5S10.93,5,9,5S5.5,6.57,5.5,8.5S7.07,12,9,12z M9,7
  	c0.83,0,1.5,0.67,1.5,1.5S9.83,10,9,10S7.5,9.33,7.5,8.5S8.17,7,9,7z M16.04,13.81C17.2,14.65,18,15.77,18,17.25V19h4v-1.75
  	C22,15.23,18.5,14.08,16.04,13.81z M15,12c1.93,0,3.5-1.57,3.5-3.5S16.93,5,15,5c-0.54,0-1.04,0.13-1.5,0.35
  	c0.63,0.89,1,1.98,1,3.15s-0.37,2.26-1,3.15C13.96,11.87,14.46,12,15,12z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-68': {
    element: [
      <path
        d="M12,3c-1.1,0-2,0.9-2,2s0.9,2,2,2s2-0.9,2-2S13.1,3,12,3z M12,8c-2.1,0-3.8,0.8-4,2H2v2h1.2l0.6,2.5c0.2,0.9,1,1.5,1.9,1.5
      H8v5h2v-5h4v5h2v-5h2.2c0.9,0,1.7-0.6,1.9-1.5l0.6-2.5H22v-2h-6C15.8,8.8,14.1,8,12,8z M5.3,12h13.4l-0.5,2H5.8L5.3,12z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-69': {
    element: [
      <path d="M5,19c-0.668,0-2,0.36-2,1.025V21h4v-0.975C7,19.36,5.668,19,5,19z" />,
      <path d="M12,19c-0.667,0-2,0.36-2,1.025V21h4v-0.975C14,19.36,12.668,19,12,19z" />,
      <path d="M19,19c-0.667,0-2,0.36-2,1.025V21h4v-0.975C21,19.36,19.667,19,19,19z" />,
      <path d="M19.166,5.834v6.332H4.834V5.834H19.166 M21,4H3v10h18V4L21,4z" />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-70': {
    element: [
      <path
        d="M14,3c-1.1,0-2,0.9-2,2v9l3-3h5c1.1,0,2-0.9,2-2V5c0-1.1-0.9-2-2-2H14z M14,5h6v4h-6V5z M7,9c-1.682,0-3,1.317-3,3
      s1.318,3,3,3s3-1.317,3-3S8.682,9,7,9z M7,11c0.58,0,1,0.421,1,1s-0.42,1-1,1s-1-0.421-1-1S6.42,11,7,11z M7,16
      c-2.851,0-5,1.456-5,3.385V21h10v-1.615C12,17.456,9.851,16,7,16z M7,18c1.469,0,2.49,0.504,2.854,1H4.146
      C4.51,18.504,5.531,18,7,18z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-71': {
    element: [
      <path
        d="M9,13c2.21,0,4-1.79,4-4s-1.79-4-4-4S5,6.79,5,9S6.79,13,9,13z M9,7c1.1,0,2,0.9,2,2s-0.9,2-2,2s-2-0.9-2-2S7.9,7,9,7z
      M9,15c-2.67,0-8,1.34-8,4v2h16v-2C17,16.34,11.67,15,9,15z M3,19c0.22-0.72,3.31-2,6-2c2.7,0,5.8,1.29,6,2H3z M15.08,7.05
     c0.84,1.18,0.84,2.71,0,3.89l1.68,1.69c2.02-2.02,2.02-5.07,0-7.27C16.76,5.36,15.08,7.05,15.08,7.05z M20.07,2l-1.63,1.63
     c2.77,3.02,2.77,7.56,0,10.74L20.07,16C23.97,12.11,23.98,6.05,20.07,2z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-72': {
    element: [
      <path
        d="M4.971,4.971C4.549,4.549,3.854,4.59,3.477,5.052C1.929,6.948,1,9.367,1,12s0.929,5.052,2.477,6.948
      c0.378,0.463,1.072,0.503,1.494,0.081h0c0.359-0.359,0.394-0.932,0.072-1.324C3.767,16.15,3,14.163,3,12s0.767-4.15,2.043-5.705
      C5.365,5.903,5.33,5.33,4.971,4.971L4.971,4.971z M19.029,4.971L19.029,4.971c-0.359,0.359-0.394,0.932-0.072,1.324
      C20.233,7.85,21,9.837,21,12s-0.767,4.15-2.043,5.705c-0.322,0.392-0.287,0.965,0.072,1.324l0,0
      c0.422,0.422,1.117,0.382,1.494-0.081C22.071,17.052,23,14.633,23,12s-0.929-5.052-2.477-6.948
      C20.146,4.59,19.451,4.549,19.029,4.971z M7.82,7.82c-0.426-0.426-1.147-0.395-1.5,0.094C5.489,9.064,5,10.476,5,12
      s0.489,2.936,1.32,4.087c0.353,0.489,1.074,0.52,1.5,0.094l0.002-0.002c0.352-0.352,0.377-0.898,0.09-1.304
      C7.337,14.061,7,13.069,7,12c0-1.069,0.338-2.061,0.912-2.874c0.287-0.406,0.261-0.952-0.091-1.304L7.82,7.82z M16.181,7.819
      l-0.003,0.003c-0.351,0.351-0.377,0.897-0.09,1.303C16.662,9.939,17,10.931,17,12c0,1.069-0.338,2.061-0.913,2.875
      c-0.286,0.406-0.261,0.951,0.091,1.303l0.003,0.003c0.426,0.426,1.146,0.394,1.499-0.094C18.51,14.936,19,13.524,19,12
      c0-1.525-0.49-2.937-1.32-4.088C17.327,7.424,16.607,7.393,16.181,7.819z M12,9c-1.657,0-3,1.343-3,3s1.343,3,3,3s3-1.343,3-3
      S13.657,9,12,9z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-73': {
    element: [
      <path
        d="M5.54,8.46L2,12l3.54,3.54l1.76-1.77L5.54,12l1.76-1.77L5.54,8.46z M12,18.46l-1.77-1.76l-1.77,1.76L12,22l3.54-3.54
      l-1.77-1.76L12,18.46z M18.46,8.46l-1.76,1.77L18.46,12l-1.76,1.77l1.76,1.77L22,12L18.46,8.46z M8.46,5.54l1.77,1.76L12,5.54
      l1.77,1.76l1.77-1.76L12,2L8.46,5.54z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-74': {
    element: [
      <path
        d="M4,4v4l4-4H4z M16,4l4,4V4H16z M20,20v-4l-4,4H20z M4,20h4l-4-4V20z M19,12c0-3.87-3.13-7-7-7s-7,3.13-7,7s3.13,7,7,7
      S19,15.87,19,12z M12,17c-2.76,0-5-2.24-5-5s2.24-5,5-5s5,2.24,5,5S14.76,17,12,17z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-a': {
    element: [
      <path
        d="M12,2C6.489,2,2,6.489,2,12s4.489,10,10,10s10-4.489,10-10S17.511,2,12,2z M12,4c4.43,0,8,3.57,8,8s-3.57,8-8,8s-8-3.57-8-8
      S7.57,4,12,4z"
      />,
      <path
        d="M13.67,14.596h-3.339L9.696,16.5H7.671l3.44-9.242h1.765l3.459,9.242h-2.024L13.67,14.596z M10.845,13.053h2.311
        l-1.162-3.459L10.845,13.053z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-b': {
    element: [
      <path
        d="M12,2C6.489,2,2,6.489,2,12s4.489,10,10,10s10-4.489,10-10S17.511,2,12,2z M12,4c4.43,0,8,3.57,8,8s-3.57,8-8,8s-8-3.57-8-8
      S7.57,4,12,4z"
      />,
      <path
        d="M8.677,16.5V7.258h3.237c1.122,0,1.973,0.215,2.552,0.645c0.58,0.43,0.87,1.059,0.87,1.889c0,0.452-0.116,0.852-0.35,1.196
        c-0.232,0.345-0.557,0.598-0.971,0.759c0.474,0.118,0.847,0.357,1.12,0.717c0.272,0.359,0.409,0.8,0.409,1.32
        c0,0.889-0.283,1.562-0.851,2.019c-0.566,0.457-1.375,0.689-2.425,0.698H8.677z M10.581,11.13h1.409
        c0.961-0.017,1.441-0.399,1.441-1.149c0-0.418-0.122-0.72-0.365-0.904c-0.243-0.184-0.627-0.275-1.152-0.275h-1.333V11.13z
         M10.581,12.476v2.495h1.632c0.448,0,0.799-0.107,1.05-0.321c0.252-0.214,0.378-0.509,0.378-0.886c0-0.846-0.438-1.275-1.313-1.288
        H10.581z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-c': {
    element: [
      <path
        d="M12,2C6.489,2,2,6.489,2,12s4.489,10,10,10s10-4.489,10-10S17.511,2,12,2z M12,4c4.43,0,8,3.57,8,8s-3.57,8-8,8s-8-3.57-8-8
      S7.57,4,12,4z"
      />,
      <path
        d="M15.828,13.422c-0.072,0.994-0.439,1.777-1.102,2.348c-0.662,0.572-1.535,0.857-2.618,0.857
        c-1.186,0-2.117-0.398-2.797-1.196c-0.679-0.798-1.019-1.893-1.019-3.285V11.58c0-0.889,0.157-1.671,0.47-2.348
        c0.313-0.678,0.761-1.197,1.343-1.559c0.582-0.362,1.258-0.543,2.028-0.543c1.066,0,1.925,0.285,2.577,0.857
        c0.651,0.57,1.028,1.373,1.13,2.405h-1.904c-0.047-0.597-0.213-1.029-0.499-1.298c-0.285-0.269-0.72-0.403-1.304-0.403
        c-0.635,0-1.11,0.228-1.426,0.683c-0.315,0.455-0.477,1.16-0.485,2.117v0.697c0,0.999,0.151,1.729,0.454,2.19
        c0.302,0.461,0.779,0.692,1.432,0.692c0.588,0,1.027-0.135,1.316-0.403c0.29-0.269,0.456-0.685,0.499-1.247H15.828z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-d': {
    element: [
      <path
        d="M12,2C6.489,2,2,6.489,2,12s4.489,10,10,10s10-4.489,10-10S17.511,2,12,2z M12,4c4.43,0,8,3.57,8,8s-3.57,8-8,8s-8-3.57-8-8
      S7.57,4,12,4z"
      />,
      <path
        d="M8.866,16.5V7.258h2.844c0.812,0,1.539,0.183,2.181,0.549c0.641,0.366,1.142,0.887,1.501,1.562
        c0.36,0.675,0.54,1.442,0.54,2.302v0.425c0,0.859-0.177,1.623-0.53,2.292c-0.354,0.668-0.852,1.187-1.495,1.555
        c-0.643,0.368-1.369,0.555-2.177,0.559H8.866z M10.77,8.801v6.17h0.92c0.745,0,1.314-0.244,1.708-0.73s0.595-1.183,0.604-2.088
        v-0.489c0-0.939-0.195-1.651-0.584-2.136c-0.39-0.484-0.959-0.727-1.708-0.727H10.77z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-e': {
    element: [
      <path
        d="M12,2C6.489,2,2,6.489,2,12s4.489,10,10,10s10-4.489,10-10S17.511,2,12,2z M12,4c4.43,0,8,3.57,8,8s-3.57,8-8,8s-8-3.57-8-8
      S7.57,4,12,4z"
      />,
      <path d="M14.729,12.494h-3.656v2.477h4.291V16.5H9.169V7.258h6.183v1.543h-4.278v2.202h3.656V12.494z" />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-f': {
    element: [
      <path
        d="M12,2C6.489,2,2,6.489,2,12s4.489,10,10,10s10-4.489,10-10S17.511,2,12,2z M12,4c4.43,0,8,3.57,8,8s-3.57,8-8,8s-8-3.57-8-8
      S7.57,4,12,4z"
      />,
      <path d="M14.825,12.723h-3.656V16.5H9.265V7.258h6.018v1.543h-4.113v2.387h3.656V12.723z" />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-g': {
    element: [
      <path
        d="M12,2C6.489,2,2,6.489,2,12s4.489,10,10,10s10-4.489,10-10S17.511,2,12,2z M12,4c4.43,0,8,3.57,8,8s-3.57,8-8,8s-8-3.57-8-8
      S7.57,4,12,4z"
      />,
      <path
        d="M15.71,15.332c-0.343,0.41-0.827,0.729-1.453,0.955c-0.627,0.227-1.32,0.34-2.082,0.34c-0.8,0-1.502-0.175-2.104-0.523
        c-0.604-0.35-1.069-0.856-1.396-1.521c-0.328-0.664-0.497-1.445-0.505-2.343v-0.628c0-0.923,0.155-1.722,0.467-2.396
        c0.311-0.675,0.759-1.191,1.346-1.549c0.586-0.357,1.272-0.536,2.06-0.536c1.097,0,1.953,0.262,2.571,0.784
        c0.617,0.522,0.983,1.283,1.098,2.282h-1.854c-0.084-0.529-0.271-0.917-0.562-1.162s-0.688-0.368-1.196-0.368
        c-0.648,0-1.141,0.243-1.479,0.729c-0.338,0.487-0.51,1.211-0.514,2.172v0.59c0,0.969,0.184,1.701,0.552,2.196
        s0.908,0.743,1.619,0.743c0.715,0,1.225-0.152,1.529-0.457v-1.594h-1.732v-1.402h3.637V15.332z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-h': {
    element: [
      <path
        d="M12,2C6.489,2,2,6.489,2,12s4.489,10,10,10s10-4.489,10-10S17.511,2,12,2z M12,4c4.43,0,8,3.57,8,8s-3.57,8-8,8s-8-3.57-8-8
      S7.57,4,12,4z"
      />,
      <path d="M15.754,16.5H13.85v-3.961h-3.713V16.5H8.232V7.258h1.904v3.745h3.713V7.258h1.904V16.5z" />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-i': {
    element: [
      <path
        d="M12,2C6.489,2,2,6.489,2,12s4.489,10,10,10s10-4.489,10-10S17.511,2,12,2z M12,4c4.43,0,8,3.57,8,8s-3.57,8-8,8s-8-3.57-8-8
      S7.57,4,12,4z"
      />,
      <path d="M12.956,16.5h-1.905V7.258h1.905V16.5z" />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-j': {
    element: [
      <path
        d="M12,2C6.489,2,2,6.489,2,12s4.489,10,10,10s10-4.489,10-10S17.511,2,12,2z M12,4c4.43,0,8,3.57,8,8s-3.57,8-8,8s-8-3.57-8-8
      S7.57,4,12,4z"
      />,
      <path
        d="M12.92,7.258h1.904v6.398c0,0.588-0.13,1.107-0.39,1.559c-0.261,0.45-0.628,0.799-1.102,1.044
        c-0.475,0.245-1.01,0.368-1.606,0.368c-0.978,0-1.739-0.249-2.285-0.746s-0.819-1.2-0.819-2.11h1.917
        c0,0.453,0.095,0.787,0.286,1.003s0.491,0.324,0.901,0.324c0.364,0,0.654-0.125,0.87-0.375s0.323-0.605,0.323-1.066V7.258z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-k': {
    element: [
      <path
        d="M12,2C6.489,2,2,6.489,2,12s4.489,10,10,10s10-4.489,10-10S17.511,2,12,2z M12,4c4.43,0,8,3.57,8,8s-3.57,8-8,8s-8-3.57-8-8
      S7.57,4,12,4z"
      />,
      <path
        d="M11.594,12.793l-0.99,1.066V16.5H8.699V7.258h1.904v4.189l0.838-1.148l2.354-3.041h2.343l-3.282,4.107l3.377,5.135h-2.266
        L11.594,12.793z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-l': {
    element: [
      <path
        d="M12,2C6.489,2,2,6.489,2,12s4.489,10,10,10s10-4.489,10-10S17.511,2,12,2z M12,4c4.43,0,8,3.57,8,8s-3.57,8-8,8s-8-3.57-8-8
      S7.57,4,12,4z"
      />,
      <path d="M11.21,14.971h4.044V16.5H9.306V7.258h1.904V14.971z" />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-m': {
    element: [
      <path
        d="M12,2C6.489,2,2,6.489,2,12s4.489,10,10,10s10-4.489,10-10S17.511,2,12,2z M12,4c4.43,0,8,3.57,8,8s-3.57,8-8,8s-8-3.57-8-8
      S7.57,4,12,4z"
      />,
      <path
        d="M9.62,7.258l2.374,6.703l2.361-6.703h2.501V16.5h-1.911v-2.526l0.19-4.36L12.642,16.5h-1.308L8.846,9.619l0.19,4.354V16.5
        H7.132V7.258H9.62z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-n': {
    element: [
      <path
        d="M12,2C6.489,2,2,6.489,2,12s4.489,10,10,10s10-4.489,10-10S17.511,2,12,2z M12,4c4.43,0,8,3.57,8,8s-3.57,8-8,8s-8-3.57-8-8
      S7.57,4,12,4z"
      />,
      <path d="M15.751,16.5h-1.904l-3.707-6.081V16.5H8.235V7.258h1.904l3.714,6.094V7.258h1.897V16.5z" />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-o': {
    element: [
      <path
        d="M12,2C6.489,2,2,6.489,2,12s4.489,10,10,10s10-4.489,10-10S17.511,2,12,2z M12,4c4.43,0,8,3.57,8,8s-3.57,8-8,8s-8-3.57-8-8
      S7.57,4,12,4z"
      />,
      <path
        d="M15.929,12.088c0,0.91-0.161,1.708-0.482,2.394c-0.322,0.686-0.782,1.215-1.381,1.587s-1.285,0.559-2.06,0.559
        c-0.766,0-1.449-0.184-2.05-0.553c-0.601-0.367-1.066-0.894-1.396-1.577s-0.497-1.47-0.501-2.358v-0.457
        c0-0.909,0.164-1.71,0.492-2.402c0.328-0.691,0.791-1.223,1.39-1.593c0.599-0.37,1.284-0.556,2.054-0.556
        c0.77,0,1.454,0.186,2.054,0.556c0.599,0.37,1.062,0.901,1.39,1.593c0.328,0.692,0.492,1.491,0.492,2.396V12.088z M13.999,11.67
        c0-0.97-0.174-1.706-0.521-2.209c-0.348-0.504-0.843-0.756-1.485-0.756c-0.639,0-1.132,0.249-1.479,0.746s-0.522,1.226-0.527,2.187
        v0.45c0,0.944,0.173,1.676,0.521,2.197c0.347,0.52,0.846,0.78,1.498,0.78c0.639,0,1.13-0.251,1.473-0.752
        c0.343-0.502,0.516-1.232,0.521-2.193V11.67z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-p': {
    element: [
      <path
        d="M12,2C6.489,2,2,6.489,2,12s4.489,10,10,10s10-4.489,10-10S17.511,2,12,2z M12,4c4.43,0,8,3.57,8,8s-3.57,8-8,8s-8-3.57-8-8
      S7.57,4,12,4z"
      />,
      <path
        d="M10.537,13.244V16.5H8.633V7.258h3.605c0.693,0,1.305,0.127,1.831,0.381c0.527,0.254,0.932,0.614,1.216,1.082
        c0.283,0.468,0.425,1,0.425,1.597c0,0.905-0.31,1.62-0.93,2.143s-1.478,0.784-2.574,0.784H10.537z M10.537,11.701h1.701
        c0.503,0,0.888-0.118,1.152-0.355c0.264-0.237,0.396-0.575,0.396-1.016c0-0.453-0.134-0.818-0.4-1.098s-0.635-0.424-1.104-0.432
        h-1.745V11.701z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-q': {
    element: [
      <path
        d="M12,2C6.489,2,2,6.489,2,12s4.489,10,10,10s10-4.489,10-10S17.511,2,12,2z M12,4c4.43,0,8,3.57,8,8s-3.57,8-8,8s-8-3.57-8-8
      S7.57,4,12,4z"
      />,
      <path
        d="M15.916,12.088c0,0.863-0.14,1.614-0.419,2.251s-0.667,1.147-1.162,1.532l1.536,1.207l-1.212,1.072l-1.968-1.58
        c-0.225,0.037-0.457,0.057-0.698,0.057c-0.766,0-1.449-0.184-2.05-0.553c-0.601-0.367-1.066-0.894-1.396-1.577
        s-0.497-1.47-0.501-2.358v-0.457c0-0.909,0.164-1.71,0.492-2.402c0.328-0.691,0.791-1.223,1.39-1.593
        c0.599-0.37,1.284-0.556,2.054-0.556c0.77,0,1.454,0.186,2.054,0.556c0.599,0.37,1.062,0.901,1.39,1.593
        c0.328,0.692,0.492,1.491,0.492,2.396V12.088z M13.986,11.67c0-0.97-0.174-1.706-0.521-2.209c-0.348-0.504-0.843-0.756-1.485-0.756
        c-0.639,0-1.132,0.249-1.479,0.746s-0.522,1.226-0.527,2.187v0.45c0,0.944,0.173,1.676,0.521,2.197
        c0.347,0.52,0.846,0.78,1.498,0.78c0.639,0,1.13-0.251,1.473-0.752c0.343-0.502,0.516-1.232,0.521-2.193V11.67z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-r': {
    element: [
      <path
        d="M12,2C6.489,2,2,6.489,2,12s4.489,10,10,10s10-4.489,10-10S17.511,2,12,2z M12,4c4.43,0,8,3.57,8,8s-3.57,8-8,8s-8-3.57-8-8
      S7.57,4,12,4z"
      />,
      <path
        d="M12.099,13.117h-1.518V16.5H8.677V7.258h3.435c1.092,0,1.934,0.243,2.526,0.73c0.592,0.486,0.889,1.174,0.889,2.062
        c0,0.631-0.137,1.156-0.41,1.577c-0.272,0.421-0.687,0.757-1.24,1.007l1.999,3.776V16.5h-2.044L12.099,13.117z M10.581,11.574
        h1.536c0.479,0,0.849-0.122,1.111-0.365c0.262-0.243,0.394-0.578,0.394-1.006c0-0.436-0.124-0.778-0.372-1.028
        c-0.247-0.25-0.627-0.374-1.139-0.374h-1.53V11.574z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-s': {
    element: [
      <path
        d="M12,2C6.489,2,2,6.489,2,12s4.489,10,10,10s10-4.489,10-10S17.511,2,12,2z M12,4c4.43,0,8,3.57,8,8s-3.57,8-8,8s-8-3.57-8-8
      S7.57,4,12,4z"
      />,
      <path
        d="M13.621,14.075c0-0.359-0.127-0.636-0.381-0.828s-0.711-0.396-1.371-0.609c-0.66-0.214-1.183-0.425-1.568-0.632
        c-1.049-0.567-1.574-1.331-1.574-2.291c0-0.5,0.141-0.945,0.422-1.337c0.282-0.392,0.686-0.697,1.213-0.917
        c0.526-0.22,1.118-0.33,1.773-0.33c0.66,0,1.249,0.119,1.765,0.358c0.517,0.239,0.918,0.577,1.203,1.013
        c0.286,0.436,0.429,0.931,0.429,1.485h-1.904c0-0.423-0.134-0.752-0.4-0.987c-0.267-0.234-0.641-0.352-1.123-0.352
        c-0.465,0-0.827,0.098-1.085,0.295c-0.258,0.196-0.387,0.456-0.387,0.777c0,0.301,0.151,0.553,0.454,0.756
        c0.302,0.203,0.748,0.393,1.336,0.57c1.083,0.326,1.872,0.73,2.367,1.213s0.743,1.083,0.743,1.803c0,0.8-0.303,1.427-0.908,1.882
        c-0.604,0.455-1.42,0.683-2.443,0.683c-0.711,0-1.358-0.13-1.942-0.391c-0.584-0.26-1.029-0.616-1.336-1.069
        c-0.307-0.453-0.46-0.978-0.46-1.574h1.911c0,1.02,0.609,1.53,1.828,1.53c0.452,0,0.806-0.093,1.06-0.276
        C13.494,14.662,13.621,14.405,13.621,14.075z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-t': {
    element: [
      <path
        d="M12,2C6.489,2,2,6.489,2,12s4.489,10,10,10s10-4.489,10-10S17.511,2,12,2z M12,4c4.43,0,8,3.57,8,8s-3.57,8-8,8s-8-3.57-8-8
      S7.57,4,12,4z"
      />,
      <path d="M15.761,8.801H12.93V16.5h-1.904V8.801H8.232V7.258h7.528V8.801z" />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-u': {
    element: [
      <path
        d="M12,2C6.489,2,2,6.489,2,12s4.489,10,10,10s10-4.489,10-10S17.511,2,12,2z M12,4c4.43,0,8,3.57,8,8s-3.57,8-8,8s-8-3.57-8-8
      S7.57,4,12,4z"
      />,
      <path
        d="M15.542,7.258v6.088c0,1.011-0.316,1.811-0.949,2.398c-0.632,0.589-1.496,0.883-2.593,0.883
        c-1.079,0-1.936-0.285-2.571-0.857c-0.635-0.57-0.958-1.355-0.971-2.354V7.258h1.904v6.1c0,0.605,0.145,1.047,0.435,1.324
        c0.29,0.277,0.691,0.416,1.203,0.416c1.071,0,1.614-0.563,1.632-1.689v-6.15H15.542z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-v': {
    element: [
      <path
        d="M12,2C6.489,2,2,6.489,2,12s4.489,10,10,10s10-4.489,10-10S17.511,2,12,2z M12,4c4.43,0,8,3.57,8,8s-3.57,8-8,8s-8-3.57-8-8
      S7.57,4,12,4z"
      />,
      <path d="M11.99,14.209l2.095-6.951h2.12L12.986,16.5H11L7.794,7.258h2.114L11.99,14.209z" />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-w': {
    element: [
      <path
        d="M12,2C6.489,2,2,6.489,2,12s4.489,10,10,10s10-4.489,10-10S17.511,2,12,2z M12,4c4.43,0,8,3.57,8,8s-3.57,8-8,8s-8-3.57-8-8
      S7.57,4,12,4z"
      />,
      <path
        d="M14.339,13.834l1.244-6.576h1.897l-2.05,9.242h-1.917l-1.505-6.183L10.505,16.5H8.588l-2.05-9.242h1.898l1.25,6.563
        l1.523-6.563h1.612L14.339,13.834z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-x': {
    element: [
      <path
        d="M12,2C6.489,2,2,6.489,2,12s4.489,10,10,10s10-4.489,10-10S17.511,2,12,2z M12,4c4.43,0,8,3.57,8,8s-3.57,8-8,8s-8-3.57-8-8
      S7.57,4,12,4z"
      />,
      <path
        d="M12.004,10.444l1.732-3.187h2.19l-2.691,4.583l2.761,4.659h-2.215l-1.777-3.237L10.226,16.5H8.011l2.761-4.659L8.081,7.258
        h2.19L12.004,10.444z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-y': {
    element: [
      <path
        d="M12,2C6.489,2,2,6.489,2,12s4.489,10,10,10s10-4.489,10-10S17.511,2,12,2z M12,4c4.43,0,8,3.57,8,8s-3.57,8-8,8s-8-3.57-8-8
      S7.57,4,12,4z"
      />,
      <path d="M11.994,11.422l1.923-4.164h2.082l-3.034,5.891V16.5h-1.936v-3.352L7.995,7.258h2.088L11.994,11.422z" />,
    ],
    viewBox: '0 0 24 24',
  },
  'icon-z': {
    element: [
      <path
        d="M12,2C6.489,2,2,6.489,2,12s4.489,10,10,10s10-4.489,10-10S17.511,2,12,2z M12,4c4.43,0,8,3.57,8,8s-3.57,8-8,8s-8-3.57-8-8
      S7.57,4,12,4z"
      />,
      <path d="M10.905,14.971h4.659V16.5h-7.04v-1.117l4.57-6.582H8.531V7.258h6.932V8.35L10.905,14.971z" />,
    ],
    viewBox: '0 0 24 24',
  },
  link: {
    element: [
      <path
        d="M12.707,15.293c-1.068,0-2.073-0.416-2.828-1.172c-0.391-0.391-0.391-1.023,0-1.414s1.023-0.391,1.414,0
      c0.756,0.756,2.072,0.756,2.828,0l2.829-2.828c0.779-0.78,0.779-2.049,0-2.829c-0.756-0.755-2.072-0.757-2.829,0
      c-0.391,0.391-1.023,0.391-1.414,0s-0.391-1.023,0-1.414c1.56-1.559,4.096-1.561,5.657,0c1.559,1.559,1.559,4.097,0,5.657
      l-2.829,2.828C14.78,14.877,13.775,15.293,12.707,15.293z"
      />,
      <path
        d="M8.464,19.533c-1.024,0-2.048-0.39-2.828-1.169c-0.756-0.756-1.172-1.76-1.172-2.829c0-1.068,0.416-2.072,1.172-2.828
      l2.828-2.828c1.511-1.512,4.145-1.512,5.657,0c0.391,0.391,0.391,1.023,0,1.414s-1.023,0.391-1.414,0
      c-0.756-0.757-2.074-0.756-2.829,0L7.05,14.121c-0.78,0.78-0.78,2.049,0,2.829c0.779,0.779,2.048,0.779,2.829,0
      c0.391-0.391,1.024-0.391,1.415,0c0.39,0.391,0.39,1.024,0,1.414C10.513,19.144,9.489,19.533,8.464,19.533z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  manage: {
    element: [
      <path
        d="M21,15.184V13v-1c0-0.552-0.448-1-1-1h-7V7.816C14.161,7.401,15,6.302,15,5c0-1.654-1.346-3-3-3S9,3.346,9,5
      c0,1.302,0.839,2.401,2,2.816V11H4c-0.552,0-1,0.448-1,1v1v2.184C1.839,15.599,1,16.698,1,18c0,1.654,1.346,3,3,3s3-1.346,3-3
      c0-1.302-0.839-2.401-2-2.816V13h6v2.184C9.839,15.599,9,16.698,9,18c0,1.654,1.346,3,3,3s3-1.346,3-3c0-1.302-0.839-2.401-2-2.816
      V13h6v2.184c-1.161,0.414-2,1.514-2,2.816c0,1.654,1.346,3,3,3s3-1.346,3-3C23,16.698,22.161,15.599,21,15.184z M12,4
      c0.551,0,1,0.449,1,1s-0.449,1-1,1s-1-0.449-1-1S11.449,4,12,4z M4,19c-0.551,0-1-0.448-1-1s0.449-1,1-1s1,0.448,1,1S4.551,19,4,19z
       M12,19c-0.551,0-1-0.448-1-1s0.449-1,1-1s1,0.448,1,1S12.551,19,12,19z M20,19c-0.552,0-1-0.448-1-1s0.448-1,1-1s1,0.448,1,1
      S20.552,19,20,19z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  page: {
    element: [
      <path
        d="M14,2H6C4.9,2,4.01,2.9,4.01,4L4,20c0,1.1,0.89,2,1.99,2H18c1.1,0,2-0.9,2-2V8L14,2z M6,20V4h7v4c0,0.552,0.448,1,1,1h4v11
      H6z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  plan: {
    element: [
      <path
        d="M20.5,3l-0.16,0.03L15,5.1L9,3L3.36,4.9C3.15,4.97,3,5.15,3,5.38V20.5C3,20.78,3.22,21,3.5,21l0.16-0.03L9,18.9l6,2.1
      l5.64-1.9c0.21-0.07,0.36-0.25,0.36-0.48V3.5C21,3.22,20.78,3,20.5,3z M10,5.47l4,1.4v11.66l-4-1.4V5.47z M5,6.46l3-1.01v11.7
      l-3,1.16V6.46z M19,17.54l-3,1.01V6.86l3-1.16V17.54z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
  videos: {
    element: [
      <path d="M10 16.5l6-4.5-6-4.5v9zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z" />,
    ],
    viewBox: '0 0 24 24',
  },
  welcome: {
    element: [
      <path
        d="M11.99,2C6.47,2,2,6.48,2,12s4.47,10,9.99,10C17.52,22,22,17.52,22,12S17.52,2,11.99,2z M18.92,8h-2.95
      c-0.32-1.25-0.78-2.45-1.38-3.56C16.43,5.07,17.96,6.35,18.92,8z M12,4.04c0.83,1.2,1.48,2.53,1.91,3.96h-3.82
      C10.52,6.57,11.17,5.24,12,4.04z M4.26,14C4.1,13.36,4,12.69,4,12s0.1-1.36,0.26-2h3.38c-0.08,0.66-0.14,1.32-0.14,2
      s0.06,1.34,0.14,2H4.26z M5.08,16h2.95c0.32,1.25,0.78,2.45,1.38,3.56C7.57,18.93,6.04,17.66,5.08,16z M8.03,8H5.08
      c0.96-1.66,2.49-2.93,4.33-3.56C8.81,5.55,8.35,6.75,8.03,8z M12,19.96c-0.83-1.2-1.48-2.53-1.91-3.96h3.82
      C13.48,17.43,12.83,18.76,12,19.96z M14.34,14H9.66c-0.09-0.66-0.16-1.32-0.16-2s0.07-1.35,0.16-2h4.68c0.09,0.65,0.16,1.32,0.16,2
      S14.43,13.34,14.34,14z M14.59,19.56c0.6-1.11,1.06-2.31,1.38-3.56h2.95C17.96,17.65,16.43,18.93,14.59,19.56z M16.36,14
      c0.08-0.66,0.14-1.32,0.14-2s-0.06-1.34-0.14-2h3.38C19.9,10.64,20,11.31,20,12s-0.1,1.36-0.26,2H16.36z"
      />,
    ],
    viewBox: '0 0 24 24',
  },
};

export default {
  facebook: facebookIcons,
  google: googleIcons,
  intellum: intellumIcons,
};
